'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var freeze = Object.freeze || function (x) {
  return x;
};

var html = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']); // SVG

var svg = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'audio', 'canvas', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'video', 'view', 'vkern']);
var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);
var mathMl = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);
var text = freeze(['#text']);

var freeze$1 = Object.freeze || function (x) {
  return x;
};

var html$1 = freeze$1(['accept', 'action', 'align', 'alt', 'autocomplete', 'background', 'bgcolor', 'border', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'coords', 'crossorigin', 'datetime', 'default', 'dir', 'disabled', 'download', 'enctype', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'integrity', 'ismap', 'label', 'lang', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'multiple', 'name', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns']);
var svg$1 = freeze$1(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'tabindex', 'targetx', 'targety', 'transform', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
var mathMl$1 = freeze$1(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
var xml = freeze$1(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

var hasOwnProperty = Object.hasOwnProperty,
    setPrototypeOf = Object.setPrototypeOf;

var _ref = typeof Reflect !== 'undefined' && Reflect,
    apply = _ref.apply;

if (!apply) {
  apply = function apply(fun, thisValue, args) {
    return fun.apply(thisValue, args);
  };
}
/* Add properties to a lookup table */


function addToSet(set, array) {
  if (setPrototypeOf) {
    // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    setPrototypeOf(set, null);
  }

  var l = array.length;

  while (l--) {
    var element = array[l];

    if (typeof element === 'string') {
      var lcElement = element.toLowerCase();

      if (lcElement !== element) {
        // Config presets (e.g. tags.js, attrs.js) are immutable.
        if (!Object.isFrozen(array)) {
          array[l] = lcElement;
        }

        element = lcElement;
      }
    }

    set[element] = true;
  }

  return set;
}
/* Shallow clone an object */

function clone(object) {
  var newObject = {};
  var property;

  for (property in object) {
    if (apply(hasOwnProperty, object, [property])) {
      newObject[property] = object[property];
    }
  }

  return newObject;
}

var seal = Object.seal || function (x) {
  return x;
};

var MUSTACHE_EXPR = seal(/\{\{[\s\S]*|[\s\S]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode

var ERB_EXPR = seal(/<%[\s\S]*|[\s\S]*%>/gm);
var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape

var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape

var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g // eslint-disable-line no-control-regex
);

var _ref$1 = typeof Reflect !== 'undefined' && Reflect,
    apply$1 = _ref$1.apply;

var arraySlice = Array.prototype.slice;
var freeze$2 = Object.freeze;

var getGlobal = function getGlobal() {
  return typeof window === 'undefined' ? null : window;
};

if (!apply$1) {
  apply$1 = function apply(fun, thisValue, args) {
    return fun.apply(thisValue, args);
  };
}
/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
 * @param {Document} document The document object (to determine policy name suffix)
 * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
 * are not supported).
 */


var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
  if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
    return null;
  } // Allow the callers to control the unique policy name
  // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
  // Policy creation with duplicate names throws in Trusted Types.


  var suffix = null;
  var ATTR_NAME = 'data-tt-policy-suffix';

  if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
    suffix = document.currentScript.getAttribute(ATTR_NAME);
  }

  var policyName = "dompurify" + (suffix ? "#" + suffix : '');

  try {
    return trustedTypes.createPolicy(policyName, {
      createHTML: function createHTML(html) {
        return html;
      }
    });
  } catch (error) {
    // Policy creation failed (most likely another DOMPurify script has
    // already run). Skip creating the policy, as this will only cause errors
    // if TT are enforced.
    console.warn("TrustedTypes policy " + policyName + " could not be created.");
    return null;
  }
};

function createDOMPurify(window) {
  if (window === void 0) {
    window = getGlobal();
  }

  var DOMPurify = function DOMPurify(root) {
    return createDOMPurify(root);
  };
  /**
   * Array of elements that DOMPurify removed during sanitation.
   * Empty if nothing was removed.
   */


  DOMPurify.removed = [];

  if (!window || !window.document || window.document.nodeType !== 9) {
    // Not running in a browser, provide a factory function
    // so that you can pass your own Window
    DOMPurify.isSupported = false;
    return DOMPurify;
  }

  var originalDocument = window.document;
  var useDOMParser = false;
  var removeTitle = false;
  var _window = window,
      document = _window.document;
  var _window2 = window,
      DocumentFragment = _window2.DocumentFragment,
      HTMLTemplateElement = _window2.HTMLTemplateElement,
      Node = _window2.Node,
      NodeFilter = _window2.NodeFilter,
      _window2$NamedNodeMap = _window2.NamedNodeMap,
      NamedNodeMap = _window2$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window2$NamedNodeMap,
      Text = _window2.Text,
      Comment = _window2.Comment,
      DOMParser = _window2.DOMParser,
      TrustedTypes = _window2.TrustedTypes; // As per issue #47, the web-components registry is inherited by a
  // new document created via createHTMLDocument. As per the spec
  // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
  // a new empty registry is used when creating a template contents owner
  // document, so we use that as our parent document to ensure nothing
  // is inherited.

  if (typeof HTMLTemplateElement === 'function') {
    var template = document.createElement('template');

    if (template.content && template.content.ownerDocument) {
      document = template.content.ownerDocument;
    }
  }

  var trustedTypesPolicy = _createTrustedTypesPolicy(TrustedTypes, originalDocument);

  var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
  var _document = document,
      implementation = _document.implementation,
      createNodeIterator = _document.createNodeIterator,
      getElementsByTagName = _document.getElementsByTagName,
      createDocumentFragment = _document.createDocumentFragment;
  var importNode = originalDocument.importNode;
  var hooks = {};
  /**
   * Expose whether this browser supports running the full DOMPurify.
   */

  DOMPurify.isSupported = implementation && typeof implementation.createHTMLDocument !== 'undefined' && document.documentMode !== 9;
  var MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
      ERB_EXPR$1 = ERB_EXPR,
      DATA_ATTR$1 = DATA_ATTR,
      ARIA_ATTR$1 = ARIA_ATTR,
      IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
      ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
  var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
  /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */

  /* allowed element names */

  var ALLOWED_TAGS = null;
  var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(html, svg, svgFilters, mathMl, text));
  /* Allowed attribute names */

  var ALLOWED_ATTR = null;
  var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(html$1, svg$1, mathMl$1, xml));
  /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */

  var FORBID_TAGS = null;
  /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */

  var FORBID_ATTR = null;
  /* Decide if ARIA attributes are okay */

  var ALLOW_ARIA_ATTR = true;
  /* Decide if custom data attributes are okay */

  var ALLOW_DATA_ATTR = true;
  /* Decide if unknown protocols are okay */

  var ALLOW_UNKNOWN_PROTOCOLS = false;
  /* Output should be safe for jQuery's $() factory? */

  var SAFE_FOR_JQUERY = false;
  /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */

  var SAFE_FOR_TEMPLATES = false;
  /* Decide if document with <html>... should be returned */

  var WHOLE_DOCUMENT = false;
  /* Track whether config is already set on this instance of DOMPurify. */

  var SET_CONFIG = false;
  /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */

  var FORCE_BODY = false;
  /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */

  var RETURN_DOM = false;
  /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */

  var RETURN_DOM_FRAGMENT = false;
  /* If `RETURN_DOM` or `RETURN_DOM_FRAGMENT` is enabled, decide if the returned DOM
   * `Node` is imported into the current `Document`. If this flag is not enabled the
   * `Node` will belong (its ownerDocument) to a fresh `HTMLDocument`, created by
   * DOMPurify. */

  var RETURN_DOM_IMPORT = false;
  /* Output should be free from DOM clobbering attacks? */

  var SANITIZE_DOM = true;
  /* Keep element content when removing element? */

  var KEEP_CONTENT = true;
  /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */

  var IN_PLACE = false;
  /* Allow usage of profiles like html, svg and mathMl */

  var USE_PROFILES = {};
  /* Tags to ignore content of when KEEP_CONTENT is true */

  var FORBID_CONTENTS = addToSet({}, ['audio', 'head', 'math', 'script', 'style', 'template', 'svg', 'video']);
  /* Tags that are safe for data: URIs */

  var DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image']);
  /* Attributes safe for values like "javascript:" */

  var URI_SAFE_ATTRIBUTES = null;
  var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'summary', 'title', 'value', 'style', 'xmlns']);
  /* Keep a reference to config to pass to hooks */

  var CONFIG = null;
  /* Ideally, do not touch anything below this line */

  /* ______________________________________________ */

  var formElement = document.createElement('form');
  /**
   * _parseConfig
   *
   * @param  {Object} cfg optional config literal
   */
  // eslint-disable-next-line complexity

  var _parseConfig = function _parseConfig(cfg) {
    if (CONFIG && CONFIG === cfg) {
      return;
    }
    /* Shield configuration object from tampering */


    if (!cfg || typeof cfg !== 'object') {
      cfg = {};
    }
    /* Set configuration parameters */


    ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
    ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
    URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet({}, cfg.ADD_URI_SAFE_ATTR) : DEFAULT_URI_SAFE_ATTRIBUTES;
    FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS) : {};
    FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR) : {};
    USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
    ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true

    ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true

    ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false

    SAFE_FOR_JQUERY = cfg.SAFE_FOR_JQUERY || false; // Default false

    SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false

    WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false

    RETURN_DOM = cfg.RETURN_DOM || false; // Default false

    RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false

    RETURN_DOM_IMPORT = cfg.RETURN_DOM_IMPORT || false; // Default false

    FORCE_BODY = cfg.FORCE_BODY || false; // Default false

    SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true

    KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true

    IN_PLACE = cfg.IN_PLACE || false; // Default false

    IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;

    if (SAFE_FOR_TEMPLATES) {
      ALLOW_DATA_ATTR = false;
    }

    if (RETURN_DOM_FRAGMENT) {
      RETURN_DOM = true;
    }
    /* Parse profile info */


    if (USE_PROFILES) {
      ALLOWED_TAGS = addToSet({}, [].concat(text));
      ALLOWED_ATTR = [];

      if (USE_PROFILES.html === true) {
        addToSet(ALLOWED_TAGS, html);
        addToSet(ALLOWED_ATTR, html$1);
      }

      if (USE_PROFILES.svg === true) {
        addToSet(ALLOWED_TAGS, svg);
        addToSet(ALLOWED_ATTR, svg$1);
        addToSet(ALLOWED_ATTR, xml);
      }

      if (USE_PROFILES.svgFilters === true) {
        addToSet(ALLOWED_TAGS, svgFilters);
        addToSet(ALLOWED_ATTR, svg$1);
        addToSet(ALLOWED_ATTR, xml);
      }

      if (USE_PROFILES.mathMl === true) {
        addToSet(ALLOWED_TAGS, mathMl);
        addToSet(ALLOWED_ATTR, mathMl$1);
        addToSet(ALLOWED_ATTR, xml);
      }
    }
    /* Merge configuration parameters */


    if (cfg.ADD_TAGS) {
      if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
        ALLOWED_TAGS = clone(ALLOWED_TAGS);
      }

      addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
    }

    if (cfg.ADD_ATTR) {
      if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
        ALLOWED_ATTR = clone(ALLOWED_ATTR);
      }

      addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
    }

    if (cfg.ADD_URI_SAFE_ATTR) {
      addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
    }
    /* Add #text in case KEEP_CONTENT is set to true */


    if (KEEP_CONTENT) {
      ALLOWED_TAGS['#text'] = true;
    }
    /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */


    if (WHOLE_DOCUMENT) {
      addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
    }
    /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286 */


    if (ALLOWED_TAGS.table) {
      addToSet(ALLOWED_TAGS, ['tbody']);
    } // Prevent further manipulation of configuration.
    // Not available in IE8, Safari 5, etc.


    if (freeze$2) {
      freeze$2(cfg);
    }

    CONFIG = cfg;
  };
  /**
   * _forceRemove
   *
   * @param  {Node} node a DOM node
   */


  var _forceRemove = function _forceRemove(node) {
    DOMPurify.removed.push({
      element: node
    });

    try {
      node.parentNode.removeChild(node);
    } catch (error) {
      node.outerHTML = emptyHTML;
    }
  };
  /**
   * _removeAttribute
   *
   * @param  {String} name an Attribute name
   * @param  {Node} node a DOM node
   */


  var _removeAttribute = function _removeAttribute(name, node) {
    try {
      DOMPurify.removed.push({
        attribute: node.getAttributeNode(name),
        from: node
      });
    } catch (error) {
      DOMPurify.removed.push({
        attribute: null,
        from: node
      });
    }

    node.removeAttribute(name);
  };
  /**
   * _initDocument
   *
   * @param  {String} dirty a string of dirty markup
   * @return {Document} a DOM, filled with the dirty markup
   */


  var _initDocument = function _initDocument(dirty) {
    /* Create a HTML document */
    var doc;
    var leadingWhitespace;

    if (FORCE_BODY) {
      dirty = "<remove></remove>" + dirty;
    } else {
      /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
      var matches = dirty.match(/^[\s]+/);
      leadingWhitespace = matches && matches[0];

      if (leadingWhitespace) {
        dirty = dirty.slice(leadingWhitespace.length);
      }
    }
    /* Use DOMParser to workaround Firefox bug (see comment below) */


    if (useDOMParser) {
      try {
        doc = new DOMParser().parseFromString(dirty, 'text/html');
      } catch (error) {}
    }
    /* Remove title to fix a mXSS bug in older MS Edge */


    if (removeTitle) {
      addToSet(FORBID_TAGS, ['title']);
    }
    /* Otherwise use createHTMLDocument, because DOMParser is unsafe in
    Safari (see comment below) */


    if (!doc || !doc.documentElement) {
      doc = implementation.createHTMLDocument('');
      var _doc = doc,
          body = _doc.body;
      body.parentNode.removeChild(body.parentNode.firstElementChild);
      body.outerHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
    }

    if (leadingWhitespace) {
      doc.body.insertBefore(document.createTextNode(leadingWhitespace), doc.body.childNodes[0] || null);
    }
    /* Work on whole document or just its body */


    return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
  }; // Firefox uses a different parser for innerHTML rather than
  // DOMParser (see https://bugzilla.mozilla.org/show_bug.cgi?id=1205631)
  // which means that you *must* use DOMParser, otherwise the output may
  // not be safe if used in a document.write context later.
  //
  // So we feature detect the Firefox bug and use the DOMParser if necessary.
  //
  // MS Edge, in older versions, is affected by an mXSS behavior. The second
  // check tests for the behavior and fixes it if necessary.


  if (DOMPurify.isSupported) {
    (function () {
      try {
        var doc = _initDocument('<svg><p><style><img src="</style><img src=x onerror=1//">');

        if (doc.querySelector('svg img')) {
          useDOMParser = true;
        }
      } catch (error) {}
    })();

    (function () {
      try {
        var doc = _initDocument('<x/><title>&lt;/title&gt;&lt;img&gt;');

        if (doc.querySelector('title').innerHTML.match(/<\/title/)) {
          removeTitle = true;
        }
      } catch (error) {}
    })();
  }
  /**
   * _createIterator
   *
   * @param  {Document} root document/fragment to create iterator for
   * @return {Iterator} iterator instance
   */


  var _createIterator = function _createIterator(root) {
    return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, function () {
      return NodeFilter.FILTER_ACCEPT;
    }, false);
  };
  /**
   * _isClobbered
   *
   * @param  {Node} elm element to check for clobbering attacks
   * @return {Boolean} true if clobbered, false if safe
   */


  var _isClobbered = function _isClobbered(elm) {
    if (elm instanceof Text || elm instanceof Comment) {
      return false;
    }

    if (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function') {
      return true;
    }

    return false;
  };
  /**
   * _isNode
   *
   * @param  {Node} obj object to check whether it's a DOM node
   * @return {Boolean} true is object is a DOM node
   */


  var _isNode = function _isNode(obj) {
    return typeof Node === 'object' ? obj instanceof Node : obj && typeof obj === 'object' && typeof obj.nodeType === 'number' && typeof obj.nodeName === 'string';
  };
  /**
   * _executeHook
   * Execute user configurable hooks
   *
   * @param  {String} entryPoint  Name of the hook's entry point
   * @param  {Node} currentNode node to work on with the hook
   * @param  {Object} data additional hook parameters
   */


  var _executeHook = function _executeHook(entryPoint, currentNode, data) {
    if (!hooks[entryPoint]) {
      return;
    }

    hooks[entryPoint].forEach(function (hook) {
      hook.call(DOMPurify, currentNode, data, CONFIG);
    });
  };
  /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   *
   * @param   {Node} currentNode to check for permission to exist
   * @return  {Boolean} true if node was killed, false if left alive
   */
  // eslint-disable-next-line complexity


  var _sanitizeElements = function _sanitizeElements(currentNode) {
    var content;
    /* Execute a hook if present */

    _executeHook('beforeSanitizeElements', currentNode, null);
    /* Check if element is clobbered or can clobber */


    if (_isClobbered(currentNode)) {
      _forceRemove(currentNode);

      return true;
    }
    /* Now let's check the element's type and name */


    var tagName = currentNode.nodeName.toLowerCase();
    /* Execute a hook if present */

    _executeHook('uponSanitizeElement', currentNode, {
      tagName: tagName,
      allowedTags: ALLOWED_TAGS
    });
    /* Remove element if anything forbids its presence */


    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
      /* Keep content except for black-listed elements */
      if (KEEP_CONTENT && !FORBID_CONTENTS[tagName] && typeof currentNode.insertAdjacentHTML === 'function') {
        try {
          var htmlToInsert = currentNode.innerHTML;
          currentNode.insertAdjacentHTML('AfterEnd', trustedTypesPolicy ? trustedTypesPolicy.createHTML(htmlToInsert) : htmlToInsert);
        } catch (error) {}
      }

      _forceRemove(currentNode);

      return true;
    }
    /* Remove in case a noscript/noembed XSS is suspected */


    if (tagName === 'noscript' && currentNode.innerHTML.match(/<\/noscript/i)) {
      _forceRemove(currentNode);

      return true;
    }

    if (tagName === 'noembed' && currentNode.innerHTML.match(/<\/noembed/i)) {
      _forceRemove(currentNode);

      return true;
    }
    /* Convert markup to cover jQuery behavior */


    if (SAFE_FOR_JQUERY && !currentNode.firstElementChild && (!currentNode.content || !currentNode.content.firstElementChild) && /</g.test(currentNode.textContent)) {
      DOMPurify.removed.push({
        element: currentNode.cloneNode()
      });

      if (currentNode.innerHTML) {
        currentNode.innerHTML = currentNode.innerHTML.replace(/</g, '&lt;');
      } else {
        currentNode.innerHTML = currentNode.textContent.replace(/</g, '&lt;');
      }
    }
    /* Sanitize element content to be template-safe */


    if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
      /* Get the element's text content */
      content = currentNode.textContent;
      content = content.replace(MUSTACHE_EXPR$1, ' ');
      content = content.replace(ERB_EXPR$1, ' ');

      if (currentNode.textContent !== content) {
        DOMPurify.removed.push({
          element: currentNode.cloneNode()
        });
        currentNode.textContent = content;
      }
    }
    /* Execute a hook if present */


    _executeHook('afterSanitizeElements', currentNode, null);

    return false;
  };
  /**
   * _isValidAttribute
   *
   * @param  {string} lcTag Lowercase tag name of containing element.
   * @param  {string} lcName Lowercase attribute name.
   * @param  {string} value Attribute value.
   * @return {Boolean} Returns true if `value` is valid, otherwise false.
   */
  // eslint-disable-next-line complexity


  var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
    /* Make sure attribute cannot clobber */
    if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
      return false;
    }
    /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */


    if (ALLOW_DATA_ATTR && DATA_ATTR$1.test(lcName)) ; else if (ALLOW_ARIA_ATTR && ARIA_ATTR$1.test(lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
      return false;
      /* Check value is safe. First, is attr inert? If so, is safe */
    } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (IS_ALLOWED_URI$1.test(value.replace(ATTR_WHITESPACE$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href') && lcTag !== 'script' && value.indexOf('data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !IS_SCRIPT_OR_DATA$1.test(value.replace(ATTR_WHITESPACE$1, ''))) ; else if (!value) ; else {
      return false;
    }

    return true;
  };
  /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param  {Node} currentNode to sanitize
   */


  var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
    var attr;
    var value;
    var lcName;
    var idAttr;
    var l;
    /* Execute a hook if present */

    _executeHook('beforeSanitizeAttributes', currentNode, null);

    var attributes = currentNode.attributes;
    /* Check if we have attributes; if not we might have a text node */

    if (!attributes) {
      return;
    }

    var hookEvent = {
      attrName: '',
      attrValue: '',
      keepAttr: true,
      allowedAttributes: ALLOWED_ATTR
    };
    l = attributes.length;
    /* Go backwards over all attributes; safely remove bad ones */

    while (l--) {
      attr = attributes[l];
      var _attr = attr,
          name = _attr.name,
          namespaceURI = _attr.namespaceURI;
      value = attr.value.trim();
      lcName = name.toLowerCase();
      /* Execute a hook if present */

      hookEvent.attrName = lcName;
      hookEvent.attrValue = value;
      hookEvent.keepAttr = true;

      _executeHook('uponSanitizeAttribute', currentNode, hookEvent);

      value = hookEvent.attrValue;
      /* Remove attribute */
      // Safari (iOS + Mac), last tested v8.0.5, crashes if you try to
      // remove a "name" attribute from an <img> tag that has an "id"
      // attribute at the time.

      if (lcName === 'name' && currentNode.nodeName === 'IMG' && attributes.id) {
        idAttr = attributes.id;
        attributes = apply$1(arraySlice, attributes, []);

        _removeAttribute('id', currentNode);

        _removeAttribute(name, currentNode);

        if (attributes.indexOf(idAttr) > l) {
          currentNode.setAttribute('id', idAttr.value);
        }
      } else if ( // This works around a bug in Safari, where input[type=file]
      // cannot be dynamically set after type has been removed
      currentNode.nodeName === 'INPUT' && lcName === 'type' && value === 'file' && hookEvent.keepAttr && (ALLOWED_ATTR[lcName] || !FORBID_ATTR[lcName])) {
        continue;
      } else {
        // This avoids a crash in Safari v9.0 with double-ids.
        // The trick is to first set the id to be empty and then to
        // remove the attribute
        if (name === 'id') {
          currentNode.setAttribute(name, '');
        }

        _removeAttribute(name, currentNode);
      }
      /* Did the hooks approve of the attribute? */


      if (!hookEvent.keepAttr) {
        continue;
      }
      /* Sanitize attribute content to be template-safe */


      if (SAFE_FOR_TEMPLATES) {
        value = value.replace(MUSTACHE_EXPR$1, ' ');
        value = value.replace(ERB_EXPR$1, ' ');
      }
      /* Is `value` valid for this attribute? */


      var lcTag = currentNode.nodeName.toLowerCase();

      if (!_isValidAttribute(lcTag, lcName, value)) {
        continue;
      }
      /* Handle invalid data-* attribute set by try-catching it */


      try {
        if (namespaceURI) {
          currentNode.setAttributeNS(namespaceURI, name, value);
        } else {
          /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
          currentNode.setAttribute(name, value);
        }

        DOMPurify.removed.pop();
      } catch (error) {}
    }
    /* Execute a hook if present */


    _executeHook('afterSanitizeAttributes', currentNode, null);
  };
  /**
   * _sanitizeShadowDOM
   *
   * @param  {DocumentFragment} fragment to iterate over recursively
   */


  var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
    var shadowNode;

    var shadowIterator = _createIterator(fragment);
    /* Execute a hook if present */


    _executeHook('beforeSanitizeShadowDOM', fragment, null);

    while (shadowNode = shadowIterator.nextNode()) {
      /* Execute a hook if present */
      _executeHook('uponSanitizeShadowNode', shadowNode, null);
      /* Sanitize tags and elements */


      if (_sanitizeElements(shadowNode)) {
        continue;
      }
      /* Deep shadow DOM detected */


      if (shadowNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(shadowNode.content);
      }
      /* Check attributes, sanitize if necessary */


      _sanitizeAttributes(shadowNode);
    }
    /* Execute a hook if present */


    _executeHook('afterSanitizeShadowDOM', fragment, null);
  };
  /**
   * Sanitize
   * Public method providing core sanitation functionality
   *
   * @param {String|Node} dirty string or DOM node
   * @param {Object} configuration object
   */
  // eslint-disable-next-line complexity


  DOMPurify.sanitize = function (dirty, cfg) {
    var body;
    var importedNode;
    var currentNode;
    var oldNode;
    var returnNode;
    /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */

    if (!dirty) {
      dirty = '<!-->';
    }
    /* Stringify, in case dirty is an object */


    if (typeof dirty !== 'string' && !_isNode(dirty)) {
      // eslint-disable-next-line no-negated-condition
      if (typeof dirty.toString !== 'function') {
        throw new TypeError('toString is not a function');
      } else {
        dirty = dirty.toString();

        if (typeof dirty !== 'string') {
          throw new TypeError('dirty is not a string, aborting');
        }
      }
    }
    /* Check we can run. Otherwise fall back or ignore */


    if (!DOMPurify.isSupported) {
      if (typeof window.toStaticHTML === 'object' || typeof window.toStaticHTML === 'function') {
        if (typeof dirty === 'string') {
          return window.toStaticHTML(dirty);
        }

        if (_isNode(dirty)) {
          return window.toStaticHTML(dirty.outerHTML);
        }
      }

      return dirty;
    }
    /* Assign config vars */


    if (!SET_CONFIG) {
      _parseConfig(cfg);
    }
    /* Clean up removed elements */


    DOMPurify.removed = [];

    if (IN_PLACE) ; else if (dirty instanceof Node) {
      /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */
      body = _initDocument('<!-->');
      importedNode = body.ownerDocument.importNode(dirty, true);

      if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
        /* Node is already a body, use as is */
        body = importedNode;
      } else if (importedNode.nodeName === 'HTML') {
        body = importedNode;
      } else {
        // eslint-disable-next-line unicorn/prefer-node-append
        body.appendChild(importedNode);
      }
    } else {
      /* Exit directly if we have nothing to do */
      if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && dirty.indexOf('<') === -1) {
        return trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      }
      /* Initialize the document to work on */


      body = _initDocument(dirty);
      /* Check we have a DOM node from the data */

      if (!body) {
        return RETURN_DOM ? null : emptyHTML;
      }
    }
    /* Remove first element node (ours) if FORCE_BODY is set */


    if (body && FORCE_BODY) {
      _forceRemove(body.firstChild);
    }
    /* Get node iterator */


    var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
    /* Now start iterating over the created document */


    while (currentNode = nodeIterator.nextNode()) {
      /* Fix IE's strange behavior with manipulated textNodes #89 */
      if (currentNode.nodeType === 3 && currentNode === oldNode) {
        continue;
      }
      /* Sanitize tags and elements */


      if (_sanitizeElements(currentNode)) {
        continue;
      }
      /* Shadow DOM detected, sanitize it */


      if (currentNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(currentNode.content);
      }
      /* Check attributes, sanitize if necessary */


      _sanitizeAttributes(currentNode);

      oldNode = currentNode;
    }

    oldNode = null;
    /* If we sanitized `dirty` in-place, return it. */

    if (IN_PLACE) {
      return dirty;
    }
    /* Return sanitized string or DOM */


    if (RETURN_DOM) {
      if (RETURN_DOM_FRAGMENT) {
        returnNode = createDocumentFragment.call(body.ownerDocument);

        while (body.firstChild) {
          // eslint-disable-next-line unicorn/prefer-node-append
          returnNode.appendChild(body.firstChild);
        }
      } else {
        returnNode = body;
      }

      if (RETURN_DOM_IMPORT) {
        /* AdoptNode() is not used because internal state is not reset
               (e.g. the past names map of a HTMLFormElement), this is safe
               in theory but we would rather not risk another attack vector.
               The state that is cloned by importNode() is explicitly defined
               by the specs. */
        returnNode = importNode.call(originalDocument, returnNode, true);
      }

      return returnNode;
    }

    var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
    /* Sanitize final string template-safe */

    if (SAFE_FOR_TEMPLATES) {
      serializedHTML = serializedHTML.replace(MUSTACHE_EXPR$1, ' ');
      serializedHTML = serializedHTML.replace(ERB_EXPR$1, ' ');
    }

    return trustedTypesPolicy ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
  };
  /**
   * Public method to set the configuration once
   * setConfig
   *
   * @param {Object} cfg configuration object
   */


  DOMPurify.setConfig = function (cfg) {
    _parseConfig(cfg);

    SET_CONFIG = true;
  };
  /**
   * Public method to remove the configuration
   * clearConfig
   *
   */


  DOMPurify.clearConfig = function () {
    CONFIG = null;
    SET_CONFIG = false;
  };
  /**
   * Public method to check if an attribute value is valid.
   * Uses last set config, if any. Otherwise, uses config defaults.
   * isValidAttribute
   *
   * @param  {string} tag Tag name of containing element.
   * @param  {string} attr Attribute name.
   * @param  {string} value Attribute value.
   * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
   */


  DOMPurify.isValidAttribute = function (tag, attr, value) {
    /* Initialize shared config vars if necessary. */
    if (!CONFIG) {
      _parseConfig({});
    }

    var lcTag = tag.toLowerCase();
    var lcName = attr.toLowerCase();
    return _isValidAttribute(lcTag, lcName, value);
  };
  /**
   * AddHook
   * Public method to add DOMPurify hooks
   *
   * @param {String} entryPoint entry point for the hook to add
   * @param {Function} hookFunction function to execute
   */


  DOMPurify.addHook = function (entryPoint, hookFunction) {
    if (typeof hookFunction !== 'function') {
      return;
    }

    hooks[entryPoint] = hooks[entryPoint] || [];
    hooks[entryPoint].push(hookFunction);
  };
  /**
   * RemoveHook
   * Public method to remove a DOMPurify hook at a given entryPoint
   * (pops it from the stack of hooks if more are present)
   *
   * @param {String} entryPoint entry point for the hook to remove
   */


  DOMPurify.removeHook = function (entryPoint) {
    if (hooks[entryPoint]) {
      hooks[entryPoint].pop();
    }
  };
  /**
   * RemoveHooks
   * Public method to remove all DOMPurify hooks at a given entryPoint
   *
   * @param  {String} entryPoint entry point for the hooks to remove
   */


  DOMPurify.removeHooks = function (entryPoint) {
    if (hooks[entryPoint]) {
      hooks[entryPoint] = [];
    }
  };
  /**
   * RemoveAllHooks
   * Public method to remove all DOMPurify hooks
   *
   */


  DOMPurify.removeAllHooks = function () {
    hooks = {};
  };

  return DOMPurify;
}

var purify = createDOMPurify().sanitize;

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  -webkit-font-smoothing:antialiased;\n  box-sizing: border-box;\n  line-height: 1.625;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font: inherit;\n  vertical-align: baseline;\n  font-size: 100%;\n  display: block;\n\n  div, span, h3, h4, h6, p, a, em, img, strong, i, label, ol, ul, li, section {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    vertical-align: baseline;\n    box-sizing: border-box;\n  }\n\n  h3 {\n    line-height: 1.4167;\n    margin: 0.5em 0;\n  }\n\n  h4 {\n    line-height: 1.3636;\n    margin: 0.5em 0;\n  }\n\n  h6 {\n    font-size: 1rem;\n    line-height: 1.375;\n    font-weight: 700;\n    margin: 0.5em 0;\n  }\n\n  ul, ol {\n    list-style: none;\n  }\n\n  p {\n    font-size: 1rem;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n\n  img {\n    max-width: 100%;\n  }\n\n  a {\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n\n  .hsg-icon {\n    &::before {\n      font-family: \"hsg-icons\";\n      -webkit-font-smoothing: antialiased;\n      font-style: normal;\n      font-variant: normal;\n      font-weight: normal;\n      text-decoration: none;\n      text-transform: none;\n    }\n\n    &-facebook::before {\n      content: \"\\E01C\";\n    }\n\n    &-instagram::before {\n      content: \"\\E025\";\n    }\n\n    &-youtube::before {\n      content: \"\\E040\";\n    }\n\n    &-twitter::before {\n      content: \"\\E03C\";\n    }\n\n    &-linkedin::before {\n      content: \"\\E028\";\n    }\n\n    &-medium::before {\n      content: \"\\E02A\";\n    }\n  }\n"], ["\n  -webkit-font-smoothing:antialiased;\n  box-sizing: border-box;\n  line-height: 1.625;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font: inherit;\n  vertical-align: baseline;\n  font-size: 100%;\n  display: block;\n\n  div, span, h3, h4, h6, p, a, em, img, strong, i, label, ol, ul, li, section {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    vertical-align: baseline;\n    box-sizing: border-box;\n  }\n\n  h3 {\n    line-height: 1.4167;\n    margin: 0.5em 0;\n  }\n\n  h4 {\n    line-height: 1.3636;\n    margin: 0.5em 0;\n  }\n\n  h6 {\n    font-size: 1rem;\n    line-height: 1.375;\n    font-weight: 700;\n    margin: 0.5em 0;\n  }\n\n  ul, ol {\n    list-style: none;\n  }\n\n  p {\n    font-size: 1rem;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n\n  img {\n    max-width: 100%;\n  }\n\n  a {\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n\n  .hsg-icon {\n    &::before {\n      font-family: \"hsg-icons\";\n      -webkit-font-smoothing: antialiased;\n      font-style: normal;\n      font-variant: normal;\n      font-weight: normal;\n      text-decoration: none;\n      text-transform: none;\n    }\n\n    &-facebook::before {\n      content: \"\\\\E01C\";\n    }\n\n    &-instagram::before {\n      content: \"\\\\E025\";\n    }\n\n    &-youtube::before {\n      content: \"\\\\E040\";\n    }\n\n    &-twitter::before {\n      content: \"\\\\E03C\";\n    }\n\n    &-linkedin::before {\n      content: \"\\\\E028\";\n    }\n\n    &-medium::before {\n      content: \"\\\\E02A\";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var StyledBase = styled__default.section(_templateObject());

var SVGIcons =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SVGIcons, _React$Component);

  function SVGIcons() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SVGIcons.prototype;

  _proto.render = function render() {
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        display: 'none'
      }
    }, React.createElement("symbol", {
      viewBox: "0 0 60 23.7",
      id: "add-on-label"
    }, React.createElement("path", {
      fill: "#CECECE",
      d: "M60 1.4c.1-.3-.1-.6-.4-.6h-.4l-3.4 10.5v.3l3.4 10.7c.1.3-.1.6-.4.6H.8v.3c0 .2.2.4.4.4h58.3c.3 0 .5-.3.4-.6l-3.4-10.7V12L60 1.4z"
    }), React.createElement("path", {
      fill: "#F7751F",
      d: "M11.3 12.4h2l-1-3z"
    }), React.createElement("path", {
      fill: "#F7751F",
      d: "M4.1 22.9h54.7c.3 0 .5-.3.4-.6l-3.4-10.7v-.3L59.2.8l.1-.2c0-.3-.2-.6-.5-.6H4.1v22.9zm10.1-7.8l-.4-1.1h-3l-.4 1.1H8.3l2.8-7.3h2.4l2.8 7.3h-2.1zm5.7 0h-3.1V7.8h3.1c2.3 0 4 1.4 4 3.7s-1.8 3.6-4 3.6zm7.9 0h-3.1V7.8h3.1c2.3 0 4 1.4 4 3.7s-1.7 3.6-4 3.6zm7-3.1h-2.1v-1.1h2.1V12zm4.8 3.2c-2.2 0-3.9-1.6-3.9-3.8s1.7-3.8 3.9-3.8 3.9 1.6 3.9 3.8-1.7 3.8-3.9 3.8zm11.6-.1h-1.8l-3.1-4.4v4.4h-1.9V7.8h1.9l3 4.2V7.8h1.9v7.3z"
    }), React.createElement("path", {
      fill: "#F7751F",
      d: "M19.9 9.4h-1.2v4h1.2c1.3 0 2-.9 2-2s-.7-2-2-2zM39.6 9.3c-1.2 0-2 .9-2 2.1 0 1.2.8 2.1 2 2.1s2-.9 2-2.1c0-1.1-.8-2.1-2-2.1zM27.8 9.4h-1.2v4h1.2c1.3 0 2-.9 2-2 .1-1.1-.6-2-2-2z"
    }), React.createElement("path", {
      fill: "#3B3F3F",
      d: "M4.1 0H.4C.2 0 0 .2 0 .4v22c0 .2.2.4.4.4H4V0z"
    }), React.createElement("path", {
      fill: "#FFF",
      d: "M11.1 7.8l-2.8 7.3h2.1l.4-1.1h3l.4 1.1h2.1l-2.8-7.3h-2.4zm.2 4.6l1-3 1 3h-2zM19.8 7.8h-3.1v7.3h3.1c2.3 0 4-1.4 4-3.7s-1.7-3.6-4-3.6zm0 5.7h-1.2v-4h1.2c1.3 0 2 .9 2 2 .1 1-.7 2-2 2zM27.8 7.8h-3.1v7.3h3.1c2.3 0 4-1.4 4-3.7s-1.7-3.6-4-3.6zm0 5.7h-1.2v-4h1.2c1.3 0 2 .9 2 2 .1 1-.7 2-2 2zM32.7 10.9h2.1V12h-2.1zM39.6 7.7c-2.2 0-3.9 1.6-3.9 3.8s1.7 3.8 3.9 3.8 3.9-1.6 3.9-3.8-1.7-3.8-3.9-3.8zm0 5.9c-1.2 0-2-.9-2-2.1 0-1.2.8-2.1 2-2.1s2 .9 2 2.1c0 1.1-.8 2.1-2 2.1zM49.3 12l-2.9-4.2h-2v7.3h1.9v-4.4l3.1 4.4h1.8V7.8h-1.9z"
    })), React.createElement("symbol", {
      viewBox: "0 0 20 20",
      id: "facebook-icon"
    }, React.createElement("path", {
      fill: "#FFF",
      d: "M18.9 0H1.1C.5 0 0 .5 0 1.1v17.8c0 .6.5 1.1 1.1 1.1h9.6v-7.7H8.1v-3h2.6V7c0-2.6 1.6-4 3.9-4 1.1 0 2.1.1 2.3.1v2.7h-1.6c-1.3 0-1.5.6-1.5 1.5v1.9h3l-.4 3h-2.6V20h5.1c.6 0 1.1-.5 1.1-1.1V1.1c0-.6-.5-1.1-1.1-1.1z"
    })), React.createElement("symbol", {
      viewBox: "0 0 18 18",
      id: "grey-search-icon"
    }, React.createElement("circle", {
      fill: "none",
      cx: "7.5",
      cy: "7.5",
      r: "4"
    }), React.createElement("path", {
      fill: "#555",
      d: "M7.5 13.5c1.3 0 2.5-.4 3.5-1.1l3.8 3.8c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L12.4 11c.7-1 1.1-2.2 1.1-3.5 0-3.3-2.7-6-6-6s-6 2.7-6 6 2.7 6 6 6zm0-10c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4z"
    })), React.createElement("symbol", {
      viewBox: "0 0 75.9 22",
      id: "hubspot-grey-logo-footer"
    }, React.createElement("g", {
      fill: "#B3B3B3"
    }, React.createElement("path", {
      d: "M8.2 10H2.6V4.1H0v14.4h2.6v-6h5.6v6h2.7V4.1H8.2zM19.3 13.8c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2V7.6h-2.5v6.2c0 2.6 2.1 4.7 4.7 4.7s4.7-2.1 4.7-4.7V7.6h-2.5v6.2zM28.8 7.7c-1.2 0-2.1.4-3 1.2V4.1h-2.5v8.8c0 3.3 2.4 5.6 5.1 5.6 3 0 5.6-2.3 5.6-5.4s-2.4-5.4-5.2-5.4zm0 8.5c-1.7 0-3-1.4-3-3.1s1.3-3.1 3-3.1c1.4 0 2.8 1.4 2.8 3.1 0 1.7-1.3 3.1-2.8 3.1zM38.2 8.3c0-1.3.8-1.7 1.8-1.7.7 0 1.7.6 2.4 1.2L44 6c-.8-1.1-2.5-1.9-3.9-1.9-2.7 0-4.7 1.6-4.7 4.2 0 4.9 6 3.3 6 6.1 0 .8-.8 1.6-1.8 1.6-1.5 0-2-.7-2.6-1.5l-1.8 1.9c1.2 1.4 2.6 2.1 4.3 2.1 2.6 0 4.7-1.6 4.7-4.1 0-5.4-6-3.7-6-6.1zM50.9 7.5c-2.7 0-5.1 2.3-5.1 5.6V22h2.5v-4.8c.8.8 1.7 1.2 3 1.2 2.8 0 5.2-2.3 5.2-5.4 0-3.1-2.7-5.5-5.6-5.5zm.4 8.6c-1.7 0-3-1.4-3-3.1s1.3-3.1 3-3.1c1.4 0 2.8 1.4 2.8 3.1 0 1.6-1.4 3.1-2.8 3.1zM75 16.2c-1.5 0-1.9-.6-1.9-1.6v-4.4h2.3V8h-2.3V5.1l-2.5 1.1v8.9c0 2.3 1.6 3.4 3.7 3.4.3 0 .8 0 1-.1l.6-2.3c-.3.1-.6.1-.9.1z"
    }), React.createElement("path", {
      d: "M68.4 10.3c-.5-.8-1.2-1.5-2-2-.6-.4-1.3-.6-2-.7V5c.7-.3 1.2-1 1.2-1.8 0-1.1-.9-2-2-2s-2 .9-2 2c-.1.8.4 1.5 1.1 1.8v2.6c-.7.1-1.2.3-1.8.6-1.1-.9-4.9-3.7-7.1-5.4.1-.2.1-.4.1-.6 0-1.2-1-2.2-2.2-2.2s-2.2 1-2.2 2.2 1 2.2 2.2 2.2c.4 0 .8-.1 1.1-.3l.5.4 6.4 4.6c-.3.3-.6.7-.9 1.1-.5.8-.8 1.7-.8 2.7v.2c0 .7.1 1.3.3 1.9.2.5.5 1 .8 1.4L57 18.5c-.2-.1-.4-.1-.6-.1-.5 0-.9.2-1.2.5s-.5.8-.5 1.2c0 .5.2.9.5 1.2.3.3.8.5 1.2.5.5 0 .9-.2 1.2-.5s.5-.8.5-1.2c0-.2 0-.4-.1-.5l2.2-2.2c.3.2.6.4 1 .5.7.3 1.4.5 2.3.5h.2c.9 0 1.8-.2 2.6-.7.9-.5 1.5-1.1 2-1.9.5-.8.8-1.7.8-2.7 0-1-.3-1.9-.7-2.8zm-2.7 4.6c-.6.7-1.3 1-2 1h-.1c-.4 0-.9-.1-1.3-.3-.5-.2-.8-.6-1.1-1s-.5-.9-.5-1.4V13c0-.5.1-1 .3-1.4.3-.5.6-.9 1.1-1.2.4-.3.9-.4 1.5-.4.5 0 .9.1 1.4.3.4.2.8.6 1.1 1 .3.4.4.9.5 1.4v.3c-.1.7-.4 1.3-.9 1.9z"
    }))), React.createElement("symbol", {
      viewBox: "0 0 101 29.3",
      id: "hubspot-main-logo"
    }, React.createElement("path", {
      fill: "none",
      d: "M87.8 15.1c-.4-.6-.9-1-1.4-1.3-.6-.3-1.2-.4-1.8-.4h-.1c-.7 0-1.4.2-2 .6-.6.4-1.1.9-1.4 1.5-.3.6-.5 1.2-.5 1.9v.2c0 .7.2 1.3.6 1.8.4.6.9 1 1.5 1.4.6.3 1.1.4 1.7.4h.2c1 0 1.9-.5 2.7-1.4.7-.8 1-1.6 1-2.5v-.4c.1-.6-.1-1.2-.5-1.8zM68.3 13.1c-2.3 0-4 1.9-4 4.1s1.7 4.1 4 4.1c1.9 0 3.7-1.9 3.7-4.1-.1-2.2-1.8-4.1-3.7-4.1zM38.4 13.3c-2.3 0-4 1.9-4 4.1s1.7 4.1 4 4.1c1.9 0 3.7-1.9 3.7-4.1-.1-2.2-1.8-4.1-3.7-4.1z"
    }), React.createElement("path", {
      fill: "#4F4F4F",
      d: "M11 13.3H3.5V5.5H0v19.2h3.5v-8H11v8h3.5V5.5H11zM25.6 18.4c0 1.6-1.3 2.9-2.9 2.9s-2.9-1.3-2.9-2.9v-8.3h-3.3v8.3c0 3.4 2.8 6.3 6.3 6.3 3.4 0 6.3-2.8 6.3-6.3v-8.3h-3.3v8.3h-.2zM38.3 10.2c-1.7 0-2.8.5-3.9 1.6V5.5H31v11.8c0 4.4 3.2 7.4 6.8 7.4 4 0 7.5-3.1 7.5-7.2s-3.3-7.3-7-7.3zm.1 11.4c-2.3 0-4-1.9-4-4.1s1.7-4.1 4-4.1c1.9 0 3.7 1.9 3.7 4.1-.1 2.2-1.8 4.1-3.7 4.1zM50.9 11.1c0-1.7 1.1-2.2 2.4-2.2 1 0 2.3.7 3.2 1.7L58.6 8c-1.1-1.5-3.3-2.5-5.1-2.5-3.6 0-6.3 2.1-6.3 5.6 0 6.5 8 4.4 8 8.1 0 1.1-1.1 2.1-2.4 2.1-2 0-2.6-1-3.5-2l-2.4 2.5c1.6 1.9 3.5 2.9 5.8 2.9 3.4 0 6.2-2.1 6.2-5.5 0-7.2-8-5-8-8.1zM75.2 17.3c0-4.1-3.5-7.2-7.5-7.2-3.6 0-6.8 3-6.8 7.4v11.8h3.4v-6.4c1.1 1.1 2.3 1.6 3.9 1.6 3.7 0 7-3.1 7-7.2zm-6.9 4.1c-2.3 0-4-1.9-4-4.1s1.7-4.1 4-4.1c1.9 0 3.7 1.9 3.7 4.1-.1 2.2-1.8 4.1-3.7 4.1zM99.8 21.6c-2 0-2.5-.9-2.5-2.2v-5.8h3.1v-2.9h-3.1V6.8l-3.4 1.5v11.8c0 3 2.1 4.5 4.9 4.5.4 0 1 0 1.3-.1l.8-3c-.3 0-.7.1-1.1.1z"
    }), React.createElement("path", {
      fill: "#F37622",
      d: "M88.3 11.1c-.8-.5-1.7-.8-2.7-.9V6.7c1-.4 1.6-1.3 1.6-2.4 0-1.5-1.2-2.7-2.7-2.7s-2.6 1.2-2.6 2.7c0 1.1.6 2 1.6 2.4v3.5c-.9.1-1.6.4-2.4.7-1.5-1.2-6.5-5-9.5-7.2.1-.3.1-.5.1-.8 0-1.6-1.3-3-3-3-1.6 0-3 1.3-3 3 0 1.6 1.3 3 3 3 .6 0 1.1-.2 1.5-.4l.6.5 8.5 6.1c-.4.4-.8.9-1.2 1.4-.7 1.1-1.1 2.3-1.1 3.5v.3c0 .9.1 1.8.4 2.6.3.7.6 1.3 1.1 1.9l-2.8 2.8c-.2-.1-.5-.1-.8-.1-.6 0-1.2.2-1.6.7-.4.4-.7 1-.7 1.6s.2 1.2.7 1.6c.4.4 1 .7 1.6.7s1.2-.2 1.6-.7c.4-.4.7-1 .7-1.6 0-.2 0-.5-.1-.7l2.9-2.9c.4.3.8.5 1.3.7.9.4 1.9.6 3 .6h.2c1.2 0 2.4-.3 3.5-.9s2-1.5 2.7-2.5c.7-1.1 1.1-2.3 1.1-3.6v-.1c0-1.3-.3-2.5-.9-3.6-.5-1.1-1.4-2-2.6-2.7zm-.9 8.7c-.8.9-1.7 1.4-2.7 1.4h-.2c-.6 0-1.2-.1-1.7-.4-.6-.3-1.1-.8-1.5-1.4s-.6-1.2-.6-1.8v-.2c0-.7.1-1.3.5-1.9.3-.6.8-1.1 1.4-1.5s1.2-.6 2-.6h.1c.6 0 1.3.1 1.8.4.6.3 1.1.7 1.4 1.3.4.6.6 1.2.6 1.8v.4c0 1-.4 1.8-1.1 2.5z"
    })), React.createElement("symbol", {
      viewBox: "0 0 21 10.4",
      id: "inboundorg-icon"
    }, React.createElement("path", {
      fill: "#FFF",
      d: "M20.9 4c0-.1 0-.2-.1-.3 0-.1 0-.1-.1-.2 0-.1 0-.1-.1-.2 0-.1-.1-.2-.1-.3 0-.1-.1-.2-.1-.2s0-.1-.1-.1c-.2-.4-.5-.8-.9-1.2l-.1-.1c-.1-.2-.3-.4-.6-.6-.5-.3-1.1-.6-1.8-.7-.3-.1-.7-.1-1.1-.1h-.6-.1c-.2 0-.3 0-.5.1h-.1c-1.1.3-2.1.8-3 1.7l-.4.4c-.2.2-.4.4-.6.7L8.8 5.2c-.2.3-.3.5-.5.7l-.2.2c-.1.1-.2.2-.2.3-.9.8-1.8 1.2-2.6 1.2-.5 0-1-.1-1.4-.4l-.3-.3-.1-.1c-.4-.7 0-1.5.3-1.5-.4-.2-.8-1-.2-1.8l.1-.1c.4-.4 1-.6 1.6-.6.8 0 2.1.8 3 1.7 0 0 .1-.1.1-.2l1.5-1.9v-.1c0-.1.1-.1.1-.1C8.9 1 7.3.2 5.8 0h-.5C2.4 0 .1 2.3 0 5.1v.1c0 .4 0 .8.1 1.2 0 .1 0 .2.1.3 0 .1 0 .1.1.2 0 .1 0 .1.1.2 0 .1.1.2.1.3 0 .1.1.2.1.2s0 .1.1.1c.2.4.5.8.9 1.2l.1.1c.1.2.3.4.6.6.4.2.8.4 1.3.6.5.2 1.1.3 1.6.3h.2c.2 0 .3 0 .4-.1h.1c.2 0 .3 0 .5-.1h.1c1.1-.3 2.1-.8 3-1.7.2-.2.3-.4.4-.6.2-.2.4-.4.6-.7l1.7-2.2c.2-.2.3-.5.5-.7.1-.1.1-.2.2-.2s.1-.1.2-.2c.9-.8 1.8-1.3 2.6-1.3.5 0 1 .1 1.4.4l.3.3c.1.1.1.1.1.2.4.7 0 1.5-.3 1.5.4.1.8 1 .2 1.7l-.1.1c-.4.4-1 .6-1.6.6-.8 0-2.1-.8-3-1.7 0 0 0 .1-.1.2l-1.5 1.9V8l-.1.1c1.2 1.2 2.8 2 4.3 2.2h.6c.8 0 1.6-.1 2.2-.4.1 0 .2-.1.3-.1h.1c.1 0 .1-.1.2-.1.4-.2.7-.4 1-.7.5-.5.8-1 1.1-1.6v-.1c0-.1.1-.2.1-.2 0-.1.1-.2.1-.2v-.1c-.1-.7 0-1.1 0-1.6 0-.4 0-.8-.1-1.2z"
    })), React.createElement("symbol", {
      viewBox: "0 0 20 20",
      id: "instagram-icon"
    }, React.createElement("g", {
      fill: "#FFF"
    }, React.createElement("path", {
      d: "M10 1.8c2.7 0 3 0 4 .1 1 0 1.5.2 1.9.3.5.2.8.4 1.1.8.3.3.6.7.7 1.1.2.4.4.9.4 1.9 0 1.1.1 1.4.1 4s0 3-.1 4c0 1-.2 1.5-.3 1.9-.2.5-.4.8-.7 1.1-.3.3-.7.6-1.1.7s-.9.3-1.9.3c-1.1 0-1.4.1-4 .1s-3 0-4-.1c-1 0-1.5-.2-1.9-.3-.6-.1-.9-.3-1.2-.7-.3-.3-.6-.7-.7-1.1-.2-.4-.4-.9-.4-1.9 0-1.1-.1-1.4-.1-4s0-3 .1-4c0-1 .2-1.5.3-1.9.2-.5.4-.8.8-1.1.3-.3.7-.6 1.1-.7.4-.2.9-.4 1.9-.4 1-.1 1.3-.1 4-.1M10 0C7.3 0 6.9 0 5.9.1 4.8.1 4.1.3 3.5.6c-.7.2-1.3.5-1.8 1.1-.6.5-.9 1.1-1.2 1.7-.2.7-.4 1.4-.4 2.5C0 6.9 0 7.3 0 10s0 3.1.1 4.1c0 1.1.2 1.8.5 2.4.3.7.6 1.2 1.2 1.8.6.6 1.1.9 1.8 1.2.6.2 1.4.4 2.4.5h4c2.7 0 3.1 0 4.1-.1 1.1 0 1.8-.2 2.4-.5.7-.3 1.2-.6 1.8-1.2.6-.6.9-1.1 1.2-1.8.2-.6.4-1.4.5-2.4 0-1.1.1-1.4.1-4.1s0-3.1-.1-4.1c0-1.1-.2-1.8-.5-2.4-.3-.7-.6-1.2-1.2-1.8S17.2.7 16.5.4c-.6-.2-1.4-.4-2.4-.5-1 .1-1.4.1-4.1.1z"
    }), React.createElement("path", {
      d: "M10 4.9c-2.8 0-5.1 2.3-5.1 5.1s2.3 5.1 5.1 5.1 5.1-2.3 5.1-5.1-2.3-5.1-5.1-5.1zm0 8.4c-1.8 0-3.3-1.5-3.3-3.3S8.2 6.7 10 6.7s3.3 1.5 3.3 3.3-1.5 3.3-3.3 3.3z"
    }), React.createElement("circle", {
      cx: "15.3",
      cy: "4.7",
      r: "1.2"
    }))), React.createElement("symbol", {
      viewBox: "0 0 20 20",
      id: "linkedin-icon"
    }, React.createElement("path", {
      fill: "#FFF",
      d: "M18.5 0h-17C.7 0 0 .6 0 1.4v17.1c0 .9.7 1.5 1.5 1.5h17c.8 0 1.5-.6 1.5-1.4V1.4c0-.8-.7-1.4-1.5-1.4zM5.9 17H3V7.5h3L5.9 17zM4.4 6.2c-1 0-1.7-.8-1.7-1.7s.8-1.7 1.7-1.7 1.7.8 1.7 1.7c.1.9-.7 1.7-1.7 1.7zM17 17h-3v-4.6c0-1.1 0-2.5-1.5-2.5s-1.8 1.2-1.8 2.5V17h-3V7.5h2.8v1.3c.4-.8 1.4-1.5 2.8-1.5 3 0 3.6 2 3.6 4.5V17h.1z"
    })), React.createElement("symbol", {
      viewBox: "0 0 18.9 16",
      id: "medium-icon"
    }, React.createElement("g", {
      fill: "#FFF"
    }, React.createElement("path", {
      d: "M18.8 2.9L13.1 0H12.8c-.2 0-.4.1-.6.3L9 5.6l4.1 6.7 5.7-9.4c.1.1.1 0 0 0zM7.2 4.4v6.1l5.4 2.7zM13.4 13.6l4.4 2.2c.6.3 1 .1 1-.5V4.7l-5.4 8.9zM6.3 2.9L.7.2C.6.1.5.1.4.1.2.1 0 .3 0 .6v12c0 .3.2.7.5.8l4.9 2.5c.2.1.3.1.4.1.3 0 .5-.2.5-.6V2.9c0 .1 0 0 0 0z"
    }))), React.createElement("symbol", {
      viewBox: "0 0 18 18",
      id: "orange-globe-icon"
    }, React.createElement("path", {
      fill: "#F7751F",
      d: "M9 .6c4.6 0 8.4 3.8 8.4 8.4s-3.8 8.4-8.4 8.4S.6 13.6.6 9 4.4.6 9 .6M9 0C4 0 0 4 0 9s4 9 9 9 9-4 9-9-4-9-9-9z"
    }), React.createElement("defs", null, React.createElement("circle", {
      id: "ja",
      cx: "9",
      cy: "9",
      r: "8.4"
    })), React.createElement("clipPath", {
      id: "jb"
    }, React.createElement("use", {
      xlinkHref: "#ja",
      overflow: "visible"
    })), React.createElement("g", {
      clipPath: "url(#jb)",
      fill: "#F7751F"
    }, React.createElement("path", {
      d: "M18.3 9v0zM18.3 8.9v-.2.2c0 .1 0 0 0 0zM18.3 9.7v0zM7.6-.2h0zM9.7-.3h.3-.3zM6.8 0zM6.4.1zM7.2-.1c.1 0 0 0 0 0zM6 .2zM18.2 7.4zM18.2 10.1v0zM12 .2zM10.6-.2h.2c-.1.1-.1.1-.2 0zM11.1-.1h.1c0 .1-.1 0-.1 0zM9-.3h.4H9zM8.5-.3h.4-.4zM10.2-.2h.2-.2zM-.1 7.1c0-.1 0-.1 0 0 0-.1 0-.1 0 0zM8.1-.3h.2-.2zM12.4.3zM18 6.5zM11.5.1c.1 0 .1 0 0 0 .1 0 .1 0 0 0zM18.2 7.7v0zM11.2 18c-.1 0-.2 0-.3.1.1 0 .2 0 .3-.1zM-.3 8.4v-.3.3zM11.6 17.9h-.1.1zM-.3 9v-.4.4zM9.9 18.3h-.3.3zM9.4 18.3H9h.4zM-.2 7.9v-.2.2zM-.2 7.5v-.2.2zM10.8 18.1h-.2c0 .1.1 0 .2 0zM10.4 18.2H10h.4zM18.2 10.6v0zM12 17.8c-.1 0-.1 0 0 0-.1 0-.1 0 0 0zM8.3-.3h0zM-.1 7.3V7v.3zM9.5-.3h.2-.2zM11.9 17.8c-.1 0-.2.1-.2.1s.1 0 .2-.1zM10.9 18.1h-.2.2zM10.5 18.2h-.2.2zM11.5 18c-.1 0-.2.1-.3.1.1-.1.2-.1.3-.1zM-.2 7.7v-.2.2zM6.9-.1c.1 0 .2-.1.3-.1-.1.1-.2.1-.3.1zM6 .2c.1 0 .3-.1.4-.1-.2 0-.3.1-.4.1zM-.3 8.1v-.2c.1.1 0 .2 0 .2zM6.4.1c.1-.1.3-.1.4-.1-.1 0-.3 0-.4.1zM-.3 8.6v-.2.2zM7.8-.2h.3-.3zM9.5 18.3h-.1.1zM10 18.3h-.1.1zM7.3-.2c.1 0 .2 0 .3-.1-.1.1-.2.1-.3.1zM10.8-.1c.1 0 .2 0 .3.1-.1-.1-.2-.1-.3-.1zM4.5 3.1v-.2h-.2L4 3l.1.1h.4zM5.5 4.5l-.2.1v.1H6v-.1h-.1v-.1zM1.8 4.4c-.1.2-.2.4-.4.6l.4-.4v-.2zM5.2 3.9L5 3.8l-.2.1.1.3.2-.1z"
    }), React.createElement("path", {
      d: "M16.5 5.9l-.2-.2v-.4l-.3.1-.1.5-.3-.4v-.3l-.3-.3-.1-.1h-.4l.1.3.4.2.1.1h-.1v.3l-.2.1h-.2l-.1-.2h.3l.1-.1-.7-.5-.1-.2-.3.2-.3-.1-.4.5-.1.2h-.7l-.2-.1-.1-.5.1-.2.5.2.4.1.1-.2h-.2l.1-.4.4-.1.3-.5.3-.1h.4l-.1-.4-.3.1-.1-.3H14V3l.2-.2.4-.2.1-.2C13.1 1.3 11.2.5 9 .5c-1.9 0-3.6.6-5 1.6h.4l.2.1.4.1v.1h.6l-.1-.1-.5-.1.1-.1V2h-.5l.5-.4h.5l.2.3h.4l.2-.2.2.1-.3.3h-.4v.3h.5l.1-.1h.4v-.2L6.7 2l.1-.2.2-.1h.6l-.4.4.1.2h.3v-.4l.3-.2.6-.1.8.4v.3l.3.1-.3.3h-.4l-.1.3-.8-.2.7-.3-.3-.3-.5.1v.1l-.3.1h-.3v.1h.1-.2v.1l-.2.2v-.3l-.4.2-.7.4.1.3.2.1.4.1v.5h.2l.2-.4.5-.1v-.6l.3-.2.5.1v.4h.2l.4-.2v.5l.3.2v.3l-.3.1v.1l.4.2v.2h-.1l-.5-.2v-.2l.1-.1h-.1v.1h-.4l-.1-.1h-.4v.2h.4l-.3.2v-.1h-.1l-.4.3-.6.4-.5.5V6l-.5.4-.3.3v.5L5.2 7v-.3h-1l-.6.3-.2.4-.1.3.1.3.4.1.7-.4.1.2-.2.4.5.1.1.8.7.1.4-.5.5.1.2.3h.5v-.1l.3.1.3.5h.5l.2.3v.4l.6.2h.8l.2.4.3.1-.1.3-.4.5-.1 1-.3.3h-.5l-.1.1.1.5-.5.7-.2.3-.5.2-.3.1v.1l.2.1v.2l-.2.2.1.2H8v.2l-.1.2v.2l.4.3v.2h-.5l-.5-.4-.4-.7.1-.7-.3-.4-.1-.8h-.2v-1.5l-.5-.4-.3-.1-.1-.3L5 11l.1-.3v-.5l.4-.3v-.5h-.7l-.5-.6-.4-.1h-.2v-.2h-.3v.1l-.7-.3-.3-.5.1-.2-.5-.7v-.5h-.2l.1.5.3.5v.2h-.3L1.5 7v-.7l-.4-.2v-.4c.1-.3.2-.5.3-.7-.1.2-.2.4-.3.7C.7 6.7.5 7.8.5 9c0 4.7 3.8 8.5 8.5 8.5 2.7 0 5.1-1.2 6.6-3.2h-.3v-.6l-.3-.3v-.7l-.2-.2v-.3l.3-.6-.6-1.1.1-.7-.6-.1-.2-.2h-.4l-.2.2h-.6v.1h-.4l-.8-.9v-.7l.1-.1.1-.3h-.2l-.1-.3.9-.7v-.5l.5-.3H13.3l.3-.2 1-.1v.5l.8.2.1.1h.1v-.1h.4l.4.3h.7c0-.3-.1-.6-.1-.8h-.5zm-3.6-2.4l.1-.1.3-.1.1.3.1.2.1.2.2.1-.2.2H13V4h.2v-.1l-.2-.1-.1-.1v-.2zm-.4.5l.2-.3.2-.1.1.2V4l-.4.2h-.2l.1-.2zM7.8 5.1h-.2V5l.1-.1.1.2zm.7-.2h-.1V5H8.1v-.1H8h.2l.1-.1.2.1z"
    }), React.createElement("path", {
      d: "M16.8 5.5c-.1-.1-.1-.3-.2-.4l-.1.1v.4l.3-.1zM15.5 3.9l.2-.3c-.1-.2-.3-.3-.4-.5v.4l-.4.2v.1l.6.1zM4.5 2.6v-.1H4v.2h.4zM6 4.5v.2h.2zM6.3 5V5.3h.3v-.2zM6.4 4.8v.1h.2zM17.3 7.1l.1.1-.1-.1zM17.3 13.2c-1.1 2.1-3 3.8-5.3 4.6 3.2-1.1 5.6-3.8 6.2-7.1 0 .2-.1.3-.1.5-.2.7-.5 1.4-.8 2zM5.9 5.1h.2l.1-.1v-.2h-.3zM5.9 5.2h-.1l-.1.2H6l.1-.1v-.2zM5.2 5.2l.2.1.3-.5h-.2l-.2.2zM18.3 9.9v.3c-.1-.2 0-.2 0-.3zM18.2 7.5v0zM18.3 9.4v0zM18 6.5c.1.3.1.6.2.9-.1-.3-.2-.6-.2-.9zM9.9-.3h.2c0 .1-.1.1-.2 0zM18.2 10.3v0zM11.2 0c.1 0 .2.1.3.1-.1-.1-.2-.1-.3-.1zM12 .2c.1 0 .2.1.4.1-.1 0-.2-.1-.4-.1zM10.4-.2h.3-.3zM11.6.1c.1 0 .2.1.3.1 0-.1-.2-.1-.3-.1zM-.3 9c0 5.1 4.2 9.3 9.3 9.3-5.1 0-9.3-4.2-9.3-9.3zM18.3 8.7c0-.3 0-.6-.1-.9V8c.1.3.1.5.1.7zM9-.3zM2.7 2.2c.9-.9 2-1.5 3.3-2C3 1.2.6 3.8-.1 7c.3-1.4.9-2.6 1.7-3.7.4-.4.7-.8 1.1-1.1zM18.3 9z"
    }), React.createElement("path", {
      d: "M15.7 2.5c0 .1.1.1.1.2.7.8 1.3 1.7 1.7 2.7 0 .1 0 .1.1.2l.3.9C17.1 3.7 15 1.4 12.4.4c1.1.4 2 1 2.8 1.8.2.1.3.2.5.3z"
    }))), React.createElement("symbol", {
      viewBox: "0 0 18 18",
      id: "orange-telephone-icon"
    }, React.createElement("path", {
      fill: "none",
      d: "M9 10.9c-1.3 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3 2.2-1 2.2-2.3c.1-1.3-.9-2.3-2.2-2.3z"
    }), React.createElement("path", {
      fill: "#F7751F",
      d: "M0 7l1.6 2.3 2.9-1.6c.6-.3.6-1.6.6-1.6 1.6-1 6.1-1 7.7 0 0 0 0 1.3.6 1.6l2.9 1.6L18 7C13.8 2.2 4.2 2.2 0 7z"
    }), React.createElement("path", {
      fill: "#F7751F",
      d: "M1.3 17.7c0 .3 0 .3.3.3h14.8c.3 0 .3 0 .3-.3.7-12.3-16.1-12.3-15.4 0zM9 15.4c-1.3 0-2.3-1-2.3-2.3s1-2.3 2.3-2.3 2.2 1 2.2 2.3c.1 1.3-.9 2.3-2.2 2.3z"
    })), React.createElement("symbol", {
      viewBox: "0 0 16 16",
      id: "pinterest-icon"
    }, React.createElement("path", {
      fill: "#FFF",
      d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15.1c-.7 0-1.4-.1-2.1-.3.3-.5.7-1.2.9-1.9.1-.3.4-1.7.4-1.7.2.4.9.8 1.6.8 2.1 0 3.7-2 3.7-4.4 0-2.3-1.9-4.1-4.4-4.1-3.1 0-4.7 2.1-4.7 4.3 0 1 .6 2.3 1.4 2.8.1.1.2 0 .2-.1s.1-.6.2-.8v-.2c-.2-.4-.5-1-.5-1.6 0-1.6 1.2-3.1 3.2-3.1 1.7 0 3 1.2 3 2.9 0 1.9-1 3.3-2.2 3.3-.7 0-1.2-.6-1.1-1.3.2-.8.6-1.8.6-2.4 0-.5-.3-1-.9-1C6.6 6.3 6 7 6 8c0 .6.3 1 .3 1s-.7 3-.8 3.5c-.1.6-.1 1.5 0 2C2.8 13.6.9 11 .9 8 .9 4.1 4.1.9 8 .9s7.1 3.2 7.1 7.1c0 3.9-3.2 7.1-7.1 7.1z"
    })), React.createElement("symbol", {
      viewBox: "0 0 18 20.6",
      id: "podcast-icon"
    }, React.createElement("path", {
      fill: "none",
      d: "M8.5 10.3h1.1c1 0 1.8.6 1.8 1.4 1-.7 1.7-2 1.7-3.3 0-2.2-1.8-4.1-4.1-4.1S4.9 6.1 4.9 8.4c0 1.4.7 2.6 1.8 3.3 0-.8.7-1.4 1.8-1.4zM9 5.8c1.2 0 2.1 1 2.1 2.1S10.1 10 9 10s-2.1-.8-2.1-2S7.8 5.8 9 5.8z"
    }), React.createElement("path", {
      fill: "none",
      d: "M9 1.3C4.8 1.3 1.3 4.8 1.3 9c0 3.6 2.4 6.5 5.7 7.4l-.2-3.2c-1.9-.8-3.2-2.7-3.2-4.9C3.6 5.4 6 3 9 3s5.4 2.4 5.4 5.4c0 2.2-1.3 4-3.2 4.9l-.2 3.1c3.3-.9 5.7-3.8 5.7-7.4 0-4.2-3.5-7.7-7.7-7.7z"
    }), React.createElement("path", {
      fill: "#FFF",
      d: "M9 0C4 0 0 4 0 9c0 4.3 3.1 8 7.2 8.8l.1 1.3c.1.8.7 1.5 1.4 1.5h.7c.7 0 1.3-.7 1.4-1.5l.1-1.3c4-.8 7.1-4.5 7.1-8.8 0-5-4-9-9-9zM4.9 8.4c0-2.2 1.8-4.1 4.1-4.1s4.1 1.8 4.1 4.1c0 1.4-.7 2.6-1.7 3.3 0-.8-.8-1.4-1.8-1.4H8.5c-1 0-1.8.6-1.8 1.4-1.1-.7-1.8-2-1.8-3.3zm6.1 8l.2-3.1c1.9-.8 3.2-2.7 3.2-4.9C14.4 5.4 12 3 9 3S3.6 5.4 3.6 8.4c0 2.2 1.3 4 3.2 4.9l.2 3.1c-3.2-.9-5.7-3.8-5.7-7.4 0-4.2 3.4-7.7 7.7-7.7s7.7 3.4 7.7 7.7c0 3.6-2.5 6.5-5.7 7.4z"
    }), React.createElement("circle", {
      fill: "#FFF",
      cx: "9",
      cy: "8",
      r: "2.1"
    })), React.createElement("symbol", {
      viewBox: "0 0 125.1 125.1",
      id: "slack-icon"
    }, React.createElement("g", {
      fill: "#FFF"
    }, React.createElement("path", {
      d: "M51.444 57.35l16.689-5.59 5.399 16.119-16.689 5.59z"
    }), React.createElement("path", {
      d: "M51.444 57.35l16.689-5.59 5.399 16.119-16.689 5.59z"
    }), React.createElement("path", {
      d: "M119.8 45.3c-12.9-43-31.5-53-74.5-40.1s-53 31.5-40.1 74.5 31.5 53 74.5 40.1 53-31.5 40.1-74.5zM98.1 73.2L90 75.9l2.8 8.4c1.1 3.4-.7 7.1-4.1 8.2-.7.2-1.5.4-2.2.3-2.6-.1-5.1-1.8-6-4.4L77.7 80 61 85.6l2.8 8.4c1.1 3.4-.7 7.1-4.1 8.2-.7.2-1.5.4-2.2.3-2.6-.1-5.1-1.8-6-4.4l-2.8-8.4-8.1 2.7c-.7.2-1.5.4-2.2.3-2.6-.1-5.1-1.8-6-4.4-1.1-3.4.7-7.1 4.1-8.2l8.1-2.7-5.4-16.1-8.1 2.7c-.7.2-1.5.4-2.2.3-2.6-.1-5.1-1.8-6-4.4-1.1-3.4.7-7.1 4.1-8.2l8.1-2.7-2.8-8.4c-1.1-3.4.7-7.1 4.1-8.2s7.1.7 8.2 4.1l2.8 8.4 16.7-5.6-2.8-8.4c-1.1-3.4.7-7.1 4.1-8.2 3.4-1.1 7.1.7 8.2 4.1l2.8 8.4 8.1-2.7c3.4-1.1 7.1.7 8.2 4.1 1.1 3.4-.7 7.1-4.1 8.2l-8.1 2.7 5.4 16.1 8.1-2.7c3.4-1.1 7.1.7 8.2 4.1 1.1 3.4-.7 7.1-4.1 8.2z"
    }))), React.createElement("symbol", {
      viewBox: "0 0 17 17.3",
      id: "slideshare-icon"
    }, React.createElement("g", {
      fill: "#FFF"
    }, React.createElement("path", {
      d: "M16.3 8.2c-.1 0-.1.1-.2.1V1.7c0-.9-.7-1.7-1.6-1.7H2.4C1.6 0 .9.8.9 1.7v6.7c-.1 0-.1-.1-.2-.1-.6-.4-.9.1-.6.5.6.8 1.8 1.7 3.6 2.4-1.9 6.5 4.6 7.5 4.5 4.2v-3.3c.2 0 .3.1.5.1v3.2c-.1 3.3 6.5 2.3 4.5-4.2 1.8-.7 3-1.7 3.6-2.4.4-.4.1-.9-.5-.6zM9.9 9.9c-.8 0-1.1.3-1.1.8-.2-.1-.4-.3-.6-.5l-.1-.1c-.2-.1-.5-.2-1-.2-1.1 0-3 .2-5.3-1V2.4c0-1.2.3-1.5 1.4-1.5h10.7c1 0 1.4.4 1.4 1.5v6.4C13 10.2 11 9.9 9.9 9.9z"
    }), React.createElement("path", {
      d: "M11 5.2c-1.1 0-2 .9-2 2s.9 2 2.1 2c1.2 0 2.1-.9 2.1-2s-1-2-2.2-2z"
    }), React.createElement("ellipse", {
      cx: "6.2",
      cy: "7.2",
      rx: "2.1",
      ry: "2"
    }))), React.createElement("symbol", {
      viewBox: "0 0 18 18",
      id: "solid-orange-email-icon"
    }, React.createElement("g", {
      fill: "#F7751F"
    }, React.createElement("path", {
      d: "M0 5.8v8.3c0 .5.4.9.9.9h16.2c.5 0 .9-.5.9-.9V5.9l-8.9 4.9-9.1-5z"
    }), React.createElement("path", {
      d: "M17.1 2.9H.9c-.5 0-.9.3-.9.8v.8l9.1 4.9L18 4.6v-.9c0-.5-.4-.8-.9-.8z"
    }))), React.createElement("symbol", {
      viewBox: "0 0 20 20",
      id: "twitter-icon"
    }, React.createElement("path", {
      fill: "#FFF",
      d: "M20 5.7c-.7.3-1.5.5-2.4.6.9-.5 1.5-1.3 1.8-2.3-.8.5-1.7.8-2.6 1-.7-.8-1.8-1.3-3-1.3-2.3 0-4.1 1.8-4.1 4.1 0 .3 0 .6.1.9C6.4 8.6 3.4 7 1.4 4.5 1 5.1.8 5.8.8 6.6c0 1.4.8 2.6 1.9 3.4-.7 0-1.3-.2-1.9-.5v.1c0 2 1.4 3.6 3.3 4-.3.1-.7.1-1.1.1-.3 0-.5 0-.8-.1.5 1.6 2 2.8 3.8 2.8-1.4 1.1-3.2 1.8-5.1 1.8-.3 0-.7 0-1-.1C1.8 19.3 4 20 6.3 20 13.8 20 18 13.7 18 8.3v-.5c.8-.6 1.4-1.3 2-2.1z"
    })), React.createElement("symbol", {
      viewBox: "0 0 20 20",
      id: "youtube-icon"
    }, React.createElement("path", {
      fill: "#FFF",
      d: "M19.8 9s-.2-1.4-.8-2c-.8-.8-1.6-.8-2-.8-2.8-.2-7-.2-7-.2s-4.2 0-7 .2c-.4 0-1.2 0-2 .8-.6.6-.8 2-.8 2S0 10.6 0 12.2v1.5c0 1.6.2 3.3.2 3.3s.2 1.4.8 2c.8.8 1.8.8 2.2.9 1.6.1 6.8.1 6.8.1s4.2 0 7-.2c.4 0 1.2-.1 2-.8.6-.6.8-2 .8-2s.2-1.6.2-3.2v-1.5c0-1.7-.2-3.3-.2-3.3zM7.9 15.6V10l5.4 2.8-5.4 2.8z"
    })));
  };

  return SVGIcons;
}(React.Component);

var COLORS = {
  // THEME COLORS
  // Primary colors
  calypso: '#00a4bd',
  calypsoLightest: '#e5f5f8',
  calypsoSearch: '#0091ae;',
  calypsoSearchHover: '#007a8c;',
  lorax: '#ff7a59',
  primaryBackgroundHover: '#ff8f73',
  // Secondary colors
  oz: '#00bda5',
  secondaryBackgroundHover: '#fff8f6',
  headerSearchFocus: '#00d0e4',
  headerSearchFocusRGB: '0, 208, 228',
  // Links
  linkPrimary: '#0091ae',
  linkPrimaryHover: '#007a8c',
  // Dark greys
  pantera: '#2d3e50',
  panteraRGB: '45, 62, 80',
  obsidian: '#33475b',
  obsidianRGB: '51, 71, 91',
  flint: '#99acc2',
  eerie: '#7c98b6',
  heffalump: '#425b76',
  // Light greys
  battleship: '#cbd6e2',
  koala: '#eaf0f6',
  gypsum: '#f5f8fa',
  olaf: '#fff',
  olafRGB: '255, 255, 255'
};
var DEFAULT_RIBBON_TEXT = 'NEW';

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  list-style: none;\n\n  @media (min-width: 501px) and (max-width: 767px) {\n    display: flex;\n    justify-content: space-evenly;\n    width: 100%;\n  }\n\n  .hsg-nav__link {\n    display: block;\n    padding: 0.75rem 0;\n    font-weight: 500;\n\n    @media (min-width: 768px) {\n      display: inline-block;\n    }\n  }\n\n  .hsg-nav__link-label {\n    padding: 0 1rem;\n    display: inline-block;\n\n    :hover {\n      color: ", ";\n      text-decoration: underline;\n    }\n\n    &--contact-us {\n      ::before {\n        content: url(//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/ContactSales.svg);\n        position: relative;\n        left: -0.5rem;\n        top: 0.25rem;\n      }\n    }\n    .hsg-icon {\n      display: inline-block;\n      font-size: 1.125rem;\n      line-height: 1;\n      vertical-align: middle;\n      margin-right: 0.625rem;\n\n      &::before {\n        content: url(//cdn2.hubspot.net/hubfs/53/Logos/language-switcher-icon.svg);\n        display: inline-block;\n        width: .75rem;\n        margin-bottom: -0.875rem;\n      }\n    }\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var renderLangList = function renderLangList(lang, languagesContent, _ref) {
  var pathname = _ref.pathname;
  return Object.keys(languagesContent).map(function (langKey) {
    var _languagesContent$lan = languagesContent[langKey],
        languageName = _languagesContent$lan[0],
        localizedHostName = _languagesContent$lan[1],
        _languagesContent$lan2 = _languagesContent$lan[2],
        localizedPathName = _languagesContent$lan2 === void 0 ? pathname : _languagesContent$lan2;
    var localizedUrl = "" + localizedHostName + localizedPathName;
    return langKey !== lang && React.createElement("li", {
      key: langKey,
      className: "hsg-nav__dropdown-item"
    }, React.createElement("a", {
      className: "hsg-nav__dropdown-country-link",
      href: purify(localizedUrl)
    }, languageName));
  });
};

var regionalDropdown =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(regionalDropdown, _React$Component);

  function regionalDropdown() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = regionalDropdown.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        contactUrl = _this$props.contactUrl,
        contactText = _this$props.contactText,
        languagesContent = _this$props.languagesContent,
        _this$props$isMobile = _this$props.isMobile,
        isMobile = _this$props$isMobile === void 0 ? false : _this$props$isMobile,
        _this$props$isToggle = _this$props.isToggle,
        isToggle = _this$props$isToggle === void 0 ? false : _this$props$isToggle,
        _this$props$isLangTog = _this$props.isLangToggleOn,
        isLangToggleOn = _this$props$isLangTog === void 0 ? false : _this$props$isLangTog,
        _this$props$lang = _this$props.lang,
        lang = _this$props$lang === void 0 ? 'en' : _this$props$lang,
        _this$props$handleLan = _this$props.handleLanguageClick,
        handleLanguageClick = _this$props$handleLan === void 0 ? function () {} : _this$props$handleLan;
    var currentLocation = window.location; // Do not show the dropdown if we are in the in-app pricing page

    if (currentLocation.href.indexOf('app.hubspot.com/pricing') > -1) {
      return null;
    }

    return React.createElement("ul", {
      className: className
    }, React.createElement("li", {
      className: "hsg-nav__group-item hsg-nav__group-item--has-dropdown " + (isMobile && isToggle && isLangToggleOn ? 'active' : ''),
      onClick: function onClick(e) {
        return handleLanguageClick(e);
      }
    }, React.createElement("div", {
      id: "nav-main-link",
      className: "hsg-nav__link-wrapper"
    }, React.createElement("a", {
      className: "hsg-nav__link"
    }, " ", React.createElement("span", {
      className: "hsg-nav__link-label hsg-nav__link-label--globe"
    }, React.createElement("span", {
      className: "hsg-icon hsg-nav__globe-icon"
    }), languagesContent["" + lang] ? languagesContent["" + lang][0] : languagesContent.en[0]))), React.createElement("ul", {
      className: "hsg-nav__dropdown-list " + (isMobile && isToggle && isLangToggleOn ? 'open' : '')
    }, renderLangList(lang, languagesContent, currentLocation))), React.createElement("li", {
      className: "hsg-nav__group-item"
    }, React.createElement("div", {
      className: "hsg-nav__link-wrapper"
    }, React.createElement("a", {
      href: contactUrl,
      className: "hsg-nav__link"
    }, React.createElement("span", {
      className: "hsg-nav__link-label hsg-nav__link-label--contact-us"
    }, contactText)))));
  };

  return regionalDropdown;
}(React.Component);

regionalDropdown.propTypes = {
  className: PropTypes.string.isRequired,
  contactUrl: PropTypes.string.isRequired,
  contactText: PropTypes.string.isRequired,
  languagesContent: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
  isToggle: PropTypes.bool,
  isLangToggleOn: PropTypes.bool,
  lang: PropTypes.string,
  handleLanguageClick: PropTypes.func
};
var StyledRegionalDropdown = styled__default(regionalDropdown)(_templateObject$1(), COLORS.linkPrimaryHover);

var Search =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Search, _React$Component);

  function Search(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.searchInput = null;

    _this.setSearchInputRef = function (elem) {
      _this.searchInput = elem;
    };

    _this.focusSearchInput = function () {
      if (_this.searchInput) _this.searchInput.focus();
    };

    _this.showResults = _this.showResults.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Search.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.focusSearchInput();
    document.body.style.overflowY = this.props.isSearchOpen ? 'hidden' : 'auto';
  };

  _proto.showResults = function showResults() {
    var _this$props = this.props,
        searchResultsList = _this$props.searchResultsList,
        searchIndex = _this$props.searchIndex,
        loadMoreResults = _this$props.loadMoreResults,
        loadMoreText = _this$props.searchContent.loadMoreText;
    var numResultsShow = 9;
    var searchIndexEnd = searchIndex + numResultsShow;

    if (searchResultsList) {
      var searchResults = searchResultsList.slice(0, searchIndexEnd).map(function (result) {
        var htmlTitle = result.htmlTitle,
            link = result.link,
            htmlSnippet = result.htmlSnippet,
            cacheId = result.cacheId;
        return React.createElement("div", {
          key: cacheId,
          className: "hsg-search-item",
          "data-link": link
        }, React.createElement("div", {
          className: "title"
        }, React.createElement("a", {
          href: link,
          target: "_blank",
          rel: "noopener noreferrer",
          dangerouslySetInnerHTML: {
            __html: purify(htmlTitle)
          }
        })), React.createElement("div", {
          className: "snippet"
        }, React.createElement("p", {
          dangerouslySetInnerHTML: {
            __html: purify(htmlSnippet)
          }
        })));
      });
      return React.createElement("section", {
        className: "hsg-search__results"
      }, React.createElement("div", {
        className: "hs-page-width-normal"
      }, searchResults, searchIndexEnd < searchResultsList.length && React.createElement("span", {
        className: "hsg-search__container"
      }, React.createElement("a", {
        className: "hsg-search__more cta cta--blue",
        href: "#",
        onClick: function onClick(e) {
          return loadMoreResults(e);
        }
      }, loadMoreText))));
    }

    var _this$props$searchCon = this.props.searchContent.noResultsContent,
        h6 = _this$props$searchCon.h6,
        p1 = _this$props$searchCon.p1,
        p2 = _this$props$searchCon.p2;
    return React.createElement("section", {
      className: "hsg-search__results no-results"
    }, React.createElement("h6", null, h6), React.createElement("p", null, React.createElement("strong", null, p1)), React.createElement("p", null, p2));
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        className = _this$props2.className,
        queryString = _this$props2.queryString,
        isSearchOpen = _this$props2.isSearchOpen,
        handleSearch = _this$props2.handleSearch,
        handleCx = _this$props2.handleCx,
        closeSearch = _this$props2.closeSearch,
        _this$props2$searchCo = _this$props2.searchContent,
        searchPlaceholder = _this$props2$searchCo.searchPlaceholder,
        searchHubLabel = _this$props2$searchCo.searchHubLabel,
        searchBlogLabel = _this$props2$searchCo.searchBlogLabel,
        cx = _this$props2$searchCo.cx,
        cxBlog = _this$props2$searchCo.cxBlog;

    if (isSearchOpen) {
      return React.createElement("section", {
        className: className,
        datatype: "hsg-search__modal-wrapper"
      }, React.createElement("a", {
        className: "modalClose",
        id: "modalClose",
        onClick: function onClick(e) {
          return closeSearch(e);
        }
      }), React.createElement("div", {
        className: "hsgModalFullscreenInner"
      }, React.createElement("section", {
        className: "hsg-search__modal-header"
      }, React.createElement("div", {
        className: "hs-page-width-normal"
      }, React.createElement("input", {
        className: "hsg-search__modal-input",
        name: "searchModal",
        type: "search",
        ref: this.setSearchInputRef,
        placeholder: searchPlaceholder,
        defaultValue: queryString,
        onKeyUp: function onKeyUp(e) {
          return handleSearch(e);
        }
      }), React.createElement("div", {
        className: "hsg-search__modal-search-options"
      }, React.createElement("label", {
        htmlFor: "searchOptionWeb"
      }, React.createElement("input", {
        id: "searchOptionWeb",
        value: cx,
        name: "searchOption",
        type: "radio",
        className: "hsg-search__modal-radio",
        defaultChecked: "true",
        onChange: function onChange(e) {
          return handleCx(e);
        }
      }), searchHubLabel), React.createElement("label", {
        htmlFor: "searchOptionBlog"
      }, React.createElement("input", {
        id: "searchOptionBlog",
        value: cxBlog,
        name: "searchOption",
        type: "radio",
        className: "hsg-search__modal-radio",
        onChange: function onChange(e) {
          return handleCx(e);
        }
      }), searchBlogLabel)))), this.showResults()));
    }

    return null;
  };

  return Search;
}(React.Component);

Search.propTypes = {
  className: PropTypes.string,
  queryString: PropTypes.string,
  searchIndex: PropTypes.number,
  isSearchOpen: PropTypes.bool,
  handleSearch: PropTypes.func,
  handleCx: PropTypes.func,
  loadMoreResults: PropTypes.func,
  closeSearch: PropTypes.func,
  searchContent: PropTypes.object,
  searchResultsList: PropTypes.array
};

var renderLinkItems = function renderLinkItems(contentObj) {
  return Object.keys(contentObj).map(function (item) {
    var _contentObj$item = contentObj[item],
        url = _contentObj$item.url,
        text = _contentObj$item.text,
        isEN = _contentObj$item.isEN;
    return React.createElement("li", {
      key: item
    }, isEN ? React.createElement("a", {
      className: "hsg-en-link",
      href: url
    }, React.createElement("span", null, text)) : React.createElement("a", {
      href: url
    }, text));
  });
};

var NavLinkCol =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(NavLinkCol, _React$Component);

  function NavLinkCol() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavLinkCol.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        headerText = _this$props.headerText,
        listColContent = _this$props.listColContent;
    return React.createElement("div", {
      className: "hsg-nav__dropdown-column"
    }, React.createElement("h4", {
      className: "hsg-nav__header"
    }, headerText), React.createElement("ul", {
      className: "hsg-nav__link-group"
    }, renderLinkItems(listColContent)));
  };

  return NavLinkCol;
}(React.Component);

NavLinkCol.propTypes = {
  headerText: PropTypes.string,
  listColContent: PropTypes.object
};

var MyContext = React.createContext({
  useNewIcons: false
});

var renderLinkItems$1 = function renderLinkItems(contentObj, useNewIcons) {
  return Object.keys(contentObj).map(function (item) {
    var _contentObj$item = contentObj[item],
        url = _contentObj$item.url,
        htype = _contentObj$item.htype,
        headerText = _contentObj$item.headerText,
        gtm = _contentObj$item.gtm,
        subtextContent = _contentObj$item.subtextContent,
        iconSrc = _contentObj$item.iconSrc,
        newIconSrc = _contentObj$item.newIconSrc,
        iconAlt = _contentObj$item.iconAlt,
        _contentObj$item$hasR = _contentObj$item.hasRibbon,
        hasRibbon = _contentObj$item$hasR === void 0 ? false : _contentObj$item$hasR,
        _contentObj$item$ribb = _contentObj$item.ribbonText,
        ribbonText = _contentObj$item$ribb === void 0 ? DEFAULT_RIBBON_TEXT : _contentObj$item$ribb;
    var iconSrcRef = useNewIcons === true ? newIconSrc : iconSrc;

    if (url) {
      return React.createElement("a", {
        key: item,
        href: url,
        className: "hsg-nav__box-link"
      }, htype !== 6 && htype !== null ? React.createElement(React.Fragment, null, iconSrcRef && React.createElement("img", {
        className: "hsg-nav__box-link-icon",
        src: iconSrcRef,
        alt: iconAlt
      }), React.createElement("span", {
        className: "hsg-nav__header-container"
      }, htype === 3 ? React.createElement("h3", {
        className: "hsg-nav__header",
        gtm: gtm
      }, headerText) : React.createElement("h4", {
        className: "hsg-nav__header",
        gtm: gtm
      }, headerText, " ", hasRibbon && React.createElement("span", {
        className: "hsg-nav__ribbon"
      }, ribbonText)), React.createElement("p", {
        className: "hsg-nav__subheader",
        gtm: gtm,
        dangerouslySetInnerHTML: {
          __html: purify(subtextContent)
        }
      }))) : htype == null ? React.createElement(React.Fragment, null, React.createElement("p", {
        className: "hsg-nav__subheader",
        gtm: gtm
      }, headerText)) : React.createElement(React.Fragment, null, React.createElement("h3", {
        className: "hsg-nav__header",
        gtm: gtm
      }, headerText), React.createElement("p", {
        className: "hsg-nav__subheader",
        gtm: gtm,
        dangerouslySetInnerHTML: {
          __html: purify(subtextContent)
        }
      })));
    } else if (!url) {
      return React.createElement("div", {
        key: item,
        className: "hsg-nav__box-link-none"
      }, htype !== 6 && htype !== null ? React.createElement(React.Fragment, null, iconSrcRef && React.createElement("img", {
        className: "hsg-nav__box-link-icon",
        src: iconSrcRef,
        alt: iconAlt
      }), React.createElement("span", {
        className: "hsg-nav__header-container"
      }, htype === 3 ? React.createElement("h3", {
        className: "hsg-nav__header",
        gtm: gtm
      }, headerText) : React.createElement("h4", {
        className: "hsg-nav__header",
        gtm: gtm
      }, headerText, " ", hasRibbon && React.createElement("span", {
        className: "hsg-nav__ribbon"
      }, ribbonText)), React.createElement("p", {
        className: "hsg-nav__subheader",
        gtm: gtm,
        dangerouslySetInnerHTML: {
          __html: purify(subtextContent)
        }
      }))) : htype == null ? React.createElement(React.Fragment, null, React.createElement("p", {
        className: "hsg-nav__subheader",
        gtm: gtm
      }, headerText)) : React.createElement(React.Fragment, null, React.createElement("h3", {
        className: "hsg-nav__header",
        gtm: gtm
      }, headerText), React.createElement("p", {
        className: "hsg-nav__subheader",
        gtm: gtm,
        dangerouslySetInnerHTML: {
          __html: purify(subtextContent)
        }
      })));
    }
  });
};

var addTitle = function addTitle(sectionLabel) {
  if (sectionLabel) {
    return React.createElement(React.Fragment, null, React.createElement("h4", {
      className: "hsg-nav__header"
    }, sectionLabel));
  }
};

var wrapDiv = function wrapDiv(numInnerDivs, listRowContent, sectionLabel, sectionIcon) {
  if (numInnerDivs > 1) {
    return Object.keys(listRowContent).map(function (item) {
      var _listRowContent$item = listRowContent[item],
          headerText = _listRowContent$item.headerText,
          listColContent = _listRowContent$item.listColContent;
      return React.createElement(NavLinkCol, {
        key: item,
        headerText: headerText,
        listColContent: listColContent
      });
    });
  }

  if (sectionIcon) {
    return React.createElement(React.Fragment, null, React.createElement("img", {
      className: "hsg-nav__link-section-icon hsg-nav__box-link-icon",
      src: sectionIcon,
      alt: sectionLabel
    }), React.createElement("div", {
      className: "hsg-nav__dropdown-column"
    }, addTitle(sectionLabel), renderLinkItems$1(listRowContent)));
  } else {
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: "hsg-nav__dropdown-column"
    }, addTitle(sectionLabel), renderLinkItems$1(listRowContent)));
  }
};

var NavLinkhs =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(NavLinkhs, _React$Component);

  function NavLinkhs() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavLinkhs.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        numInnerDivs = _this$props.numInnerDivs,
        className = _this$props.className,
        listRowContent = _this$props.listRowContent,
        sectionLabel = _this$props.sectionLabel,
        sectionIcon = _this$props.sectionIcon;
    return React.createElement(MyContext.Consumer, null, function (_ref) {
      var useNewIcons = _ref.useNewIcons;
      return React.createElement("li", {
        className: className
      }, numInnerDivs ? wrapDiv(numInnerDivs, listRowContent, sectionLabel, sectionIcon) : renderLinkItems$1(listRowContent, useNewIcons));
    });
  };

  return NavLinkhs;
}(React.Component);

NavLinkhs.propTypes = {
  numInnerDivs: PropTypes.number,
  className: PropTypes.string,
  listRowContent: PropTypes.object,
  sectionLabel: PropTypes.string,
  sectionIcon: PropTypes.string
};

var renderNavItems = function renderNavItems(contentObj) {
  return Object.keys(contentObj).map(function (item) {
    var _contentObj$item = contentObj[item],
        numInnerDivs = _contentObj$item.numInnerDivs,
        className = _contentObj$item.className,
        listRowContent = _contentObj$item.listRowContent,
        sectionLabel = _contentObj$item.sectionLabel,
        sectionIcon = _contentObj$item.sectionIcon;
    return React.createElement(NavLinkhs, {
      key: item,
      numInnerDivs: numInnerDivs,
      className: className,
      listRowContent: listRowContent,
      sectionLabel: sectionLabel,
      sectionIcon: sectionIcon
    });
  });
};

var NavDropDown =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(NavDropDown, _React$Component);

  function NavDropDown() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavDropDown.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        hasDropDown = _this$props.hasDropDown,
        className = _this$props.className,
        topUrl = _this$props.topUrl,
        topText = _this$props.topText,
        ulClassName = _this$props.ulClassName,
        navLinksContent = _this$props.navLinksContent,
        handleToggleClick = _this$props.handleToggleClick,
        objId = _this$props.objId;
    return React.createElement("li", {
      className: className
    }, React.createElement("div", {
      className: "hsg-nav__link-wrapper"
    }, hasDropDown ? React.createElement("a", {
      href: topUrl,
      className: "hsg-nav__link",
      onClick: function onClick(e) {
        return handleToggleClick(e, objId);
      }
    }, React.createElement("span", {
      className: "hsg-nav__link-label"
    }, topText)) : React.createElement("a", {
      href: topUrl,
      className: "hsg-nav__link"
    }, React.createElement("span", {
      className: "hsg-nav__link-label"
    }, topText))), hasDropDown && React.createElement("ul", {
      className: ulClassName
    }, React.createElement("h4", {
      className: "hsg-nav__dropdown-list-title"
    }, topText), renderNavItems(navLinksContent)));
  };

  return NavDropDown;
}(React.Component);

NavDropDown.propTypes = {
  hasDropDown: PropTypes.bool,
  className: PropTypes.string,
  topUrl: PropTypes.string,
  topText: PropTypes.string,
  ulClassName: PropTypes.string,
  navLinksContent: PropTypes.object,
  handleToggleClick: PropTypes.func,
  objId: PropTypes.string.isRequired
};

var MainNav =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(MainNav, _React$Component);

  function MainNav(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isMobile: window.innerWidth <= 767,
      isActive: false,
      isToggle: false,
      isLangToggleOn: false,
      dropDowns: Object.keys(_this.props.mainNavContent).reduce(function (dropDowns, item) {
        if (_this.props.mainNavContent[item].hasDropDown) {
          dropDowns[item] = '';
        }

        return dropDowns;
      }, {})
    };

    if (_this.state.isMobile) {
      _this.state.isActive = _this.state.isMobile && false;
    }

    _this.handleToggleClick = _this.handleToggleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.renderNavDropDowns = _this.renderNavDropDowns.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleLanguageClick = _this.handleLanguageClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleBurgerMenuClick = _this.handleBurgerMenuClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = MainNav.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    window.addEventListener('resize', function () {
      var isMobile = window.innerWidth <= 767;

      _this2.setState({
        isMobile: isMobile,
        // eslint-disable-line object-shorthand
        isActive: isMobile && _this2.state.isActive
      });
    });
  };

  _proto.handleToggleClick = function handleToggleClick(event, item) {
    if (this.state.isMobile) {
      event.preventDefault();
      var dropDowns = Object.assign({}, this.state.item);
      dropDowns[item] = dropDowns[item] === 'active' ? '' : 'active';
      this.setState({
        dropDowns: dropDowns
      });
      this.setState({
        isToggle: !this.state.isToggle
      });
      this.setState({
        isLangToggleOn: false
      });
    }
  };

  _proto.handleLanguageClick = function handleLanguageClick() {
    this.setState({
      isToggle: !this.state.isToggle,
      isLangToggleOn: !this.state.isLangToggleOn
    });
  };

  _proto.handleBurgerMenuClick = function handleBurgerMenuClick() {
    this.setState({
      isActive: this.state.isMobile && !this.state.isActive
    });
    this.props.onNavToggle(this.state.isMobile && !this.state.isActive);
  };

  _proto.renderNavDropDowns = function renderNavDropDowns(contentObj) {
    var _this3 = this;

    return Object.keys(contentObj).map(function (item) {
      var _contentObj$item = contentObj[item],
          hasDropDown = _contentObj$item.hasDropDown,
          className = _contentObj$item.className,
          topUrl = _contentObj$item.topUrl,
          topText = _contentObj$item.topText,
          ulClassName = _contentObj$item.ulClassName,
          navLinksContent = _contentObj$item.navLinksContent;
      return React.createElement(NavDropDown, {
        key: item,
        objId: item,
        className: className + " " + (_this3.state.isActive && _this3.state.isToggle ? _this3.state.dropDowns[item] : ''),
        hasDropDown: hasDropDown,
        topUrl: topUrl,
        topText: topText,
        ulClassName: ulClassName + " " + (_this3.state.isToggle && _this3.state.dropDowns[item] === 'active' ? 'open' : ''),
        navLinksContent: navLinksContent,
        handleToggleClick: _this3.handleToggleClick
      });
    });
  };

  _proto.render = function render() {
    var _this4 = this;

    var _this$props = this.props,
        isLoggedIn = _this$props.isLoggedIn,
        lang = _this$props.lang,
        className = _this$props.className,
        _this$props$mobileNav = _this$props.mobileNavContent,
        loginText = _this$props$mobileNav.loginText,
        loginUrl = _this$props$mobileNav.loginUrl,
        home = _this$props$mobileNav.home,
        homeUrl = _this$props$mobileNav.homeUrl,
        searchPlaceholder = _this$props$mobileNav.searchPlaceholder,
        contactUrl = _this$props$mobileNav.contactUrl,
        contactText = _this$props$mobileNav.contactText,
        supportUrl = _this$props$mobileNav.supportUrl,
        supportText = _this$props$mobileNav.supportText,
        languagesContent = _this$props$mobileNav.languagesContent,
        mainNavContent = _this$props.mainNavContent,
        handleSearch = _this$props.handleSearch,
        _this$props$navCta = _this$props.navCta,
        navCtaText = _this$props$navCta.navCtaText,
        navCtaUrl = _this$props$navCta.navCtaUrl,
        navCtaClass = _this$props$navCta.navCtaClass;
    return React.createElement("div", {
      className: "hsg-nav-menu " + className
    }, React.createElement("div", {
      className: "hsg-page-width-normal"
    }, React.createElement("div", {
      className: "hsg-nav__inner " + (this.state.isToggle || this.state.isLangToggleOn ? 'secondary' : '')
    }, this.state.isToggle ? React.createElement("div", {
      id: "hsg-nav__logo-caret"
    }, React.createElement("img", {
      id: "hsg-nav__logo-caret-img",
      src: "https://cdn2.hubspot.net/hubfs/53/assets/hubspot.com/global/CaretRight.svg",
      alt: "Left caret",
      onClick: this.handleToggleClick
    }), React.createElement("span", {
      id: "hsg-nav__logo-caret-home"
    }, home)) : React.createElement("a", {
      href: homeUrl,
      id: "hsg-nav__logo"
    }, React.createElement("img", {
      id: "hsg-nav__logo-desktop",
      className: "" + (this.state.isActive ? 'hide' : ''),
      src: "https://www.hubspot.com/hubfs/HubSpot_Logos/HSLogo_color.svg?t=1529954678437",
      alt: "HubSpot Logo"
    }), React.createElement("img", {
      id: "hsg-nav__logo-mobile",
      className: "" + (this.state.isActive ? '' : 'hide'),
      src: "https://cdn2.hubspot.net/hubfs/53/assets/hubspot.com/global/Sprocket.svg",
      alt: "HubSpot sprocket"
    })), React.createElement("div", {
      className: "hsg-nav__group-item--search-container " + (this.state.isActive ? '' : 'hide')
    }, React.createElement("input", {
      "data-id": "hsg-nav__search-input",
      type: "search",
      placeholder: searchPlaceholder,
      onKeyUp: function onKeyUp(e) {
        return handleSearch(e);
      }
    })), React.createElement("div", {
      id: "hsg-nav__burger-wrapper",
      className: this.state.isActive ? 'active' : '',
      onClick: function onClick(e) {
        return _this4.handleBurgerMenuClick(e);
      }
    }, this.state.isToggle || this.state.isLangToggleOn ? React.createElement("div", {
      id: "hsg-nav__burger",
      className: (this.state.isActive ? 'active' : '') + " secondary",
      onClick: this.handleToggleClick
    }, React.createElement("span", {
      className: "hsg-nav__burger-label"
    })) : React.createElement("div", {
      id: "hsg-nav__burger",
      className: "" + (this.state.isActive ? 'active' : '')
    }, React.createElement("span", {
      className: "hsg-nav__burger-label"
    }))), React.createElement("div", {
      id: "hsg-nav__groups-wrapper",
      className: this.state.isActive ? 'active' : ''
    }, React.createElement("ul", {
      className: "hsg-nav__group hsg-nav__group--primary"
    }, this.renderNavDropDowns(mainNavContent)), React.createElement("ul", {
      className: "hsg-nav__group hsg-nav__group--cta"
    }, React.createElement("li", {
      className: "hsg-nav__group-item hsg-nav__group-item--cta"
    }, React.createElement("a", {
      className: navCtaClass,
      href: navCtaUrl
    }, navCtaText))), (!this.state.isToggle || this.state.isLangToggleOn) && React.createElement("ul", {
      className: "hsg-nav__group hsg-nav__group--utility"
    }, React.createElement("li", {
      className: "hsg-nav__group-item hsg-nav__group--lang"
    }, React.createElement(StyledRegionalDropdown, {
      isMobile: this.state.isMobile,
      isToggle: this.state.isToggle,
      isLangToggleOn: this.state.isLangToggleOn,
      lang: lang || 'en',
      contactUrl: contactUrl,
      contactText: contactText,
      languagesContent: languagesContent,
      handleLanguageClick: this.handleLanguageClick
    })), !isLoggedIn && React.createElement("li", {
      className: "hsg-nav__group-item hsg-nav__group-item--login"
    }, React.createElement("a", {
      href: loginUrl
    }, loginText)), React.createElement("li", {
      className: "hsg-nav__group-item"
    }, React.createElement("a", {
      href: supportUrl
    }, supportText)))))));
  };

  return MainNav;
}(React.Component);

MainNav.propTypes = {
  className: PropTypes.string,
  mobileNavContent: PropTypes.object,
  mainNavContent: PropTypes.object,
  handleSearch: PropTypes.func,
  isLoggedIn: PropTypes.bool,
  navCta: PropTypes.object,
  lang: PropTypes.string
};

var NavLogoLink = function NavLogoLink(_ref) {
  var href = _ref.href;
  return React.createElement("a", {
    href: href,
    id: "hsg-nav__logo"
  }, React.createElement("img", {
    id: "hsg-nav__logo-desktop",
    src: "https://www.hubspot.com/hubfs/HubSpot_Logos/HSLogo_color.svg?t=1529954678437",
    alt: "HubSpot Logo"
  }), React.createElement("img", {
    id: "hsg-nav__logo-mobile",
    src: "https://cdn2.hubspot.net/hubfs/53/assets/hubspot.com/global/Sprocket.svg",
    alt: "HubSpot sprocket"
  }));
};

NavLogoLink.propTypes = {
  href: PropTypes.string
};
NavLogoLink.defaultProps = {
  href: '/'
};

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(", ", 0.79);\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n\n  .hs-page-width-normal {\n    max-width: 1080px;\n    margin: 0 auto;\n    padding: 0 2rem;\n    box-sizing: content-box;\n  }\n\n  .hsgModalFullscreenInner {\n    overflow: hidden;\n    max-width: 100%;\n  }\n\n  .modalClose {\n    cursor: pointer;\n    display: block;\n    position: fixed;\n    top: 1.5rem;\n    right: 1.5rem;\n    color: ", ";\n    text-align: center;\n    border-radius: 50%;\n    transition: background-color 0.15s ease-out;\n    width: 2.5rem;\n    height: 2.5rem;\n    z-index: 2;\n\n    &:hover {\n      background-color: rgba(", ", 0.1);\n    }\n\n    &::before,\n    &::after {\n      content: '';\n      display: block;\n      position: absolute;\n      top: 50%;\n      left: 20%;\n      background-color: ", ";\n      border-radius: 0.125rem;\n      width: 60%;\n      height: 0.125rem;\n    }\n\n    &::before {\n      transform: rotate(-45deg);\n    }\n\n    &::after {\n      transform: rotate(45deg);\n    }\n  }\n\n  .hsg-search {\n    &__modal-header {\n      position: fixed;\n      top: 0;\n      left: 0;\n      background: linear-gradient(45deg, ", ", ", ");\n      box-shadow: 0 10px 50px -5px rgba(", ", 0.12);\n      width: 100%;\n      z-index: 1;\n\n      > div {\n        @media (min-width: 768px) {\n          display: flex;\n          flex-direction: row;\n        }\n      }\n    }\n\n    &__modal-input {\n      &::-webkit-input-placeholder {\n        color: ", ";\n      }\n\n      &::-moz-placeholder {\n        color: ", ";\n      }\n\n      &:-ms-input-placeholder {\n        color: ", ";\n      }\n\n      appearance: none;\n      display: block;\n      position: relative;\n      background-color: transparent;\n      color: ", ";\n      font-size: 1.5rem;\n      outline: none;\n      border: 0;\n      width: 100%;\n      margin-top: 1rem;\n      padding-right: 3.75rem;\n\n      @media (min-width: 768px) {\n        flex: 2;\n        margin-top: 0;\n        padding-right: 1rem;\n      }\n    }\n\n    &__modal-search-options {\n      display: flex;\n      flex-flow: row wrap;\n      padding: 0.5rem 0;\n\n      @media (min-width: 768px) {\n        flex-flow: column wrap;\n        flex: 1;\n      }\n\n      label {\n        display: block;\n        color: ", ";\n        font-size: 0.875rem;\n        padding: 0.5rem 1rem 0.5rem 0;\n\n        @media (min-width: 768px) {\n          padding: 0.5rem 0.75rem;\n        }\n      }\n\n      input {\n        position: relative;\n        margin-right: 1rem;\n\n        &:checked {\n          &::before {\n            width: 0.875rem;\n            height: 0.875rem;\n            background-color: ", ";\n            border: 2px solid ", ";\n          }\n        }\n\n        &::before {\n          content: '';\n          display: inline-block;\n          position: absolute;\n          top: -2px;\n          left: -1px;\n          background-color: ", ";\n          border-radius: 50%;\n          width: 1.125rem;\n          height: 1.125rem;\n        }\n      }\n    }\n\n    &__results {\n      position: relative;\n      padding: 9rem 0 4rem;\n\n      &.no-results {\n        max-width: 900px;\n        margin: 0 auto;\n        padding-left: 30px;\n        padding-right: 30px;\n\n        h6 {\n          color: ", ";\n        }\n\n        p {\n          color: ", ";\n          font-size: 36px;\n          letter-spacing: 0.1em;\n          margin: 0;\n\n          @media (max-width: 500px) {\n            font-size: 24px;\n          }\n        }\n      }\n    }\n\n    &-item {\n      overflow: hidden;\n      background-color: ", ";\n      border-radius: 0.1875rem;\n      margin-bottom: 1.5rem;\n      padding: 1.5rem 2rem;\n\n      @media (min-width: 501px) {\n        display: flex;\n        align-items: center;\n      }\n\n      .title {\n        @media (min-width: 501px) {\n          flex: 2;\n          padding-right: 2rem;\n        }\n\n        a {\n          font-size: 1rem;\n          font-weight: 700;\n          line-height: 1.5;\n          display: block;\n          padding: 1.5rem 0;\n          color: ", ";\n\n          &:hover {\n            text-decoration: underline;\n            color: ", ";\n          }\n        }\n\n        p {\n          display: none;\n        }\n      }\n\n      .snippet {\n        border-style: solid;\n        border-color: ", ";\n        border-width: 1px 0 0;\n\n        @media (min-width: 501px) {\n          flex: 3;\n          border-width: 0 0 0 1px;\n          padding-left: 2rem;\n        }\n      }\n    }\n\n    &__container {\n      display: block;\n      text-align: center;\n\n      &.hsg-search__default-state h6 {\n          color: $colorFontLight;\n      }\n\n      a.cta {\n        cursor: pointer;\n        display: inline-block;\n        line-height: 1.25;\n        border: 0;\n        border-radius: .1875rem;\n        transition: 0.15s color ease-out, 0.15s background-color ease-out, 0.15s border-color ease-out;\n        background-color: ", ";\n        color: ", ";\n        font-weight: 600;\n        padding: 1.625rem 3rem;\n\n        &:hover {\n          background-color: ", ";\n        }\n      }\n    }\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  position: relative;\n  background-color: ", ";\n  color: ", ";\n  z-index: 90;\n\n  .hsg-nav__inner {\n    padding-top: 1.25rem;\n  }\n\n  #hsg-nav__logo {\n    display: flex;\n    align-items: center;\n\n    #hsg-nav__logo-desktop {\n      &.hide {\n        display: none;\n      }\n    }\n\n    #hsg-nav__logo-mobile {\n      display: block;\n      height: 2rem;\n      width: 2rem;\n      margin-right: 1rem;\n\n      &.hide {\n        display: none;\n      }\n\n      @media (min-width: 768px) {\n        display: none;\n      }\n    }\n\n    @media (min-width: 768px) {\n      margin: 0.5rem 1.5rem 1rem 0;\n    }\n  }\n\n  .hsg-nav__dropdown-row--links-subheader h4 {\n    @media (max-width: 767px) {\n      text-align: center;\n      text-transform: uppercase;\n      font-size: 0.875rem !important;\n      background-color: ", ";\n      padding: 0.5rem 0;\n      border-bottom: 1px solid ", ";\n      margin-bottom: 0 !important;\n    }\n  }\n\n  #hsg-nav__logo-caret {\n    display: flex;\n    align-items: center;\n    margin-right: 1rem;\n\n    @media (min-width: 768px) {\n      display: none;\n    }\n  }\n\n  #hsg-nav__logo-caret-img {\n    display: block;\n    height: 2rem;\n    width: 1rem;\n    transform: rotate(180deg);\n    cursor: pointer;\n  }\n\n  #hsg-nav__logo-caret-home {\n    display: contents;\n    font-size: 0.6rem;\n    font-weight: 600;\n    line-height: 1.5;\n    text-transform: uppercase;\n    color: ", ";\n  }\n\n  #hsg-nav__burger-wrapper {\n    cursor: pointer;\n    transform: translateY(-50%);\n    width: 2rem;\n    padding: 0.5rem 0;\n    margin: 1rem 0 0 0.5rem;\n\n    #hsg-nav__burger {\n      transform: rotate(0deg);\n      transition: transform 0.3s ease-out;\n\n      &.active {\n        transform: rotate(90deg);\n\n        .hsg-nav__burger-label {\n          background-color: transparent;\n\n          &::before, &::after {\n            background-color: ", ";\n            transform: rotate(-135deg);\n          }\n\n          &::after {\n            transform: rotate(135deg);\n          }\n        }\n\n        &.secondary {\n          .hsg-nav__burger-label {\n            &::before, &::after {\n              background-color: ", ";\n            }\n          }\n        }\n      }\n\n      .hsg-nav__burger-label {\n        display: block;\n        background-color: ", ";\n        border-radius: 1rem;\n        width: 120%;\n        height: 0.2rem;\n        position: relative;\n        left: -15%;\n\n        &::before, &::after {\n          display: block;\n          background-color: ", ";\n          border-radius: 1rem;\n          width: 80%;\n          height: 0.2rem;\n          content: '';\n          position: absolute;\n          top: 0;\n          left: 10%;\n          transform: translateY(-0.5rem);\n        }\n\n        &::after {\n          transform: translateY(0.5rem);\n        }\n      }\n    }\n\n    @media (min-width: 768px) {\n      display: none;\n    }\n  }\n\n  #hsg-nav__groups-wrapper {\n    display: none;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    background-color: ", ";\n    border-radius: 0 0.1875rem 0.1875rem 0;\n    height: 100vh;\n    width: 100%;\n\n    .hsg-nav__group--nav-bar {\n      position: relative;\n      padding: 1rem 0;\n\n      &::after {\n        content: '';\n        position: absolute;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        background-color: ", ";\n        width: calc(100% - 3rem);\n        height: 1px;\n        margin: auto;\n      }\n\n      @media (min-width: 768px) {\n        display: none;\n      }\n    }\n\n    .hsg-nav__group--primary {\n      padding-top: 1rem;\n      max-height: 60vh;\n\n      .hsg-nav__link-wrapper {\n        @media (min-width: 768px) {\n          padding-bottom: 1.25rem;\n        }\n      }\n\n      &.active {\n        max-height: 0;\n        min-height: 0;\n      }\n\n      @media (min-width: 768px) {\n        padding: 0;\n        overflow-y: visible;\n        min-height: 50px;\n      }\n\n      .hsg-nav__group-item--has-dropdown {\n        @media (min-width: 768px) {\n          &:hover {\n            .hsg-nav__link-wrapper {\n              ::after {\n                content: \"\";\n                background: ", ";\n                height: 5px;\n                width: 100%;\n                position: absolute;\n                bottom: -0.25rem;\n                left: 0;\n                z-index: 100;\n                border-radius: .1875rem;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    &.active {\n      display: flex;\n      flex-direction: column;\n    }\n\n    @media (min-width: 768px) {\n      flex-shrink: 0;\n      align-self: flex-start;\n      display: flex;\n      position: static;\n      background-color: transparent;\n      border-radius: 0;\n      max-height: none;\n      height: auto;\n      max-width: calc(100% - 140px);\n      font-size: inherit;\n      justify-content: space-between;\n    }\n  }\n\n  .hsg-nav__group--primary {\n    .hsg-nav__group-item {\n      @media (max-width: 767px) {\n        padding: 0 1rem;\n        margin: 1rem;\n        background: ", "\n        box-shadow: 0 1px 5px 0 rgba(", ", 0.12);\n        border: 1px solid ", ";\n        border-radius: .1875rem;\n      }\n    }\n  }\n\n  .hsg-nav__group-item {\n    padding: 0 1.5rem;\n    border-bottom: 1px solid ", ";\n\n    &:hover {\n      a[href*=\"/\"] {\n        .hsg-nav__link-label {\n          color: ", ";\n          text-decoration: underline;\n          font-weight: 600;\n        }\n      }\n    }\n    \n    &.hsg-nav__group-item--order-1 {\n      .hsg-nav__dropdown-list {\n        @media (min-width: 768px) {\n          max-width: 1080px;\n          grid: 0.25fr 1fr 0.25fr / 1fr;\n          left: 0;\n          background: ", ";\n          \n          .hsg-nav__dropdown-column {\n            width: 100%;\n            text-align: center;\n          }\n\n          .hsg-nav__box-link {\n            color: ", ";\n          }\n\n          .hsg-nav__subheader {\n            &::after {\n              content: '\u2192';\n              color: ", ";\n              font-weight: 600;\n              padding-left: 0.25rem;\n            }\n            .highlight {\n              color: ", ";\n              font-weight: 600;\n\n              &:hover {\n                text-decoration: underline;\n              }\n            }\n          }\n\n          .hsg-nav__dropdown-row {\n            &:nth-child(2) {\n              grid-area: 1/1/2/2;\n              background: ", ";\n              padding: 0;\n              margin: 32px 96px 0;\n\n              .hsg-nav__box-link-none {\n                padding: 0 0.5rem;\n                text-align: center;\n                display: block;\n                width: 100%;\n\n                .hsg-nav__subheader {\n                  max-width: none;\n\n                  &::after {\n                    content: \"\";\n                  }\n                }\n              }\n              .hsg-nav__box-link {\n                display: inline-block;\n                padding: 0.75rem 4rem;\n                background: ", ";\n                border: 1px solid ", ";\n                margin: 0.5rem;\n                color: ", ";\n                \n                &:hover {\n                  box-shadow: rgba(51,71,91,0.12) 0 0 10px -3px;\n                }\n\n                .hsg-nav__subheader,\n                .hsg-nav__header {\n                  display: inline-block;\n                  font-size: .875rem;\n                  font-weight: 600;\n                  margin: 0;\n                }\n              }\n              .hsg-nav__header {\n                font-size: 1.125rem;\n                font-weight: 500;\n                margin-bottom: 0.5rem;\n              }\n              .hsg-nav__subheader {\n                font-size: 0.875rem;\n                max-width: 8rem;\n              }\n            }\n            &:nth-child(3) {\n              display: grid;\n              grid: 1fr 1fr / 1fr 1fr 1fr;\n              margin: 0 96px 8px;\n              padding: 0;\n\n              .hsg-nav__box-link {\n                display: flex;\n                background: ", ";\n                border: 1px solid ", ";\n                padding: 16px 14px;\n                margin: 0.5rem;\n\n                &:lang(fr) {\n                  padding: 16px 11px;\n                }\n\n                &:lang(ja) {\n                  padding: 16px 10px;\n                }\n\n                &:hover {\n                  box-shadow: rgba(51,71,91,0.12) 0 0 10px -3px;\n                }\n\n                .hsg-nav__box-link-icon {\n                  @media (min-width: 768px) {\n                    background-color: ", "\n                    padding: 0 8px 16px;\n                  }\n                }\n                .hsg-nav__header {\n                  margin-bottom: 0.5rem;\n                }\n              }\n            }\n            &.hsg-nav__dropdown-row--links-horizontal {\n              grid-area: 3/1/4/1;\n              justify-content: flex-start;\n              border-top: 1px solid ", ";\n              background: ", ";\n\n              @media (min-width: 768px) {\n                border-top: 1px solid ", ";\n\n                .hsg-nav__box-link {\n                  padding: 0;\n                }\n\n                .hsg-nav__header {\n                  display: block;\n                  font-size: 1rem;\n                }\n\n                .hsg-nav__subheader {\n                  font-size: .75rem;\n                }\n              }\n            }\n          }\n        }\n        @media (max-width: 767px) {\n\n          .hsg-nav__box-link-none {\n            text-align: center;\n            margin-top: 24px;\n\n            .hsg-nav__subheader {\n              max-width: 90%;\n              margin: 0 auto 24px;\n            }\n          }\n        }\n      }\n    }\n\n    &.hsg-nav__group-item--order-3 {\n      .hsg-nav__dropdown-list {\n        columns: 1;\n      }\n\n      @media (min-width: 768px) {\n        .hsg-nav__dropdown-list {\n          flex-direction: column;\n          width: 800px;\n          max-height: 550px;\n          flex-wrap: wrap;\n          padding: 1rem .5rem;\n          left: 5vw;\n          right: auto;\n          columns: 2;\n\n          [lang=\"de\"] & {\n            max-height: 550px;\n          }\n\n          .hsg-nav__dropdown-row {\n            padding: .75rem;\n            justify-content: flex-start;\n            max-width: 50%;\n\n            .hsg-nav__box-link-icon {\n              margin-bottom: 0;\n              background: ", ";\n              margin-right: .555rem;\n              height: 2.2rem;\n              padding: 8px;\n            }\n\n            .hsg-nav__header {\n              font-weight: 700;\n              font-size: 1rem;\n              margin-top: 0.5rem;\n            }\n\n            .hsg-nav__box-link {\n              padding: .25rem 0 .5rem 0;\n            }\n\n            .hsg-nav__subheader {\n              a {\n                font-size: 1rem;\n                font-weight: 400;\n\n                &:hover {\n                  color: ", ";\n                  text-decoration: underline;\n                  font-weight: 500;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      @media (max-width: 767px) {\n        .hsg-nav__dropdown-list {\n          .hsg-nav__dropdown-list-title,\n          .hsg-nav__box-link-icon {\n            display: none;\n          }\n          .hsg-nav__dropdown-list-title {\n            margin-top: 1rem;\n          }\n          .hsg-nav__dropdown-row {\n            .hsg-nav__header {\n              text-align: center;\n              font-size: 1.25rem;\n              font-weight: 400;\n              padding-top: 1rem;\n            }\n            .hsg-nav__box-link {\n              padding: 1rem 3.5rem 1rem 1rem;\n\n              .hsg-nav__subheader {\n                font-size: 1rem;\n                font-weight: 500;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    &.hsg-nav__group-item--order-4 {\n      @media (min-width: 768px) {\n        display: none;\n      }\n      & .hsg-nav__dropdown-list {\n        &.hsg-nav__dropdown-cards {\n          .hsg-nav__box-link {\n            @media (max-width: 767px) {\n              padding: 0 0 0 1rem;\n            }\n          }\n        }\n      }\n      @media (max-width: 767px) {\n        .hsg-nav__subheader {\n          font-weight: 500;\n        }\n      }\n    }\n\n    .hsg-nav__dropdown-list {\n      cursor: auto;\n      font-size: 0.875rem;\n      margin: 0 auto;\n      background-color: transparent;\n      overflow: hidden;\n      display: none;\n\n      @media (max-width: 767px) {\n        position: absolute;\n        display: block;\n        top: 0;\n        left: 200%;\n        bottom: 0;\n        width: 0;\n        transition: all 1s ease;\n      }\n\n      &.open {\n        left: 0;\n        right: 0;\n        overflow: scroll;\n        margin-bottom: 4rem;\n        z-index: 10;\n        background-color: ", ";\n        width: 100%;\n        transition: all 0.5s ease;\n      }\n\n      .hsg-nav__dropdown-list-title {\n        display: none;\n\n        @media (max-width: 767px) {\n          display: block;\n          text-align: center;\n          padding-top: 1rem;\n          font-size: 1.25rem;\n          font-weight: 400;\n          background-color: ", ";\n          border-bottom: 1px solid ", ";\n          margin: 0;\n        }\n      }\n\n      &.hsg-nav__dropdown-cards {\n\n        @media (max-width: 767px) {\n          background-color: ", ";\n        }\n\n        .hsg-nav__dropdown-list-title {\n          border-bottom: 0;\n        }\n\n        .hsg-nav__box-link {\n          @media (max-width: 767px) {\n            border: 1px solid ", ";\n            border-radius: 0.1875rem;\n            margin: 1rem;\n            position: relative;\n            padding: 1.5rem 3.5rem 1.5rem 1rem;\n            background: ", ";\n            box-shadow: 0 1px 5px 0 rgba(", ", 0.12);\n\n            &::after {\n              content: '\\E003';\n              display: inline-block;\n              position: absolute;\n              color: ", ";\n              font-family: 'hsg-icons';\n              font-size: 1.25rem;\n              line-height: 1;\n              font-weight: bold;\n              margin: 0 0.25rem 0.25rem 1rem;\n              vertical-align: middle;\n              transform: rotate(-90deg);\n              right: 1rem;\n              top: calc(50% - 10px);\n            }\n          }\n        }\n      }\n\n      .hsg-nav__dropdown-row {\n\n        &--links-horizontal {\n          h3.hsg-nav__header {\n            display: inline-block;\n            margin-right: 1em;\n          }\n\n          p {\n            display: inline-block;\n\n            @media (max-width: 767px) {\n              width: 100%;\n            }\n          }\n        }\n\n        .hsg-nav__header {\n          position: relative;\n          margin: 0 0 0.5rem;\n          font-size: 18px;\n          font-weight: 500;\n\n          @media (max-width: 767px) {\n            font-size: 1rem;\n          }\n        }\n\n        span.hsg-nav__ribbon {\n          background-color: ", ";\n          color: ", ";\n          font-size: 0.625rem;\n          font-weight: 700;\n          padding: 0.25rem 0.5rem;\n          border-radius: 0.1875rem;\n          text-align: center;\n          text-transform: uppercase;\n          margin-right: 5px;\n          display: inline-block;\n          vertical-align: top;\n        }\n\n        .hsg-nav__subheader {\n          font-size: 1em;\n          margin: 0;\n          font-weight: 400;\n        }\n\n        .hsg-nav__link-group {\n          position: relative;\n\n          a {\n            display: block;\n            padding: 0.5rem 1rem;\n            font-weight: 400;\n            font-size: 0.875rem;\n\n            @media (max-width: 767px) {\n              border-bottom: 1px solid ", ";\n            }\n\n            &:hover {\n              background-color: ", ";\n            }\n\n            &.hsg-en-link {\n              span {\n                display: inline-block;\n                position: relative;\n                padding-right: 2.25rem;\n\n                &::before {\n                  content: 'EN';\n                  position: absolute;\n                  top: 0.12rem;\n                  right: 0.2rem;\n                  background-color: ", ";\n                  color: ", ";\n                  font-size: 0.625rem;\n                  font-weight: 700;\n                  line-height: 0.8;\n                  border-radius: 0.1875rem;\n                  box-sizing: content-box;\n                  transition: opacity 0.15s ease-out;\n                  height: 0.5rem;\n                  padding: 0.25rem;\n                  opacity: 1;\n                }\n              }\n            }\n          }\n\n          @media (min-width: 768px) {\n            left: -1rem;\n            width: calc(100% + 1rem);\n          }\n        }\n\n        @media (min-width: 768px) {\n          display: flex;\n          -webkit-box-pack: justify;\n          justify-content: space-between;\n          padding: 1rem;\n        }\n      }\n\n      .hsg-nav__box-link {\n        display: block;\n        padding: 0.75rem;\n        -webkit-tap-highlight-color: ", ";\n\n        [lang=\"de\"] &,\n        [lang=\"fr\"] & {\n          padding: 0.5rem;\n        }\n\n        @media (min-width: 768px) {\n          border-radius: 0.1875rem;\n          margin-bottom: 0;\n        }\n\n        @media (max-width: 767px) {\n          border-bottom: 1px solid ", ";\n        }\n      }\n\n      .hsg-nav__box-link-icon {\n        float: left;\n        padding: 6px;\n        height: 2.2rem;\n        margin-right: 0.555rem;\n\n        @media (max-width: 767px) {\n          margin-bottom: 3rem;\n          padding-top: 0;\n          height: 2rem;\n        }\n      }\n\n      @media (min-width: 768px) {\n        position: absolute;\n        top: calc(100% + 1rem);\n        background-color: ", ";\n        border: 1px solid ", ";\n        border-radius: .1875rem;\n        box-shadow: 0 1px 24px rgba(", ", 0.12);\n        z-index: 95;\n        right: 0;\n        transition: none;\n        margin-top: -1rem;\n      }\n    }\n\n    .hsg-nav__link {\n      display: block;\n      padding: 1rem 0;\n      -webkit-tap-highlight-color: ", ";\n      font-weight: 500;\n\n      @media (min-width: 768px) {\n        display: inline-block;\n        padding: 1rem 0 0 0;\n      }\n    }\n\n    .hsg-nav__link-label {\n      display: inline-block;\n      padding: 0;\n\n      @media (max-width: 767px) {\n        display: flex;\n        justify-content: space-between;\n      }\n\n      &::after {\n        @media (max-width: 767px) {\n          content: '\\E003';\n          display: inline-block;\n          position: relative;\n          color: ", ";\n          font-family: 'hsg-icons';\n          font-size: 1.25rem;\n          line-height: 1;\n          font-weight: bold;\n          margin: 0 0.25rem 0.25rem 1rem;\n          vertical-align: middle;\n          transform: rotate(-90deg);\n        }\n      }\n\n      .hsg-icon {\n        display: inline-block;\n        font-size: 1.125rem;\n        line-height: 1;\n        vertical-align: middle;\n        margin-right: 0.625rem;\n\n        &::before {\n          font-family: \"hsg-icons\";\n          -webkit-font-smoothing: antialiased;\n          font-style: normal;\n          font-variant: normal;\n          font-weight: normal;\n          text-decoration: none;\n          text-transform: none;\n        }\n\n        &.hsg-icon-email {\n          &::before {\n            content: \"\\E017\";\n          }\n        }\n      }\n\n      @media (min-width: 768px) and (max-width: 1023px) {\n        padding: 0 0.5rem;\n      }\n\n      @media (min-width: 1024px) {\n        padding: 0 1rem;\n      }\n    }\n\n    @media (min-width: 768px) {\n      display: inline-block;\n      padding: 0;\n      border-bottom: 0;\n    }\n  }\n"], ["\n  display: block;\n  position: relative;\n  background-color: ", ";\n  color: ", ";\n  z-index: 90;\n\n  .hsg-nav__inner {\n    padding-top: 1.25rem;\n  }\n\n  #hsg-nav__logo {\n    display: flex;\n    align-items: center;\n\n    #hsg-nav__logo-desktop {\n      &.hide {\n        display: none;\n      }\n    }\n\n    #hsg-nav__logo-mobile {\n      display: block;\n      height: 2rem;\n      width: 2rem;\n      margin-right: 1rem;\n\n      &.hide {\n        display: none;\n      }\n\n      @media (min-width: 768px) {\n        display: none;\n      }\n    }\n\n    @media (min-width: 768px) {\n      margin: 0.5rem 1.5rem 1rem 0;\n    }\n  }\n\n  .hsg-nav__dropdown-row--links-subheader h4 {\n    @media (max-width: 767px) {\n      text-align: center;\n      text-transform: uppercase;\n      font-size: 0.875rem !important;\n      background-color: ", ";\n      padding: 0.5rem 0;\n      border-bottom: 1px solid ", ";\n      margin-bottom: 0 !important;\n    }\n  }\n\n  #hsg-nav__logo-caret {\n    display: flex;\n    align-items: center;\n    margin-right: 1rem;\n\n    @media (min-width: 768px) {\n      display: none;\n    }\n  }\n\n  #hsg-nav__logo-caret-img {\n    display: block;\n    height: 2rem;\n    width: 1rem;\n    transform: rotate(180deg);\n    cursor: pointer;\n  }\n\n  #hsg-nav__logo-caret-home {\n    display: contents;\n    font-size: 0.6rem;\n    font-weight: 600;\n    line-height: 1.5;\n    text-transform: uppercase;\n    color: ", ";\n  }\n\n  #hsg-nav__burger-wrapper {\n    cursor: pointer;\n    transform: translateY(-50%);\n    width: 2rem;\n    padding: 0.5rem 0;\n    margin: 1rem 0 0 0.5rem;\n\n    #hsg-nav__burger {\n      transform: rotate(0deg);\n      transition: transform 0.3s ease-out;\n\n      &.active {\n        transform: rotate(90deg);\n\n        .hsg-nav__burger-label {\n          background-color: transparent;\n\n          &::before, &::after {\n            background-color: ", ";\n            transform: rotate(-135deg);\n          }\n\n          &::after {\n            transform: rotate(135deg);\n          }\n        }\n\n        &.secondary {\n          .hsg-nav__burger-label {\n            &::before, &::after {\n              background-color: ", ";\n            }\n          }\n        }\n      }\n\n      .hsg-nav__burger-label {\n        display: block;\n        background-color: ", ";\n        border-radius: 1rem;\n        width: 120%;\n        height: 0.2rem;\n        position: relative;\n        left: -15%;\n\n        &::before, &::after {\n          display: block;\n          background-color: ", ";\n          border-radius: 1rem;\n          width: 80%;\n          height: 0.2rem;\n          content: '';\n          position: absolute;\n          top: 0;\n          left: 10%;\n          transform: translateY(-0.5rem);\n        }\n\n        &::after {\n          transform: translateY(0.5rem);\n        }\n      }\n    }\n\n    @media (min-width: 768px) {\n      display: none;\n    }\n  }\n\n  #hsg-nav__groups-wrapper {\n    display: none;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    background-color: ", ";\n    border-radius: 0 0.1875rem 0.1875rem 0;\n    height: 100vh;\n    width: 100%;\n\n    .hsg-nav__group--nav-bar {\n      position: relative;\n      padding: 1rem 0;\n\n      &::after {\n        content: '';\n        position: absolute;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        background-color: ", ";\n        width: calc(100% - 3rem);\n        height: 1px;\n        margin: auto;\n      }\n\n      @media (min-width: 768px) {\n        display: none;\n      }\n    }\n\n    .hsg-nav__group--primary {\n      padding-top: 1rem;\n      max-height: 60vh;\n\n      .hsg-nav__link-wrapper {\n        @media (min-width: 768px) {\n          padding-bottom: 1.25rem;\n        }\n      }\n\n      &.active {\n        max-height: 0;\n        min-height: 0;\n      }\n\n      @media (min-width: 768px) {\n        padding: 0;\n        overflow-y: visible;\n        min-height: 50px;\n      }\n\n      .hsg-nav__group-item--has-dropdown {\n        @media (min-width: 768px) {\n          &:hover {\n            .hsg-nav__link-wrapper {\n              ::after {\n                content: \"\";\n                background: ", ";\n                height: 5px;\n                width: 100%;\n                position: absolute;\n                bottom: -0.25rem;\n                left: 0;\n                z-index: 100;\n                border-radius: .1875rem;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    &.active {\n      display: flex;\n      flex-direction: column;\n    }\n\n    @media (min-width: 768px) {\n      flex-shrink: 0;\n      align-self: flex-start;\n      display: flex;\n      position: static;\n      background-color: transparent;\n      border-radius: 0;\n      max-height: none;\n      height: auto;\n      max-width: calc(100% - 140px);\n      font-size: inherit;\n      justify-content: space-between;\n    }\n  }\n\n  .hsg-nav__group--primary {\n    .hsg-nav__group-item {\n      @media (max-width: 767px) {\n        padding: 0 1rem;\n        margin: 1rem;\n        background: ", "\n        box-shadow: 0 1px 5px 0 rgba(", ", 0.12);\n        border: 1px solid ", ";\n        border-radius: .1875rem;\n      }\n    }\n  }\n\n  .hsg-nav__group-item {\n    padding: 0 1.5rem;\n    border-bottom: 1px solid ", ";\n\n    &:hover {\n      a[href*=\"/\"] {\n        .hsg-nav__link-label {\n          color: ", ";\n          text-decoration: underline;\n          font-weight: 600;\n        }\n      }\n    }\n    \n    &.hsg-nav__group-item--order-1 {\n      .hsg-nav__dropdown-list {\n        @media (min-width: 768px) {\n          max-width: 1080px;\n          grid: 0.25fr 1fr 0.25fr / 1fr;\n          left: 0;\n          background: ", ";\n          \n          .hsg-nav__dropdown-column {\n            width: 100%;\n            text-align: center;\n          }\n\n          .hsg-nav__box-link {\n            color: ", ";\n          }\n\n          .hsg-nav__subheader {\n            &::after {\n              content: '\u2192';\n              color: ", ";\n              font-weight: 600;\n              padding-left: 0.25rem;\n            }\n            .highlight {\n              color: ", ";\n              font-weight: 600;\n\n              &:hover {\n                text-decoration: underline;\n              }\n            }\n          }\n\n          .hsg-nav__dropdown-row {\n            &:nth-child(2) {\n              grid-area: 1/1/2/2;\n              background: ", ";\n              padding: 0;\n              margin: 32px 96px 0;\n\n              .hsg-nav__box-link-none {\n                padding: 0 0.5rem;\n                text-align: center;\n                display: block;\n                width: 100%;\n\n                .hsg-nav__subheader {\n                  max-width: none;\n\n                  &::after {\n                    content: \"\";\n                  }\n                }\n              }\n              .hsg-nav__box-link {\n                display: inline-block;\n                padding: 0.75rem 4rem;\n                background: ", ";\n                border: 1px solid ", ";\n                margin: 0.5rem;\n                color: ", ";\n                \n                &:hover {\n                  box-shadow: rgba(51,71,91,0.12) 0 0 10px -3px;\n                }\n\n                .hsg-nav__subheader,\n                .hsg-nav__header {\n                  display: inline-block;\n                  font-size: .875rem;\n                  font-weight: 600;\n                  margin: 0;\n                }\n              }\n              .hsg-nav__header {\n                font-size: 1.125rem;\n                font-weight: 500;\n                margin-bottom: 0.5rem;\n              }\n              .hsg-nav__subheader {\n                font-size: 0.875rem;\n                max-width: 8rem;\n              }\n            }\n            &:nth-child(3) {\n              display: grid;\n              grid: 1fr 1fr / 1fr 1fr 1fr;\n              margin: 0 96px 8px;\n              padding: 0;\n\n              .hsg-nav__box-link {\n                display: flex;\n                background: ", ";\n                border: 1px solid ", ";\n                padding: 16px 14px;\n                margin: 0.5rem;\n\n                &:lang(fr) {\n                  padding: 16px 11px;\n                }\n\n                &:lang(ja) {\n                  padding: 16px 10px;\n                }\n\n                &:hover {\n                  box-shadow: rgba(51,71,91,0.12) 0 0 10px -3px;\n                }\n\n                .hsg-nav__box-link-icon {\n                  @media (min-width: 768px) {\n                    background-color: ", "\n                    padding: 0 8px 16px;\n                  }\n                }\n                .hsg-nav__header {\n                  margin-bottom: 0.5rem;\n                }\n              }\n            }\n            &.hsg-nav__dropdown-row--links-horizontal {\n              grid-area: 3/1/4/1;\n              justify-content: flex-start;\n              border-top: 1px solid ", ";\n              background: ", ";\n\n              @media (min-width: 768px) {\n                border-top: 1px solid ", ";\n\n                .hsg-nav__box-link {\n                  padding: 0;\n                }\n\n                .hsg-nav__header {\n                  display: block;\n                  font-size: 1rem;\n                }\n\n                .hsg-nav__subheader {\n                  font-size: .75rem;\n                }\n              }\n            }\n          }\n        }\n        @media (max-width: 767px) {\n\n          .hsg-nav__box-link-none {\n            text-align: center;\n            margin-top: 24px;\n\n            .hsg-nav__subheader {\n              max-width: 90%;\n              margin: 0 auto 24px;\n            }\n          }\n        }\n      }\n    }\n\n    &.hsg-nav__group-item--order-3 {\n      .hsg-nav__dropdown-list {\n        columns: 1;\n      }\n\n      @media (min-width: 768px) {\n        .hsg-nav__dropdown-list {\n          flex-direction: column;\n          width: 800px;\n          max-height: 550px;\n          flex-wrap: wrap;\n          padding: 1rem .5rem;\n          left: 5vw;\n          right: auto;\n          columns: 2;\n\n          [lang=\"de\"] & {\n            max-height: 550px;\n          }\n\n          .hsg-nav__dropdown-row {\n            padding: .75rem;\n            justify-content: flex-start;\n            max-width: 50%;\n\n            .hsg-nav__box-link-icon {\n              margin-bottom: 0;\n              background: ", ";\n              margin-right: .555rem;\n              height: 2.2rem;\n              padding: 8px;\n            }\n\n            .hsg-nav__header {\n              font-weight: 700;\n              font-size: 1rem;\n              margin-top: 0.5rem;\n            }\n\n            .hsg-nav__box-link {\n              padding: .25rem 0 .5rem 0;\n            }\n\n            .hsg-nav__subheader {\n              a {\n                font-size: 1rem;\n                font-weight: 400;\n\n                &:hover {\n                  color: ", ";\n                  text-decoration: underline;\n                  font-weight: 500;\n                }\n              }\n            }\n          }\n        }\n      }\n\n      @media (max-width: 767px) {\n        .hsg-nav__dropdown-list {\n          .hsg-nav__dropdown-list-title,\n          .hsg-nav__box-link-icon {\n            display: none;\n          }\n          .hsg-nav__dropdown-list-title {\n            margin-top: 1rem;\n          }\n          .hsg-nav__dropdown-row {\n            .hsg-nav__header {\n              text-align: center;\n              font-size: 1.25rem;\n              font-weight: 400;\n              padding-top: 1rem;\n            }\n            .hsg-nav__box-link {\n              padding: 1rem 3.5rem 1rem 1rem;\n\n              .hsg-nav__subheader {\n                font-size: 1rem;\n                font-weight: 500;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    &.hsg-nav__group-item--order-4 {\n      @media (min-width: 768px) {\n        display: none;\n      }\n      & .hsg-nav__dropdown-list {\n        &.hsg-nav__dropdown-cards {\n          .hsg-nav__box-link {\n            @media (max-width: 767px) {\n              padding: 0 0 0 1rem;\n            }\n          }\n        }\n      }\n      @media (max-width: 767px) {\n        .hsg-nav__subheader {\n          font-weight: 500;\n        }\n      }\n    }\n\n    .hsg-nav__dropdown-list {\n      cursor: auto;\n      font-size: 0.875rem;\n      margin: 0 auto;\n      background-color: transparent;\n      overflow: hidden;\n      display: none;\n\n      @media (max-width: 767px) {\n        position: absolute;\n        display: block;\n        top: 0;\n        left: 200%;\n        bottom: 0;\n        width: 0;\n        transition: all 1s ease;\n      }\n\n      &.open {\n        left: 0;\n        right: 0;\n        overflow: scroll;\n        margin-bottom: 4rem;\n        z-index: 10;\n        background-color: ", ";\n        width: 100%;\n        transition: all 0.5s ease;\n      }\n\n      .hsg-nav__dropdown-list-title {\n        display: none;\n\n        @media (max-width: 767px) {\n          display: block;\n          text-align: center;\n          padding-top: 1rem;\n          font-size: 1.25rem;\n          font-weight: 400;\n          background-color: ", ";\n          border-bottom: 1px solid ", ";\n          margin: 0;\n        }\n      }\n\n      &.hsg-nav__dropdown-cards {\n\n        @media (max-width: 767px) {\n          background-color: ", ";\n        }\n\n        .hsg-nav__dropdown-list-title {\n          border-bottom: 0;\n        }\n\n        .hsg-nav__box-link {\n          @media (max-width: 767px) {\n            border: 1px solid ", ";\n            border-radius: 0.1875rem;\n            margin: 1rem;\n            position: relative;\n            padding: 1.5rem 3.5rem 1.5rem 1rem;\n            background: ", ";\n            box-shadow: 0 1px 5px 0 rgba(", ", 0.12);\n\n            &::after {\n              content: '\\\\E003';\n              display: inline-block;\n              position: absolute;\n              color: ", ";\n              font-family: 'hsg-icons';\n              font-size: 1.25rem;\n              line-height: 1;\n              font-weight: bold;\n              margin: 0 0.25rem 0.25rem 1rem;\n              vertical-align: middle;\n              transform: rotate(-90deg);\n              right: 1rem;\n              top: calc(50% - 10px);\n            }\n          }\n        }\n      }\n\n      .hsg-nav__dropdown-row {\n\n        &--links-horizontal {\n          h3.hsg-nav__header {\n            display: inline-block;\n            margin-right: 1em;\n          }\n\n          p {\n            display: inline-block;\n\n            @media (max-width: 767px) {\n              width: 100%;\n            }\n          }\n        }\n\n        .hsg-nav__header {\n          position: relative;\n          margin: 0 0 0.5rem;\n          font-size: 18px;\n          font-weight: 500;\n\n          @media (max-width: 767px) {\n            font-size: 1rem;\n          }\n        }\n\n        span.hsg-nav__ribbon {\n          background-color: ", ";\n          color: ", ";\n          font-size: 0.625rem;\n          font-weight: 700;\n          padding: 0.25rem 0.5rem;\n          border-radius: 0.1875rem;\n          text-align: center;\n          text-transform: uppercase;\n          margin-right: 5px;\n          display: inline-block;\n          vertical-align: top;\n        }\n\n        .hsg-nav__subheader {\n          font-size: 1em;\n          margin: 0;\n          font-weight: 400;\n        }\n\n        .hsg-nav__link-group {\n          position: relative;\n\n          a {\n            display: block;\n            padding: 0.5rem 1rem;\n            font-weight: 400;\n            font-size: 0.875rem;\n\n            @media (max-width: 767px) {\n              border-bottom: 1px solid ", ";\n            }\n\n            &:hover {\n              background-color: ", ";\n            }\n\n            &.hsg-en-link {\n              span {\n                display: inline-block;\n                position: relative;\n                padding-right: 2.25rem;\n\n                &::before {\n                  content: 'EN';\n                  position: absolute;\n                  top: 0.12rem;\n                  right: 0.2rem;\n                  background-color: ", ";\n                  color: ", ";\n                  font-size: 0.625rem;\n                  font-weight: 700;\n                  line-height: 0.8;\n                  border-radius: 0.1875rem;\n                  box-sizing: content-box;\n                  transition: opacity 0.15s ease-out;\n                  height: 0.5rem;\n                  padding: 0.25rem;\n                  opacity: 1;\n                }\n              }\n            }\n          }\n\n          @media (min-width: 768px) {\n            left: -1rem;\n            width: calc(100% + 1rem);\n          }\n        }\n\n        @media (min-width: 768px) {\n          display: flex;\n          -webkit-box-pack: justify;\n          justify-content: space-between;\n          padding: 1rem;\n        }\n      }\n\n      .hsg-nav__box-link {\n        display: block;\n        padding: 0.75rem;\n        -webkit-tap-highlight-color: ", ";\n\n        [lang=\"de\"] &,\n        [lang=\"fr\"] & {\n          padding: 0.5rem;\n        }\n\n        @media (min-width: 768px) {\n          border-radius: 0.1875rem;\n          margin-bottom: 0;\n        }\n\n        @media (max-width: 767px) {\n          border-bottom: 1px solid ", ";\n        }\n      }\n\n      .hsg-nav__box-link-icon {\n        float: left;\n        padding: 6px;\n        height: 2.2rem;\n        margin-right: 0.555rem;\n\n        @media (max-width: 767px) {\n          margin-bottom: 3rem;\n          padding-top: 0;\n          height: 2rem;\n        }\n      }\n\n      @media (min-width: 768px) {\n        position: absolute;\n        top: calc(100% + 1rem);\n        background-color: ", ";\n        border: 1px solid ", ";\n        border-radius: .1875rem;\n        box-shadow: 0 1px 24px rgba(", ", 0.12);\n        z-index: 95;\n        right: 0;\n        transition: none;\n        margin-top: -1rem;\n      }\n    }\n\n    .hsg-nav__link {\n      display: block;\n      padding: 1rem 0;\n      -webkit-tap-highlight-color: ", ";\n      font-weight: 500;\n\n      @media (min-width: 768px) {\n        display: inline-block;\n        padding: 1rem 0 0 0;\n      }\n    }\n\n    .hsg-nav__link-label {\n      display: inline-block;\n      padding: 0;\n\n      @media (max-width: 767px) {\n        display: flex;\n        justify-content: space-between;\n      }\n\n      &::after {\n        @media (max-width: 767px) {\n          content: '\\\\E003';\n          display: inline-block;\n          position: relative;\n          color: ", ";\n          font-family: 'hsg-icons';\n          font-size: 1.25rem;\n          line-height: 1;\n          font-weight: bold;\n          margin: 0 0.25rem 0.25rem 1rem;\n          vertical-align: middle;\n          transform: rotate(-90deg);\n        }\n      }\n\n      .hsg-icon {\n        display: inline-block;\n        font-size: 1.125rem;\n        line-height: 1;\n        vertical-align: middle;\n        margin-right: 0.625rem;\n\n        &::before {\n          font-family: \"hsg-icons\";\n          -webkit-font-smoothing: antialiased;\n          font-style: normal;\n          font-variant: normal;\n          font-weight: normal;\n          text-decoration: none;\n          text-transform: none;\n        }\n\n        &.hsg-icon-email {\n          &::before {\n            content: \"\\\\E017\";\n          }\n        }\n      }\n\n      @media (min-width: 768px) and (max-width: 1023px) {\n        padding: 0 0.5rem;\n      }\n\n      @media (min-width: 1024px) {\n        padding: 0 1rem;\n      }\n    }\n\n    @media (min-width: 768px) {\n      display: inline-block;\n      padding: 0;\n      border-bottom: 0;\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  display: none;\n  z-index: 91;\n\n  .hsg-nav__group-item {\n    position: relative;\n\n    &:first-child:not(:only-child) {\n      .hsg-nav__link-label {\n        padding-left: 0;\n      }\n    }\n\n    &--utility,\n    &--about,\n    &--login {\n      margin: 0 0.5rem;\n    }\n\n    &--about {\n      &.hsg-nav__group-item {\n        &.hsg-nav__group-item--has-dropdown {\n          @media (min-width: 768px) {\n            &:hover {\n              .hsg-nav__link-wrapper {\n                &::before {\n                  right: -1px;\n                  bottom: calc(-1rem - 2px);\n                }\n                &::after {\n                  right: 0;\n                  bottom: calc(-1rem - 1px);\n                }\n              }\n            }\n          }\n        }\n\n        .hsg-nav__dropdown-list {\n            @media (min-width: 768px) {\n              right: -1rem;\n              top: calc(100% + 0.5rem);\n            }\n\n          .hsg-nav__dropdown-item {\n            a {\n              font-size: 0.875rem;\n            }\n          }\n        }\n      }\n    }\n\n    a {\n      font-size: 0.75rem;\n      font-weight: 500;\n      padding: 0.75rem 0;\n\n      &:hover {\n        color: ", ";\n        text-decoration: underline;\n        font-weight: 600;\n      }\n    }\n\n    &.hsg-nav__group-item--has-dropdown {\n      @media (min-width: 768px) {\n        &:hover {\n          .hsg-nav__link-wrapper {\n            &::before, &::after {\n              display: inline-block;\n              position: absolute;\n              border-radius: .1875rem 0 0;\n              transform: rotate(45deg);\n              width: 1rem;\n              height: 1rem;\n              content: '';\n            }\n\n            &::before {\n              right: 1rem;\n              background-color: ", ";\n              border: 1px solid ", ";\n              bottom: calc(-0.5rem - 2px);\n              box-sizing: content-box;\n            }\n\n            &::after {\n              right: calc(1rem + 1px);\n              background-color: ", ";\n              z-index: 100;\n              bottom: calc(-0.5rem - 1px);\n              box-sizing: content-box;\n            }\n          }\n        }\n      }\n    }\n\n    .hsg-nav__dropdown-list {\n      cursor: auto;\n      display: none;\n      font-size: 0.78rem;\n      margin: 0 auto;\n      position: absolute;\n      top: 100%;\n      background-color: ", ";\n      border: 1px solid ", ";\n      border-radius: .1875rem;\n      box-shadow: 0 1px 24px rgba(", ", 0.12);\n      z-index: 95;\n      padding: 0.75rem 0;\n\n      @media (min-width: 768px) {\n        right: 0;\n        min-width: 100%;\n      }\n    }\n\n    #hsg-nav__logo {\n      display: flex;\n      margin: 0 4rem 0 0;\n\n      img {\n        position: relative;\n        top: 0.5rem;\n        display: block;\n        align-self: center;\n      }\n    }\n\n    @media (min-width: 768px) {\n      display: inline-block;\n    }\n  }\n\n  @media (min-width: 768px) {\n    display: block;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: 18px;\n  line-height: 1.625;\n  position: relative;\n  z-index: 101;\n\n  &.expanded-nav {\n    z-index: 10000;\n  }\n\n  .hsg-icon::before {\n    font-family: \"hsg-icons\";\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n    font-style: normal;\n    font-variant: normal;\n    font-weight: normal;\n    /* speak: none; only necessary if not using the private unicode range (firstGlyph option) */\n    text-decoration: none;\n    text-transform: none;\n  }\n\n  img {\n    max-width: 100%;\n  }\n\n  a:not([class^='cta']) {\n    color: inherit;\n  }\n\n  .hsg-page-width-normal {\n    max-width: 1080px;\n    margin: 0 auto;\n    padding: 0;\n    box-sizing: content-box;\n\n    @media (min-width: 768px) {\n      padding: 0 2rem;\n    }\n  }\n\n  .hsg-nav-menu {\n    @media (max-width: 767px) {\n      height: 3.25rem;\n    }\n  }\n\n  .hsg-nav__inner {\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n\n    @media (max-width: 767px) {\n      position: fixed;\n      top: 0;\n      width: 100%;\n      background-color: ", ";\n      box-shadow: 0 1px 5px 0 rgba(45, 62, 80, 0.12);\n      padding: 0.5rem 1rem;\n      flex-wrap: nowrap;\n      height: 3.25rem;\n    }\n  }\n\n  .hsg-nav__group--utility {\n    background-color: ", ";\n    display: grid;\n    grid: 1fr 1fr/1fr 1fr;\n    margin: 1rem;\n\n    [lang=\"es\"] & {\n      grid: 1fr 1fr/2fr 1fr;\n    }\n\n\n    @media (min-width: 501px) and (max-width: 767px) {\n      display: flex;\n      justify-content: space-evenly;\n      .hsg-nav__group--lang {\n        flex-basis: 50%;\n      }\n    }\n\n    @media (min-width: 768px) {\n      display: none;\n    }\n\n    .hsg-nav__group-item {\n      border-bottom: 0;\n      padding: 0;\n      font-size: 0.875rem;\n      display: flex;\n      align-items: center;\n      font-weight: 500;\n\n      .hsg-nav__link {\n        padding: 0.75rem 0;\n      }\n    }\n\n    .hsg-nav__group--lang {\n      grid-area: 1/1/3/2;\n\n      &.hsg-nav__group-item {\n        border-bottom: 0;\n      }\n\n      .hsg-nav__link-label--contact-us {\n        padding-left: 0.5rem;\n\n        &::after {\n          content: ' ';\n        }\n      }\n\n      .hsg-nav__link-label--globe::after {\n        transform: none;\n        font-size: 8px;\n        margin: 0.25rem 0.25rem 0.25rem 1rem;\n      }\n\n      &::after {\n        @media (max-width: 501px) {\n          content: \" \";\n          background-color: ", ";\n          width: 2px;\n          height: 4rem;\n          position: relative;\n          left: 1rem;\n        }\n      }\n    }\n\n  }\n\n  .hsg-nav__group-item--search-container {\n    width: 100%;\n    margin-bottom: 0.75rem;\n\n    &.hide {\n      display: none;\n    }\n\n    @media (min-width: 768px) {\n      display: none;\n    }\n\n    input {\n      background-image: url(//cdn2.hubspot.net/hubfs/53/assets/hubspot.com/_style-guide/sword-sprocket/search%20icon.png);\n      background-position: right 0.5rem center;\n      background-repeat: no-repeat;\n      background-size: 1rem;\n      font-size: 0.75rem;\n      font-weight: 500;\n      font-family: inherit;\n      text-align: center;\n      background-color: ", ";\n      border-radius: 5rem;\n      border: 1px solid ", ";\n      width: 100%;\n      appearance: none;\n      min-height: 2.5rem;\n      padding: 0.5625rem 0.625rem;\n\n      &:focus {\n        cursor: auto;\n      }\n    }\n  }\n\n  .hsg-nav__link-wrapper {\n    position: relative;\n  }\n\n  .hsg-nav__group-item--has-dropdown {\n    @media (min-width: 768px) {\n      &:hover {\n        .hsg-nav__dropdown-list {\n          display: block;\n        }\n\n        &.hsg-nav__group-item--order-1 {\n          .hsg-nav__dropdown-list {\n            display: grid\n          }\n        }\n        &.hsg-nav__group-item--order-3 {\n          .hsg-nav__dropdown-list {\n            display: flex;\n            columns: 1;\n            @media (min-width: 767px) {\n              columns: 2;\n            }\n          }\n        }\n      }\n    }\n\n    .hsg-nav__link-label {\n      &::after {\n        content: '\\E003';\n        display: inline-block;\n        position: relative;\n        color: ", ";\n        font-family: 'hsg-icons';\n        font-size: 8px;\n        line-height: 1;\n        margin: 0 0.25rem 0 0.5rem;\n        font-weight: bold;\n        @media (max-width: 767px) {\n          margin: 0 0.25rem 0.25rem 0.5rem;\n          vertical-align: middle;\n          transform: rotate(-90deg);\n          font-size: 9px;\n        }\n      }\n    }\n  }\n\n  .hsg-nav__group-item {\n    display: block;\n\n    &.hsg-nav__group-item--cta, &.hsg-nav__group-item--search {\n      padding: 1rem 1.5rem;\n\n      a {\n        text-align: center;\n        display: block;\n      }\n\n      @media (min-width: 768px) {\n        padding: 0 0.5rem;\n      }\n    }\n\n    &.hsg-nav__group-item--cta {\n      border-bottom: 0;\n      margin-left: 8px;\n\n      @media (max-width: 767px) {\n        padding: 0 1rem;\n        margin: 0;\n      }\n    }\n\n    &.hsg-nav__group-item--search {\n      background-color: ", ";\n\n      input {\n        font-size: 1rem;\n        border: 1px solid;\n        border-color: ", ";\n        min-height: 2.5rem;\n        text-align: center;\n        padding: 0.5625rem 3rem 0.5625rem 0.625rem;\n        transition: all 0.15s ease-out;\n        appearance: none;\n        color: ", ";\n        line-height: 1.375;\n        border-radius: 0.1875rem;\n        width: 100%;\n        background-color: ", ";\n        background-image: url(//cdn2.hubspot.net/hubfs/53/assets/hubspot.com/_style-guide/sword-sprocket/search%20icon.png);\n        background-position: right 1rem center;\n        background-repeat: no-repeat;\n        background-size: 1rem;\n        font-size: 0.75rem;\n        font-weight: 500;\n        text-transform: lowercase;\n\n        &:focus {\n          outline: 0;\n          box-shadow: 0 0 4px 1px rgba(", ", 0.3), 0 0 0 1px ", ";\n          border-color: rgba(", ", 0.5);\n          cursor: auto;\n          width: 100%;\n\n          @media (min-width: 768px) {\n            max-width: 175px;\n          }\n        }\n\n        @media (min-width: 768px) {\n          cursor: pointer;\n          background-color: transparent;\n          background-position: 0.25rem center;\n          text-align: left;\n          border: 0;\n          transition: max-width 0.3s ease-out;\n          max-height: 2rem;\n          min-height: 1rem;\n          max-width: 0;\n          padding: 0.25rem 0.5rem 0.25rem 1.75rem;\n        }\n      }\n\n      @media (min-width: 768px) {\n        background-color: transparent;\n      }\n    }\n\n    .hsg-nav__dropdown-item a {\n      display: block;\n      white-space: nowrap;\n      transition: color 0.15s ease-out;\n      padding: 0.25rem 1.25rem;\n      font-weight: 500;\n\n      &:hover {\n        color: ", ";\n        text-decoration: underline;\n        font-weight: 600;\n      }\n    }\n\n    .cta {\n      cursor: pointer;\n      display: inline-block;\n      line-height: 1.25;\n      border-radius: .1875rem;\n      transition: 0.15s color ease-out, 0.15s background-color ease-out, 0.15s border-color ease-out;\n    }\n\n    .cta--primary {\n      background-color: ", ";\n      color: ", ";\n\n      &:hover {\n        background-color: ", ";\n        text-decoration: none;\n        color: ", ";\n      }\n    }\n\n    .cta--regular {\n      font-size: .875rem;\n      font-weight: 600;\n      padding: .85em 1.388em;\n      min-width: 8.555rem;\n\n      @media (max-width: 767px) {\n        padding: 1.5rem;\n        font-size: 1.25rem;\n        line-height: 1.25rem;\n      }\n    }\n  }\n\n  #hsg__sprocket-loader {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    background: ", " url('//cdn2.hubspot.net/hub/53/file-1186944780-gif/assets/hubspot.com/V2-Global/v2-sprocket-loader.gif') no-repeat center;\n    background-size: 2.25rem 2.25rem;\n    border-radius: 0.1875rem;;\n    transform: translate(-50%, -50%);\n    width: 3.5rem;\n    height: 3.5rem;\n    z-index: 150;\n  }\n"], ["\n  color: ", ";\n  font-size: 18px;\n  line-height: 1.625;\n  position: relative;\n  z-index: 101;\n\n  &.expanded-nav {\n    z-index: 10000;\n  }\n\n  .hsg-icon::before {\n    font-family: \"hsg-icons\";\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n    font-style: normal;\n    font-variant: normal;\n    font-weight: normal;\n    /* speak: none; only necessary if not using the private unicode range (firstGlyph option) */\n    text-decoration: none;\n    text-transform: none;\n  }\n\n  img {\n    max-width: 100%;\n  }\n\n  a:not([class^='cta']) {\n    color: inherit;\n  }\n\n  .hsg-page-width-normal {\n    max-width: 1080px;\n    margin: 0 auto;\n    padding: 0;\n    box-sizing: content-box;\n\n    @media (min-width: 768px) {\n      padding: 0 2rem;\n    }\n  }\n\n  .hsg-nav-menu {\n    @media (max-width: 767px) {\n      height: 3.25rem;\n    }\n  }\n\n  .hsg-nav__inner {\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n\n    @media (max-width: 767px) {\n      position: fixed;\n      top: 0;\n      width: 100%;\n      background-color: ", ";\n      box-shadow: 0 1px 5px 0 rgba(45, 62, 80, 0.12);\n      padding: 0.5rem 1rem;\n      flex-wrap: nowrap;\n      height: 3.25rem;\n    }\n  }\n\n  .hsg-nav__group--utility {\n    background-color: ", ";\n    display: grid;\n    grid: 1fr 1fr/1fr 1fr;\n    margin: 1rem;\n\n    [lang=\"es\"] & {\n      grid: 1fr 1fr/2fr 1fr;\n    }\n\n\n    @media (min-width: 501px) and (max-width: 767px) {\n      display: flex;\n      justify-content: space-evenly;\n      .hsg-nav__group--lang {\n        flex-basis: 50%;\n      }\n    }\n\n    @media (min-width: 768px) {\n      display: none;\n    }\n\n    .hsg-nav__group-item {\n      border-bottom: 0;\n      padding: 0;\n      font-size: 0.875rem;\n      display: flex;\n      align-items: center;\n      font-weight: 500;\n\n      .hsg-nav__link {\n        padding: 0.75rem 0;\n      }\n    }\n\n    .hsg-nav__group--lang {\n      grid-area: 1/1/3/2;\n\n      &.hsg-nav__group-item {\n        border-bottom: 0;\n      }\n\n      .hsg-nav__link-label--contact-us {\n        padding-left: 0.5rem;\n\n        &::after {\n          content: ' ';\n        }\n      }\n\n      .hsg-nav__link-label--globe::after {\n        transform: none;\n        font-size: 8px;\n        margin: 0.25rem 0.25rem 0.25rem 1rem;\n      }\n\n      &::after {\n        @media (max-width: 501px) {\n          content: \" \";\n          background-color: ", ";\n          width: 2px;\n          height: 4rem;\n          position: relative;\n          left: 1rem;\n        }\n      }\n    }\n\n  }\n\n  .hsg-nav__group-item--search-container {\n    width: 100%;\n    margin-bottom: 0.75rem;\n\n    &.hide {\n      display: none;\n    }\n\n    @media (min-width: 768px) {\n      display: none;\n    }\n\n    input {\n      background-image: url(//cdn2.hubspot.net/hubfs/53/assets/hubspot.com/_style-guide/sword-sprocket/search%20icon.png);\n      background-position: right 0.5rem center;\n      background-repeat: no-repeat;\n      background-size: 1rem;\n      font-size: 0.75rem;\n      font-weight: 500;\n      font-family: inherit;\n      text-align: center;\n      background-color: ", ";\n      border-radius: 5rem;\n      border: 1px solid ", ";\n      width: 100%;\n      appearance: none;\n      min-height: 2.5rem;\n      padding: 0.5625rem 0.625rem;\n\n      &:focus {\n        cursor: auto;\n      }\n    }\n  }\n\n  .hsg-nav__link-wrapper {\n    position: relative;\n  }\n\n  .hsg-nav__group-item--has-dropdown {\n    @media (min-width: 768px) {\n      &:hover {\n        .hsg-nav__dropdown-list {\n          display: block;\n        }\n\n        &.hsg-nav__group-item--order-1 {\n          .hsg-nav__dropdown-list {\n            display: grid\n          }\n        }\n        &.hsg-nav__group-item--order-3 {\n          .hsg-nav__dropdown-list {\n            display: flex;\n            columns: 1;\n            @media (min-width: 767px) {\n              columns: 2;\n            }\n          }\n        }\n      }\n    }\n\n    .hsg-nav__link-label {\n      &::after {\n        content: '\\\\E003';\n        display: inline-block;\n        position: relative;\n        color: ", ";\n        font-family: 'hsg-icons';\n        font-size: 8px;\n        line-height: 1;\n        margin: 0 0.25rem 0 0.5rem;\n        font-weight: bold;\n        @media (max-width: 767px) {\n          margin: 0 0.25rem 0.25rem 0.5rem;\n          vertical-align: middle;\n          transform: rotate(-90deg);\n          font-size: 9px;\n        }\n      }\n    }\n  }\n\n  .hsg-nav__group-item {\n    display: block;\n\n    &.hsg-nav__group-item--cta, &.hsg-nav__group-item--search {\n      padding: 1rem 1.5rem;\n\n      a {\n        text-align: center;\n        display: block;\n      }\n\n      @media (min-width: 768px) {\n        padding: 0 0.5rem;\n      }\n    }\n\n    &.hsg-nav__group-item--cta {\n      border-bottom: 0;\n      margin-left: 8px;\n\n      @media (max-width: 767px) {\n        padding: 0 1rem;\n        margin: 0;\n      }\n    }\n\n    &.hsg-nav__group-item--search {\n      background-color: ", ";\n\n      input {\n        font-size: 1rem;\n        border: 1px solid;\n        border-color: ", ";\n        min-height: 2.5rem;\n        text-align: center;\n        padding: 0.5625rem 3rem 0.5625rem 0.625rem;\n        transition: all 0.15s ease-out;\n        appearance: none;\n        color: ", ";\n        line-height: 1.375;\n        border-radius: 0.1875rem;\n        width: 100%;\n        background-color: ", ";\n        background-image: url(//cdn2.hubspot.net/hubfs/53/assets/hubspot.com/_style-guide/sword-sprocket/search%20icon.png);\n        background-position: right 1rem center;\n        background-repeat: no-repeat;\n        background-size: 1rem;\n        font-size: 0.75rem;\n        font-weight: 500;\n        text-transform: lowercase;\n\n        &:focus {\n          outline: 0;\n          box-shadow: 0 0 4px 1px rgba(", ", 0.3), 0 0 0 1px ", ";\n          border-color: rgba(", ", 0.5);\n          cursor: auto;\n          width: 100%;\n\n          @media (min-width: 768px) {\n            max-width: 175px;\n          }\n        }\n\n        @media (min-width: 768px) {\n          cursor: pointer;\n          background-color: transparent;\n          background-position: 0.25rem center;\n          text-align: left;\n          border: 0;\n          transition: max-width 0.3s ease-out;\n          max-height: 2rem;\n          min-height: 1rem;\n          max-width: 0;\n          padding: 0.25rem 0.5rem 0.25rem 1.75rem;\n        }\n      }\n\n      @media (min-width: 768px) {\n        background-color: transparent;\n      }\n    }\n\n    .hsg-nav__dropdown-item a {\n      display: block;\n      white-space: nowrap;\n      transition: color 0.15s ease-out;\n      padding: 0.25rem 1.25rem;\n      font-weight: 500;\n\n      &:hover {\n        color: ", ";\n        text-decoration: underline;\n        font-weight: 600;\n      }\n    }\n\n    .cta {\n      cursor: pointer;\n      display: inline-block;\n      line-height: 1.25;\n      border-radius: .1875rem;\n      transition: 0.15s color ease-out, 0.15s background-color ease-out, 0.15s border-color ease-out;\n    }\n\n    .cta--primary {\n      background-color: ", ";\n      color: ", ";\n\n      &:hover {\n        background-color: ", ";\n        text-decoration: none;\n        color: ", ";\n      }\n    }\n\n    .cta--regular {\n      font-size: .875rem;\n      font-weight: 600;\n      padding: .85em 1.388em;\n      min-width: 8.555rem;\n\n      @media (max-width: 767px) {\n        padding: 1.5rem;\n        font-size: 1.25rem;\n        line-height: 1.25rem;\n      }\n    }\n  }\n\n  #hsg__sprocket-loader {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    background: ", " url('//cdn2.hubspot.net/hub/53/file-1186944780-gif/assets/hubspot.com/V2-Global/v2-sprocket-loader.gif') no-repeat center;\n    background-size: 2.25rem 2.25rem;\n    border-radius: 0.1875rem;;\n    transform: translate(-50%, -50%);\n    width: 3.5rem;\n    height: 3.5rem;\n    z-index: 150;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    ", ";\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  @font-face {\n    font-family: \"hsg-icons\";\n    src: url('https://cdn2.hubspot.net/hubfs/53/assets/hubspot.com/icons/hsg-icons.eot');\n    src: url('hhttps://cdn2.hubspot.net/hubfs/53/assets/hubspot.com/icons/hsg-icons.eot?#iefix') format('eot'),\n      url('https://cdn2.hubspot.net/hubfs/53/assets/hubspot.com/icons/hsg-icons.woff2') format('woff2'),\n      url('https://cdn2.hubspot.net/hubfs/53/assets/hubspot.com/icons/hsg-icons.woff') format('woff'),\n      url('https://cdn2.hubspot.net/hubfs/53/assets/hubspot.com/icons/hsg-icons.ttf') format('truetype'),\n      url('https://cdn2.hubspot.net/hubfs/53/assets/hubspot.com/icons/hsg-icons.svg#hsg-icons') format('svg');\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var colors = {
  // THEME COLORS
  // Primary colors
  calypso: '#00a4bd',
  calypsoLightest: '#e5f5f8',
  calypsoSearch: '#0091ae;',
  calypsoSearchHover: '#007a8c;',
  lorax: '#ff7a59',
  primaryBackgroundHover: '#ff8f73',
  // Secondary colors
  oz: '#00bda5',
  secondaryBackgroundHover: '#fff8f6',
  headerSearchFocus: '#00d0e4',
  headerSearchFocusRGB: '0, 208, 228',
  //Links
  linkPrimary: '#0091ae',
  linkPrimaryHover: '#007a8c',
  // Dark greys
  pantera: '#2d3e50',
  panteraRGB: '45, 62, 80',
  obsidian: '#33475b',
  obsidianRGB: '51, 71, 91',
  flint: '#99acc2',
  eerie: '#7c98b6',
  heffalump: '#425b76',
  // Light greys
  battleship: '#cbd6e2',
  koala: '#eaf0f6',
  gypsum: '#f5f8fa',
  olaf: '#fff',
  olafRGB: '255, 255, 255'
};
var iconFontMixin = styled.css(_templateObject$2());
/* Backwards Compatibility (styled-components v3/v4) */

var IconFontGlobalStyle = null;

if (styled.createGlobalStyle) {
  IconFontGlobalStyle = styled.createGlobalStyle(_templateObject2(), iconFontMixin);
} else if (styled.injectGlobal) {
  // TODO: remove this branch logic (and only use createGlobalStyle) after all downstream
  // projects are on styled-components v4
  styled.injectGlobal(_templateObject3(), iconFontMixin);
}

var StyledHeader = styled__default(StyledBase)(_templateObject4(), colors.obsidian, colors.olaf, colors.olaf, colors.battleship, colors.gypsum, colors.battleship, colors.eerie, colors.gypsum, colors.battleship, colors.obsidan, colors.olaf, colors.headerSearchFocusRGB, colors.headerSearchFocus, colors.headerSearchFocusRGB, colors.linkPrimaryHover, colors.lorax, colors.olaf, colors.primaryBackgroundHover, colors.olaf, colors.gypsum);
var UpperNav = styled__default.nav(_templateObject5(), colors.linkPrimaryHover, colors.battleship, colors.battleship, colors.olaf, colors.olaf, colors.battleship, colors.panteraRGB);
var LowerNav = styled__default(MainNav)(_templateObject6(), colors.olaf, colors.obsidian, colors.koala, colors.battleship, colors.flint, colors.obsidian, colors.eerie, colors.obsidian, colors.obsidian, colors.olaf, colors.battleship, colors.heffalump, colors.gypsum, colors.obsidianRGB, colors.battleship, colors.battleship, colors.linkPrimaryHover, colors.gypsum, colors.obsidian, colors.linkPrimary, colors.linkPrimary, colors.gypsum, colors.olaf, colors.koala, colors.linkPrimary, colors.olaf, colors.koala, colors.olaf, colors.koala, colors.olaf, colors.gypsum, colors.gypsum, colors.linkPrimaryHover, colors.olaf, colors.gypsum, colors.battleship, colors.gypsum, colors.battleship, colors.olaf, colors.obsidianRGB, colors.calypso, colors.oz, colors.olaf, colors.battleship, colors.calypsoLightest, colors.lorax, colors.olaf, colors.calypsoLightest, colors.battleship, colors.olaf, colors.battleship, colors.panteraRGB, colors.calypsoLightest, colors.eerie);
var StyledSearch = styled__default(Search)
/* .hsgModalFullscreenContainer */
(_templateObject7(), colors.panteraRGB, colors.olaf, colors.olafRGB, colors.olaf, colors.calypso, colors.oz, colors.obsidianRGB, colors.olaf, colors.olaf, colors.olaf, colors.olaf, colors.olaf, colors.lorax, colors.olaf, colors.olaf, colors.lorax, colors.olaf, colors.olaf, colors.calypsoSearch, colors.calypsoSearchHover, colors.battleship, colors.lorax, colors.olaf, colors.primaryBackgroundHover);

var getSearchResults = function getSearchResults(query, cb) {
  var xhttp = new window.XMLHttpRequest();

  xhttp.onreadystatechange = function () {
    if (this.readyState === 4 && this.status === 200) {
      var resData = JSON.parse(xhttp.responseText);

      if (resData.items) {
        cb(resData.items.map(function (item) {
          var htmlTitle = item.htmlTitle,
              link = item.link,
              htmlSnippet = item.htmlSnippet,
              cacheId = item.cacheId;
          return {
            htmlTitle: htmlTitle,
            link: link,
            htmlSnippet: htmlSnippet,
            cacheId: cacheId
          };
        }));
      }
    }
  };

  xhttp.onerror = function (err) {
    console.error("Fetch Error: " + err);
    cb(null);
  };

  xhttp.open('GET', query, true);
  xhttp.send();
};

var HeaderMain =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(HeaderMain, _React$Component);

  function HeaderMain(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      selectedSearchCx: _this.props.contentBlob.searchContent.cx,
      searchIndex: 1,
      queryString: '',
      googleSearchUrl: '',
      searchResultsList: null,
      isLoading: false,
      isSearchOpen: false,
      // isMobile: (window.innerWidth <= 767),
      isNavActive: false
    };
    _this.handleSearch = _this.handleSearch.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleCx = _this.handleCx.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.closeSearch = _this.closeSearch.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.loadMoreResults = _this.loadMoreResults.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleActiveNav = _this.handleActiveNav.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = HeaderMain.prototype;

  _proto.handleActiveNav = function handleActiveNav(isActive) {
    this.setState({
      isNavActive: isActive
    });
  };

  _proto.closeSearch = function closeSearch(event) {
    event.preventDefault();
    this.setState({
      searchIndex: 1,
      isSearchOpen: false
    });
  };

  _proto.handleSearch = function handleSearch(event) {
    var _this2 = this;

    if (event.key === 'Enter') {
      this.setState({
        isLoading: true,
        searchIndex: 1,
        queryString: event.target.value,
        googleSearchUrl: "https://wtcfns.hubspot.com/custom-search/" + this.state.selectedSearchCx + "/" + event.target.value
      }, function () {
        getSearchResults(_this2.state.googleSearchUrl, function (searchResultsList) {
          _this2.setState({
            searchResultsList: searchResultsList,
            isLoading: false,
            isSearchOpen: true
          });

          window.scrollTo(0, 0);
        });
      });
    }
  };

  _proto.handleCx = function handleCx(event) {
    var _this3 = this;

    this.setState({
      isLoading: true,
      selectedSearchCx: event.target.value,
      searchIndex: 1,
      googleSearchUrl: "https://wtcfns.hubspot.com/custom-search/" + event.target.value + "/" + this.state.queryString
    });
    getSearchResults(this.state.googleSearchUrl, function (searchResultsList) {
      _this3.setState({
        searchResultsList: searchResultsList,
        isLoading: false,
        isSearchOpen: true
      });

      window.scrollTo(0, 0);
    });
  };

  _proto.loadMoreResults = function loadMoreResults(event) {
    event.preventDefault();
    this.setState({
      searchIndex: this.state.searchIndex + 10,
      googleSearchUrl: "https://wtcfns.hubspot.com/wt-api/custom-search/" + event.target.value + "/" + this.state.queryString + "/" + (this.state.searchIndex + 10).toString()
    }); // googleSearchUrl kept here for legacy, but not utilized atm, maybe in future??
  };

  _proto.render = function render() {
    var _this4 = this;

    var _this$props = this.props,
        isLoggedIn = _this$props.isLoggedIn,
        lang = _this$props.lang,
        _this$props$contentBl = _this$props.contentBlob,
        _this$props$contentBl2 = _this$props$contentBl.upperNavContent,
        homeUrl = _this$props$contentBl2.homeUrl,
        loginUrl = _this$props$contentBl2.loginUrl,
        loginText = _this$props$contentBl2.loginText,
        supportUrl = _this$props$contentBl2.supportUrl,
        supportText = _this$props$contentBl2.supportText,
        _this$props$contentBl3 = _this$props$contentBl2.regionalDropdownContent,
        contactUrl = _this$props$contentBl3.contactUrl,
        contactText = _this$props$contentBl3.contactText,
        languagesContent = _this$props$contentBl3.languagesContent,
        _this$props$contentBl4 = _this$props$contentBl2.aboutContent,
        aboutLabel = _this$props$contentBl4.aboutLabel,
        aboutText = _this$props$contentBl4.aboutText,
        aboutUrl = _this$props$contentBl4.aboutUrl,
        contactUsText = _this$props$contentBl4.contactUsText,
        contactUsUrl = _this$props$contentBl4.contactUsUrl,
        careersText = _this$props$contentBl4.careersText,
        careersUrl = _this$props$contentBl4.careersUrl,
        managementText = _this$props$contentBl4.managementText,
        managementUrl = _this$props$contentBl4.managementUrl,
        mobileNavContent = _this$props$contentBl.mobileNavContent,
        searchContent = _this$props$contentBl.searchContent,
        _this$props$contentBl5 = _this$props$contentBl.searchContent,
        searchPlaceholder = _this$props$contentBl5.searchPlaceholder,
        cx = _this$props$contentBl5.cx,
        mainNavContent = _this$props$contentBl.mainNavContent,
        navCta = _this$props$contentBl.navCta,
        onNavToggle = _this$props$contentBl.onNavToggle,
        variation = _this$props.variation;
    var isMarketplaceVariation = variation === 'marketplace';
    return React.createElement(React.Fragment, null, IconFontGlobalStyle && React.createElement(IconFontGlobalStyle, null), React.createElement(SVGIcons, null), React.createElement(StyledHeader, {
      id: "hsg-nav-global",
      className: "" + (this.state.isNavActive ? 'expanded-nav' : '')
    }, this.state.isLoading && React.createElement("div", {
      id: "hsg__sprocket-loader"
    }), React.createElement(StyledSearch, {
      className: "hsgModalFullscreenContainer hsg-search__modal-wrapper",
      searchContent: searchContent,
      searchResultsList: this.state.searchResultsList,
      handleSearch: this.handleSearch,
      handleCx: this.handleCx,
      loadMoreResults: this.loadMoreResults,
      closeSearch: this.closeSearch,
      isSearchOpen: this.state.isSearchOpen,
      queryString: this.state.queryString,
      searchIndex: this.state.searchIndex
    }), React.createElement("div", {
      "data-fixed-element": "placeholder"
    }, React.createElement(UpperNav, {
      "data-fixed-element": "target",
      "data-cx": cx
    }, React.createElement("div", {
      className: "hsg-page-width-normal"
    }, React.createElement("div", {
      className: "hsg-nav__inner"
    }, React.createElement("ul", {
      className: "hsg-nav__group"
    }, isMarketplaceVariation && React.createElement("li", {
      className: "hsg-nav__group-item"
    }, React.createElement(NavLogoLink, {
      href: homeUrl
    })), React.createElement("li", {
      className: "hsg-nav__group-item"
    }, React.createElement(StyledRegionalDropdown, {
      lang: lang || 'en',
      contactUrl: contactUrl,
      contactText: contactText,
      languagesContent: languagesContent
    }))), React.createElement("ul", {
      className: "hsg-nav__group"
    }, React.createElement("li", {
      className: "hsg-nav__group-item hsg-nav__group-item--search"
    }, React.createElement("input", {
      "data-id": "hsg-nav__search-input",
      type: "search",
      placeholder: searchPlaceholder,
      defaultValue: this.state.queryString,
      onKeyUp: function onKeyUp(e) {
        return _this4.handleSearch(e);
      }
    })), !isLoggedIn && React.createElement("li", {
      className: "hsg-nav__group-item hsg-nav__group-item--login"
    }, React.createElement("a", {
      href: loginUrl
    }, loginText)), React.createElement("li", {
      className: "hsg-nav__group-item hsg-nav__group-item--utility"
    }, React.createElement("a", {
      href: supportUrl
    }, supportText)), !isMarketplaceVariation && React.createElement("li", {
      className: "hsg-nav__group-item hsg-nav__group-item--about hsg-nav__group-item--has-dropdown"
    }, React.createElement("div", {
      id: "nav-main-link",
      className: "hsg-nav__link-wrapper"
    }, React.createElement("a", {
      className: "hsg-nav__link"
    }, React.createElement("span", {
      className: "hsg-nav__link-label"
    }, aboutLabel))), React.createElement("ul", {
      className: "hsg-nav__dropdown-list"
    }, React.createElement("li", {
      className: "hsg-nav__dropdown-item"
    }, React.createElement("a", {
      href: aboutUrl
    }, aboutText)), React.createElement("li", {
      className: "hsg-nav__dropdown-item"
    }, React.createElement("a", {
      href: contactUsUrl
    }, contactUsText)), React.createElement("li", {
      className: "hsg-nav__dropdown-item"
    }, React.createElement("a", {
      href: careersUrl
    }, careersText)), React.createElement("li", {
      className: "hsg-nav__dropdown-item"
    }, React.createElement("a", {
      href: managementUrl
    }, managementText)))), isMarketplaceVariation && React.createElement("li", {
      className: "hsg-nav__group-item hsg-nav__group-item--cta"
    }, React.createElement("a", {
      className: navCta.navCtaClass,
      href: navCta.navCtaUrl
    }, navCta.navCtaText))))))), !isMarketplaceVariation && React.createElement(LowerNav, {
      mainNavContent: mainNavContent,
      mobileNavContent: mobileNavContent,
      isLoggedIn: isLoggedIn,
      handleSearch: this.handleSearch,
      navCta: navCta,
      lang: lang,
      onNavToggle: this.handleActiveNav
    })), React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: purify("<!--[if lte IE 10]>\n            <a href=\"http://outdatedbrowser.com\" class=\"browser-upgrade-notification\" style=\"width: 100%; text-align: center; color: #FFF; background-color: #11434c; display: block;\">\n              <p style=\"font-size: .875em; color: #FFF; padding: 15px 0px; margin: 0px;\">\n                <img class=\"browser-upgrade-notification__emoji\" src=\"https://www.hubspot.com/hubfs/assets/hubspot.com/icons/Sad_Face_Emoji_large.png?t=1494954070529\" alt=\"\" style=\"max-height: 1.3em; position: relative; top: 4px; right: 3px;\"> Looks like your browser is stuck in the past. Update to the latest version for a better, faster, stronger (and safer) browsing experience. <img class=\"browser-upgrade-notification__arrow\" src=\"https://cdn2.hubspot.net/hubfs/53/assets/hubspot.com/icons/Arrow.png\" style=\"position: relative; left: 0%;\">\n              </p>\n            </a>\n          <![endif]-->")
      }
    }));
  };

  return HeaderMain;
}(React.Component);

HeaderMain.propTypes = {
  lang: PropTypes.string,
  contentBlob: PropTypes.object,
  isLoggedIn: PropTypes.bool,
  variation: PropTypes.oneOf(['default', 'marketplace'])
};
HeaderMain.defaultProps = {
  variation: 'default'
};

var ALLOWED_CONVERT_LANG = 'en';
var withHeaderProps = (function (_ref) {
  var lang = _ref.lang,
      contentBlob = _ref.contentBlob;

  var HighOrderWithHeaderProps =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(HighOrderWithHeaderProps, _React$Component);

    function HighOrderWithHeaderProps() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = HighOrderWithHeaderProps.prototype;

    _proto.render = function render() {
      var _this$props = this.props,
          contentBlobOverrides = _this$props.contentBlob,
          enableConvertFlag = _this$props.enableConvertFlag,
          isLoggedIn = _this$props.isLoggedIn,
          variation = _this$props.variation,
          useNewIcons = _this$props.useNewIcons;

      var mergedContentBlob = _extends({}, contentBlob, contentBlobOverrides);

      var mergedConvertFlag = lang === ALLOWED_CONVERT_LANG ? enableConvertFlag : false;
      return React.createElement(MyContext.Provider, {
        value: {
          useNewIcons: useNewIcons
        }
      }, mergedConvertFlag && React.createElement("script", {
        type: "text/javascript",
        async: true,
        src: "//cdn-3.convertexperiments.com/js/10031559-1003891.js"
      }), React.createElement(HeaderMain, {
        contentBlob: mergedContentBlob,
        isLoggedIn: isLoggedIn,
        lang: lang,
        variation: variation,
        useNewIcons: useNewIcons
      }));
    };

    return HighOrderWithHeaderProps;
  }(React.Component);

  HighOrderWithHeaderProps.propTypes = {
    contentBlob: PropTypes.object,
    enableConvertFlag: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    variation: PropTypes.oneOf(['default', 'marketplace']),
    useNewIcons: PropTypes.bool
  };
  HighOrderWithHeaderProps.defaultProps = {
    contentBlob: {},
    enableConvertFlag: false,
    useNewIcons: false
  };
  HighOrderWithHeaderProps.contentBlob = contentBlob;
  return HighOrderWithHeaderProps;
});

var lang = 'en';
var enBlob = {
  upperNavContent: {
    homeUrl: '//www.hubspot.com',
    loginUrl: '//app.hubspot.com/login',
    loginText: 'Log in',
    supportUrl: '//help.hubspot.com',
    supportText: 'Customer Support',
    regionalDropdownContent: {
      contactUrl: '//offers.hubspot.com/contact-sales',
      contactText: 'Contact Sales',
      languagesContent: {
        en: ['English', 'https://www.hubspot.com'],
        jp: ['日本語', 'https://www.hubspot.jp'],
        de: ['Deutsch', 'https://www.hubspot.de'],
        es: ['Español', 'https://www.hubspot.es'],
        pt: ['Português', 'https://br.hubspot.com'],
        fr: ['Français', 'https://www.hubspot.fr']
      }
    },
    aboutContent: {
      aboutLabel: 'About',
      aboutText: 'About Us',
      aboutUrl: '//www.hubspot.com/our-story',
      contactUsText: 'Contact Us',
      contactUsUrl: '//www.hubspot.com/company/contact',
      careersText: 'Careers',
      careersUrl: '//www.hubspot.com/careers',
      managementText: 'Management Team',
      managementUrl: '//www.hubspot.com/company/management'
    }
  },
  mobileNavContent: {
    contactUrl: '//offers.hubspot.com/contact-sales',
    contactText: 'Contact Sales',
    loginUrl: '//app.hubspot.com/login',
    loginText: 'Log in',
    searchPlaceholder: 'Search HubSpot.com',
    supportUrl: '//help.hubspot.com/',
    supportText: 'Customer Support',
    home: 'Home',
    homeUrl: '//www.hubspot.com',
    languagesContent: {
      en: ['English', 'https://www.hubspot.com'],
      jp: ['日本語', 'https://www.hubspot.jp'],
      de: ['Deutsch', 'https://www.hubspot.de'],
      es: ['Español', 'https://www.hubspot.es'],
      pt: ['Português', 'https://br.hubspot.com'],
      fr: ['Français', 'https://www.hubspot.fr']
    }
  },
  searchContent: {
    searchPlaceholder: 'search...',
    searchHubLabel: 'Search hubspot.com',
    searchBlogLabel: 'Search blog',
    loadMoreText: 'Load more results',
    cx: '009219321729865762236:z9gsnksfc30',
    cxBlog: '009219321729865762236:fzizmixjdmi',
    noResultsContent: {
      h6: 'That’s odd...',
      p1: 'Couldn’t find quite the right match.',
      p2: 'Don’t worry, try searching again up top.'
    }
  },
  mainNavContent: {
    navDropDownContent0: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-1  hsg-nav__group-item--has-dropdown',
      topText: 'Software',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row hsg-nav__dropdown-row--links',
          listRowContent: {
            a0: {
              htype: 3,
              headerText: 'The HubSpot CRM Platform',
              subtextContent: 'All of HubSpot’s marketing, sales CRM, customer service, CMS, and operations software on one platform.'
            },
            a1: {
              url: '//www.hubspot.com/products/crm',
              htype: 3,
              headerText: 'Free HubSpot CRM',
              gtm: 'crm'
            },
            a2: {
              url: '//www.hubspot.com/products/get-started',
              htype: 3,
              headerText: 'Overview of all products',
              gtm: 'crm'
            }
          }
        },
        li1: {
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              url: '//www.hubspot.com/products/marketing',
              htype: 4,
              headerText: 'Marketing Hub',
              gtm: 'marketing',
              subtextContent: 'Marketing automation software. <span class="highlight">Free and premium plans</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Marketing.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/MarketingHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Marketing icon'
            },
            a1: {
              url: '//www.hubspot.com/products/sales',
              htype: 4,
              headerText: 'Sales Hub',
              gtm: 'sales',
              subtextContent: 'Sales CRM software. <span class="highlight">Free and premium plans</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Sales.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/SalesHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Sales icon'
            },
            a2: {
              url: '//www.hubspot.com/products/service',
              htype: 4,
              headerText: 'Service Hub',
              gtm: 'service',
              subtextContent: 'Customer service software. <span class="highlight">Free and premium plans</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Service.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/ServiceHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Service icon'
            },
            a3: {
              url: '//www.hubspot.com/products/cms',
              htype: 4,
              headerText: 'CMS Hub',
              gtm: 'cms',
              subtextContent: 'Content management system software. <span class="highlight">Free and premium plans</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/CMS.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/CMSHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'CMS icon',
              hasRibbon: false
            },
            a4: {
              url: '//www.hubspot.com/products/operations',
              htype: 4,
              headerText: 'Operations Hub',
              gtm: 'ops',
              subtextContent: 'Operations software. <span class="highlight">Free and premium plans</span>',
              iconSrc: '//www.hubspot.com/hubfs/assets/hubspot.com/web-team/WBZ/Navigation/operations.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/OperationsHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Operations icon',
              hasRibbon: false
            }
          }
        },
        li2: {
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row hsg-nav__dropdown-row--links hsg-nav__dropdown-row--links-horizontal',
          listRowContent: {
            a0: {
              url: '//ecosystem.hubspot.com/marketplace/apps',
              htype: 6,
              headerText: 'App Marketplace',
              gtm: 'app',
              subtextContent: 'Connect your favorite apps to HubSpot. <span class="highlight">See all integrations</span>'
            }
          }
        }
      }
    },
    navDropDownContent1: {
      hasDropDown: false,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-2',
      topUrl: '//www.hubspot.com/pricing/marketing',
      topText: 'Pricing'
    },
    navDropDownContent2: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-3  hsg-nav__group-item--has-dropdown',
      topText: 'Resources',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Education-icon.svg',
          sectionLabel: 'Education',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//blog.hubspot.com',
              headerText: 'Blog',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.com/resources/',
              headerText: 'Ebooks, Guides & More',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//academy.hubspot.com/courses',
              headerText: 'Free Courses & Certifications',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//www.hubspot.com/inbound-marketing',
              headerText: 'Inbound Methodology',
              gtm: ''
            }
          }
        },
        li1: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/WhyHubSpot%3F-icon.svg',
          sectionLabel: 'Why HubSpot?',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.com/case-studies',
              headerText: 'Case Studies',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.com/why-go-hubspot',
              headerText: 'Why Choose HubSpot?',
              gtm: ''
            }
          }
        },
        li2: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Services-icon.svg',
          sectionLabel: 'Services',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.com/services',
              headerText: 'Onboarding & Consulting Services',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//ecosystem.hubspot.com/marketplace/solutions',
              headerText: 'Hire a Service Provider',
              gtm: ''
            }
          }
        },
        li3: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Partners%26Developers-icon.svg',
          sectionLabel: 'User Resources',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.com/partners',
              headerText: 'Partner Programs',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//developers.hubspot.com/',
              headerText: 'Developer Tools',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//community.hubspot.com?profile.language=en',
              headerText: 'Community',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//ecosystem.hubspot.com/',
              headerText: 'HubSpot Ecosystem',
              gtm: ''
            }
          }
        }
      }
    },
    navDropDownContent3: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-4 hsg-nav__group-item--has-dropdown hsg-nav__group-item--about-mobile',
      topText: 'About',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.com/our-story',
              headerText: 'About Us',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.com/company/contact',
              headerText: 'Contact Us',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//www.hubspot.com/careers',
              headerText: 'Careers',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//www.hubspot.com/company/management',
              headerText: 'Management Team',
              gtm: ''
            }
          }
        }
      }
    }
  },
  navCta: {
    navCtaText: 'Get started',
    navCtaUrl: 'https://www.hubspot.com/products/get-started',
    navCtaClass: 'cta cta--regular cta--primary homepage-nav'
  }
};
var HeaderEN = withHeaderProps({
  lang: lang,
  contentBlob: enBlob
});

var lang$1 = 'de';
var deBlob = {
  upperNavContent: {
    homeUrl: '//www.hubspot.de',
    loginUrl: '//app.hubspot.com/login',
    loginText: 'Anmelden',
    supportUrl: '//help.hubspot.com/de/',
    supportText: 'Kundensupport',
    regionalDropdownContent: {
      contactUrl: '//offers.hubspot.de/contact-sales',
      contactText: 'Kontakt',
      languagesContent: {
        en: ['English', 'https://www.hubspot.com'],
        jp: ['日本語', 'https://www.hubspot.jp'],
        de: ['Deutsch', 'https://www.hubspot.de'],
        es: ['Español', 'https://www.hubspot.es'],
        pt: ['Português', 'https://br.hubspot.com'],
        fr: ['Français', 'https://www.hubspot.fr']
      }
    },
    aboutContent: {
      aboutLabel: 'Über uns',
      aboutText: 'Unsere Firmengeschichte',
      aboutUrl: '//www.hubspot.de/our-story',
      contactUsText: 'Kontaktieren Sie uns',
      contactUsUrl: '//www.hubspot.de/company/contact',
      careersText: 'Careers',
      careersUrl: '//www.hubspot.com/careers',
      managementText: 'Management Team',
      managementUrl: '//www.hubspot.com/company/management'
    }
  },
  mobileNavContent: {
    contactUrl: '//offers.hubspot.de/contact-sales',
    contactText: 'Kontakt',
    loginUrl: '//app.hubspot.com/login',
    loginText: 'Anmelden',
    searchPlaceholder: 'Suchen HubSpot.de',
    home: 'Home',
    homeUrl: '//www.hubspot.de',
    supportUrl: '//help.hubspot.com/de/',
    supportText: 'Kundensupport',
    languagesContent: {
      en: ['English', 'https://www.hubspot.com'],
      jp: ['日本語', 'https://www.hubspot.jp'],
      de: ['Deutsch', 'https://www.hubspot.de'],
      es: ['Español', 'https://www.hubspot.es'],
      pt: ['Português', 'https://br.hubspot.com'],
      fr: ['Français', 'https://www.hubspot.fr']
    }
  },
  searchContent: {
    searchPlaceholder: 'Suchen...',
    searchHubLabel: 'Im Web suchen',
    searchBlogLabel: 'Im Blog suchen',
    loadMoreText: 'Mehr Ergebnisse laden',
    cx: '009219321729865762236:1kczx_naofc',
    cxBlog: '009219321729865762236:496a5wfc6x4',
    noResultsContent: {
      h6: 'Merkwürdig ...',
      p1: 'Es wurde nicht ganz das Richtige gefunden.',
      p2: 'Versuchen Sie es noch einmal, indem Sie oben eine neue Suchanfrage eingeben.'
    }
  },
  mainNavContent: {
    navDropDownContent0: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-1  hsg-nav__group-item--has-dropdown',
      topText: 'Software',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row hsg-nav__dropdown-row--links',
          listRowContent: {
            a0: {
              htype: 3,
              headerText: 'Die CRM-Plattform von HubSpot',
              subtextContent: 'HubSpots Marketing-, Vertriebs-, Service-, CMS- und Operationssoftware, gebündelt in einer leistungsstarken Plattform'
            },
            a1: {
              url: '//www.hubspot.de/products/crm',
              htype: 3,
              headerText: 'Das kostenlose HubSpot CRM',
              gtm: 'crm'
            },
            a2: {
              url: '//www.hubspot.de/products/get-started',
              htype: 3,
              headerText: 'Die komplette CRM-Plattform',
              gtm: 'crm'
            }
          }
        },
        li1: {
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              url: '//www.hubspot.de/products/marketing',
              htype: 4,
              headerText: 'Marketing Hub',
              gtm: 'marketing',
              subtextContent: 'Marketing-Automatisierungssoftware <span class="highlight">Kostenlose und Premium-Pläne</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Marketing.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/MarketingHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Marketing Hub icon'
            },
            a1: {
              url: '//www.hubspot.de/products/sales',
              htype: 4,
              headerText: 'Sales Hub',
              gtm: 'sales',
              subtextContent: 'Sales-CRM-Software <span class="highlight">Kostenlose und Premium-Pläne</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Sales.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/SalesHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Sales Hub icon'
            },
            a2: {
              url: '//www.hubspot.de/products/service',
              htype: 4,
              headerText: 'Service Hub',
              gtm: 'service',
              subtextContent: 'Kundenservicesoftware <span class="highlight">Kostenlose und Premium-Pläne</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Service.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/ServiceHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Service Hub icon'
            },
            a3: {
              url: '//www.hubspot.de/products/cms',
              htype: 4,
              headerText: 'CMS Hub',
              gtm: 'cms',
              subtextContent: 'Content-Management-System-Software <span class="highlight">Kostenlose und Premium-Pläne</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/CMS.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/CMSHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'CMS Hub icon',
              hasRibbon: false
            },
            a4: {
              url: '//www.hubspot.de/products/operations',
              htype: 4,
              headerText: 'Operations Hub',
              gtm: 'ops',
              subtextContent: 'Operations-Software. <span class="highlight">Kostenlose und Premium-Pläne</span>',
              iconSrc: '//www.hubspot.com/hubfs/assets/hubspot.com/web-team/WBZ/Navigation/operations.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/OperationsHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Operations icon',
              hasRibbon: false
            }
          }
        },
        li2: {
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row hsg-nav__dropdown-row--links hsg-nav__dropdown-row--links-horizontal',
          listRowContent: {
            a0: {
              url: '//ecosystem.hubspot.com/de/marketplace/apps',
              htype: 6,
              headerText: 'App Marketplace',
              gtm: 'app',
              subtextContent: 'Bevorzugte Apps mit HubSpot verknüpfen <span class="highlight">Alle Integrationen ansehen</span>'
            }
          }
        }
      }
    },
    navDropDownContent1: {
      hasDropDown: false,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-2',
      topUrl: '//www.hubspot.de/pricing/marketing',
      topText: 'Preise'
    },
    navDropDownContent2: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-3  hsg-nav__group-item--has-dropdown',
      topText: 'Ressourcen',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Education-icon.svg',
          sectionLabel: 'Wissenswertes',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//blog.hubspot.de/',
              headerText: 'Blog',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.de/marketing-bibliothek',
              headerText: 'E-Books, Webinare & mehr',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//www.hubspot.de/business-templates/',
              headerText: 'Professionelle Vorlagen zum Download',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//academy.hubspot.de/courses',
              headerText: 'Kurse der HubSpot Academy',
              gtm: ''
            },
            a4: {
              htype: null,
              url: '//www.hubspot.de/inbound-marketing',
              headerText: 'Inbound-Methodik',
              gtm: ''
            },
            a5: {
              htype: null,
              url: '//www.hubspot.de/marketing-statistics',
              headerText: 'Forschungsberichte & Statistiken',
              gtm: ''
            },
            a6: {
              htype: null,
              url: '//www.hubspot.de/podcasts',
              headerText: 'Deutschsprachige HubSpot-Podcasts',
              gtm: ''
            }
          }
        },
        li1: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/WhyHubSpot%3F-icon.svg',
          sectionLabel: 'Warum HubSpot?',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.de/case-studies',
              headerText: 'Fallstudien',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.de/why-go-hubspot',
              headerText: 'Warum HubSpot?',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//www.hubspot.de/berlin',
              headerText: 'HubSpot in Deutschland',
              gtm: ''
            }
          }
        },
        li2: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Services-icon.svg',
          sectionLabel: 'Services',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.de/services',
              headerText: 'Onboarding & Beratungsservices',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//ecosystem.hubspot.com/de/marketplace/solutions',
              headerText: 'Finden Sie Ihren perfekten Partner im Anbieterverzeichnis',
              gtm: ''
            }
          }
        },
        li3: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Partners%26Developers-icon.svg',
          sectionLabel: 'Benutzerressouren',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.de/partners',
              headerText: 'Partnerprogramme',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//developers.hubspot.com/',
              headerText: 'Developer Tools',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//community.hubspot.com/',
              headerText: 'Community',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//ecosystem.hubspot.com/de',
              headerText: 'HubSpot Ecosystem',
              gtm: ''
            }
          }
        }
      }
    },
    navDropDownContent3: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-4 hsg-nav__group-item--has-dropdown hsg-nav__group-item--about-mobile',
      topText: 'Über uns',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.de/our-story',
              headerText: 'Unsere Firmengeschichte',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.de/company/contact',
              headerText: 'Kontaktieren Sie uns',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//www.hubspot.com/careers',
              headerText: 'Careers',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//www.hubspot.com/company/management',
              headerText: 'Management Team',
              gtm: ''
            }
          }
        }
      }
    }
  },
  navCta: {
    navCtaText: 'HubSpot kostenlos nutzen',
    navCtaUrl: '//www.hubspot.de/products/get-started',
    navCtaClass: 'cta cta--regular cta--primary homepage-nav'
  }
};
var HeaderDE = withHeaderProps({
  lang: lang$1,
  contentBlob: deBlob
});

var lang$2 = 'es';
var esBlob = {
  upperNavContent: {
    homeUrl: '//www.hubspot.es',
    loginUrl: '//app.hubspot.com/login',
    loginText: 'Iniciar sesión',
    supportUrl: '//help.hubspot.com/es/',
    supportText: 'Atención al cliente',
    regionalDropdownContent: {
      contactUrl: '//offers.hubspot.es/contact-sales',
      contactText: 'Contactar con ventas',
      languagesContent: {
        en: ['English', 'https://www.hubspot.com'],
        jp: ['日本語', 'https://www.hubspot.jp'],
        de: ['Deutsch', 'https://www.hubspot.de'],
        es: ['Español', 'https://www.hubspot.es'],
        pt: ['Português', 'https://br.hubspot.com'],
        fr: ['Français', 'https://www.hubspot.fr']
      }
    },
    aboutContent: {
      aboutLabel: 'Sobre nosotros',
      aboutText: 'Sobre nosotros',
      aboutUrl: '//www.hubspot.es/our-story',
      contactUsText: 'Contacto',
      contactUsUrl: '//www.hubspot.es/company/contact',
      careersText: 'Trabaja con nosotros',
      careersUrl: '//www.hubspot.com/careers',
      managementText: 'Equipo directivo',
      managementUrl: '//www.hubspot.com/company/management'
    }
  },
  mobileNavContent: {
    contactUrl: '//offers.hubspot.es/contact-sales',
    contactText: 'Contacta con nosotros',
    ctaUrl: '//www.hubspot.es/products/get-started',
    ctaText: 'Comienza ahora',
    loginUrl: '//app.hubspot.com/login',
    loginText: 'Iniciar sesión',
    searchPlaceholder: 'Buscar HubSpot.es',
    home: 'Inicio',
    homeUrl: '//www.hubspot.es',
    supportUrl: '//help.hubspot.com/es/',
    supportText: 'Atención al cliente',
    languagesContent: {
      en: ['English', 'https://www.hubspot.com'],
      jp: ['日本語', 'https://www.hubspot.jp'],
      de: ['Deutsch', 'https://www.hubspot.de'],
      es: ['Español', 'https://www.hubspot.es'],
      pt: ['Português', 'https://br.hubspot.com'],
      fr: ['Français', 'https://www.hubspot.fr']
    }
  },
  searchContent: {
    searchPlaceholder: 'Buscar...',
    searchHubLabel: 'Buscar en la web',
    searchBlogLabel: 'Buscar en el blog',
    loadMoreText: 'Cargar más resultados',
    cx: '009219321729865762236:8effq6e-rmu',
    cxBlog: '004277018879803690427:uchhvqy6ac8',
    noResultsContent: {
      h6: 'Qué extraño…',
      p1: 'No pudimos encontrar ningún resultado.',
      p2: 'No te preocupes, vuelve a intentarlo buscando en la parte superior.'
    }
  },
  mainNavContent: {
    navDropDownContent0: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-1  hsg-nav__group-item--has-dropdown',
      topText: 'Software',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row hsg-nav__dropdown-row--links',
          listRowContent: {
            a0: {
              htype: 3,
              headerText: 'La plataforma CRM de HubSpot',
              subtextContent: 'Todo el software de HubSpot para marketing, ventas, asistencia técnica, CMS y operaciones en una sola plataforma.'
            },
            a1: {
              url: '//www.hubspot.es/products/crm',
              htype: 3,
              headerText: 'CRM gratuito de HubSpot',
              gtm: 'crm'
            },
            a2: {
              url: '//www.hubspot.es/products/get-started',
              htype: 3,
              headerText: 'Plataforma de CRM completa',
              gtm: 'crm'
            }
          }
        },
        li1: {
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              url: '//www.hubspot.es/products/marketing',
              htype: 4,
              headerText: 'Marketing Hub',
              gtm: 'marketing',
              subtextContent: 'Software de automatización de marketing. <span class="highlight">Planes gratuitos y prémium</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Marketing.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/MarketingHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Marketing Hub icon'
            },
            a1: {
              url: '//www.hubspot.es/products/sales',
              htype: 4,
              headerText: 'Sales Hub',
              gtm: 'sales',
              subtextContent: 'Software CRM para ventas. <span class="highlight">Planes gratuitos y prémium</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Sales.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/SalesHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Sales Hub icon'
            },
            a2: {
              url: '//www.hubspot.es/products/service',
              htype: 4,
              headerText: 'Service Hub',
              gtm: 'service',
              subtextContent: 'Software de atención al cliente. <span class="highlight">Planes gratuitos y prémium</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Service.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/ServiceHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Service Hub icon'
            },
            a3: {
              url: '//www.hubspot.es/products/cms',
              htype: 4,
              headerText: 'CMS Hub',
              gtm: 'cms',
              subtextContent: 'Sistema de gestión de contenido prémium. <span class="highlight">Planes gratuitos y prémium</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/CMS.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/CMSHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'CMS Hub icon',
              hasRibbon: false
            },
            a4: {
              url: '//www.hubspot.es/products/operations',
              htype: 4,
              headerText: 'Operations Hub',
              gtm: 'ops',
              subtextContent: 'Software de operaciones. <span class="highlight">Planes gratuitos y prémium</span>',
              iconSrc: '//www.hubspot.com/hubfs/assets/hubspot.com/web-team/WBZ/Navigation/operations.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/OperationsHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Operations icon',
              hasRibbon: false
            }
          }
        },
        li2: {
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row hsg-nav__dropdown-row--links hsg-nav__dropdown-row--links-horizontal',
          listRowContent: {
            a0: {
              url: '//ecosystem.hubspot.com/es/marketplace/apps',
              htype: 6,
              headerText: 'Mercado de apps',
              gtm: 'app',
              subtextContent: 'Conecta tus apps preferidas con HubSpot. <span class="highlight">Ver todas las integraciones</span>'
            }
          }
        }
      }
    },
    navDropDownContent1: {
      hasDropDown: false,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-2',
      topUrl: '//www.hubspot.es/pricing/marketing',
      topText: 'Precios'
    },
    navDropDownContent2: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-3  hsg-nav__group-item--has-dropdown',
      topText: 'Recursos',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Education-icon.svg',
          sectionLabel: 'Formación',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//blog.hubspot.es',
              headerText: 'Blog',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.es/biblioteca-marketing',
              headerText: 'Ebooks, guías y más',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//academy.hubspot.es',
              headerText: 'Capacitación y certificaciones gratis',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//www.hubspot.es/inbound-marketing',
              headerText: 'Metodología inbound',
              gtm: ''
            },
            a4: {
              htype: null,
              url: '//offers.hubspot.es/transformacion-digital',
              headerText: 'Recursos para la Transformación Digital',
              gtm: ''
            },
            a5: {
              htype: null,
              url: '//www.hubspot.es/estado-del-marketing',
              headerText: 'Estado del Marketing 2020',
              gtm: ''
            },
            a6: {
              htype: null,
              url: '//www.hubspot.es/marketing-statistics',
              headerText: 'Reportes y Estadísticas',
              gtm: ''
            }
          }
        },
        li1: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/WhyHubSpot%3F-icon.svg',
          sectionLabel: '¿Por qué HubSpot?',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.es/case-studies',
              headerText: 'Casos de éxito',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.es/why-go-hubspot',
              headerText: '¿Por qué elegir HubSpot?',
              gtm: ''
            }
          }
        },
        li2: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Services-icon.svg',
          sectionLabel: 'Servicios',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.es/services',
              headerText: 'Incorporación y consultoría',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//ecosystem.hubspot.com/es/marketplace/solutions',
              headerText: 'Contratar proveedor de servicios',
              gtm: ''
            }
          }
        },
        li3: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Partners%26Developers-icon.svg',
          sectionLabel: 'Recursos de usuario',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.es/partners',
              headerText: 'Programas para partners',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//developers.hubspot.com/',
              headerText: 'Herramientas para desarrolladores',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//community.hubspot.com?profile.language=es',
              headerText: 'Comunidad',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//ecosystem.hubspot.com/es',
              headerText: 'Ecosistema HubSpot',
              gtm: ''
            }
          }
        }
      }
    },
    navDropDownContent3: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-4 hsg-nav__group-item--has-dropdown hsg-nav__group-item--about-mobile',
      topText: 'Sobre nosotros',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.es/our-story',
              headerText: 'Sobre nosotros',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.es/company/contact',
              headerText: 'Contacto',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//www.hubspot.com/careers',
              headerText: 'Trabaja con nosotros',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//www.hubspot.com/company/management',
              headerText: 'Equipo directivo',
              gtm: ''
            }
          }
        }
      }
    }
  },
  navCta: {
    navCtaText: 'Obtener HubSpot gratis',
    navCtaUrl: '//www.hubspot.es/products/get-started',
    navCtaClass: 'cta cta--regular cta--primary homepage-nav'
  }
};
var HeaderES = withHeaderProps({
  lang: lang$2,
  contentBlob: esBlob
});

var lang$3 = 'fr';
var frBlob = {
  upperNavContent: {
    homeUrl: '//www.hubspot.fr',
    loginUrl: '//app.hubspot.com/login',
    loginText: 'S\'identifier',
    supportUrl: '//help.hubspot.com/fr/',
    supportText: 'Centre d\'aide',
    regionalDropdownContent: {
      contactUrl: '//offers.hubspot.fr/contact-sales',
      contactText: 'Nous contacter',
      languagesContent: {
        en: ['English', 'https://www.hubspot.com'],
        jp: ['日本語', 'https://www.hubspot.jp'],
        de: ['Deutsch', 'https://www.hubspot.de'],
        es: ['Español', 'https://www.hubspot.es'],
        pt: ['Português', 'https://br.hubspot.com'],
        fr: ['Français', 'https://www.hubspot.fr']
      }
    },
    aboutContent: {
      aboutLabel: 'À propos',
      aboutText: 'À propos de HubSpot',
      aboutUrl: '//www.hubspot.fr/our-story',
      contactUsText: 'Contact',
      contactUsUrl: '//www.hubspot.fr/company/contact',
      careersText: 'Carrières',
      careersUrl: '//www.hubspot.com/careers',
      managementText: 'Équipe de direction',
      managementUrl: '//www.hubspot.fr/company/management'
    }
  },
  mobileNavContent: {
    contactUrl: '//offers.hubspot.fr/contact-sales',
    contactText: 'Nous contacter',
    ctaUrl: '//www.hubspot.fr/products/get-started',
    ctaText: 'Faites vos premiers pas',
    loginUrl: '//app.hubspot.com/login',
    loginText: 'S\'identifier',
    searchPlaceholder: 'Recherche HubSpot.fr',
    home: 'Accueil',
    homeUrl: '//www.hubspot.fr',
    supportUrl: '//help.hubspot.com/fr/',
    supportText: 'Centre d\'aide',
    languagesContent: {
      en: ['English', 'https://www.hubspot.com'],
      jp: ['日本語', 'https://www.hubspot.jp'],
      de: ['Deutsch', 'https://www.hubspot.de'],
      es: ['Español', 'https://www.hubspot.es'],
      pt: ['Português', 'https://br.hubspot.com'],
      fr: ['Français', 'https://www.hubspot.fr']
    }
  },
  searchContent: {
    searchPlaceholder: 'Recherche...',
    searchHubLabel: 'Chercher sur le site',
    searchBlogLabel: 'Chercher sur le blog',
    loadMoreText: 'Voir plus de résultats',
    cx: '009219321729865762236:evekf1vse58',
    cxBlog: '009219321729865762236:ba8x2a0scro',
    noResultsContent: {
      h6: 'C\'est étrange...',
      p1: 'Nous n\'avons pas trouvé de résultat pertinent.',
      p2: 'Voulez-vous renouveler votre recherche ?'
    }
  },
  mainNavContent: {
    navDropDownContent0: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-1  hsg-nav__group-item--has-dropdown',
      topText: 'Logiciel',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row hsg-nav__dropdown-row--links',
          listRowContent: {
            a0: {
              htype: 3,
              headerText: 'La plateforme CRM de HubSpot',
              subtextContent: 'L\'ensemble des logiciels de marketing, de vente, de service client, de gestion de contenu et d\'opérations sur une plateforme unique.',
              gtm: 'crm'
            },
            a1: {
              url: '//www.hubspot.fr/products/crm',
              htype: 3,
              headerText: 'CRM gratuit de HubSpot',
              gtm: 'crm'
            },
            a2: {
              url: '//www.hubspot.fr/products/get-started',
              htype: 3,
              headerText: 'Plateforme CRM complète',
              gtm: 'crm'
            }
          }
        },
        li1: {
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              url: '//www.hubspot.fr/products/marketing',
              htype: 4,
              headerText: 'Marketing Hub',
              gtm: 'marketing',
              subtextContent: 'Logiciel de marketing automation. <span class="highlight">Outils gratuits et abonnements payants</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Marketing.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/MarketingHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Hub Marketing icon'
            },
            a1: {
              url: '//www.hubspot.fr/products/sales',
              htype: 4,
              headerText: 'Sales Hub',
              gtm: 'sales',
              subtextContent: 'Logiciel CRM de vente. <span class="highlight">Outils gratuits et abonnements payants</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Sales.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/SalesHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Hub Sales icon'
            },
            a2: {
              url: '//www.hubspot.fr/products/service',
              htype: 4,
              headerText: 'Service Hub',
              gtm: 'service',
              subtextContent: 'Logiciel de service client. <span class="highlight">Outils gratuits et abonnements payants</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Service.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/ServiceHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Hub Services icon'
            },
            a3: {
              url: '//www.hubspot.fr/products/cms',
              htype: 4,
              headerText: 'CMS Hub',
              gtm: 'cms',
              subtextContent: 'Logiciel de gestion de contenu. <span class="highlight">Outils gratuits et abonnements payants</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/CMS.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/CMSHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Hub CMS icon'
            },
            a4: {
              url: '//www.hubspot.fr/products/operations',
              htype: 4,
              headerText: 'Operations Hub',
              gtm: 'ops',
              subtextContent: 'Logiciel d\'opérations de revenus. <span class="highlight">Outils gratuits et abonnements payants</span>',
              iconSrc: '//www.hubspot.com/hubfs/assets/hubspot.com/web-team/WBZ/Navigation/operations.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/OperationsHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Hub Operations icon',
              hasRibbon: false
            }
          }
        },
        li2: {
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row hsg-nav__dropdown-row--links hsg-nav__dropdown-row--links-horizontal',
          listRowContent: {
            a0: {
              url: '//ecosystem.hubspot.com/fr/marketplace/apps',
              htype: 6,
              headerText: 'Marketplace des applications',
              gtm: 'app',
              subtextContent: 'Connectez vos applications préférées à HubSpot. <span class="highlight">Voir toutes les intégrations</span>'
            }
          }
        }
      }
    },
    navDropDownContent1: {
      hasDropDown: false,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-2',
      topUrl: '//www.hubspot.fr/pricing/marketing',
      topText: 'Tarifs'
    },
    navDropDownContent2: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-3  hsg-nav__group-item--has-dropdown',
      topText: 'Ressources',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Education-icon.svg',
          sectionLabel: 'Contenu éducatif',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//blog.hubspot.fr/',
              headerText: 'Blog',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.fr/marketing-bibliothèque',
              headerText: 'E-books, rapports et modèles',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//academy.hubspot.fr',
              headerText: 'Certifications et formations gratuites',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//www.hubspot.fr/inbound-marketing',
              headerText: 'Méthodologie inbound',
              gtm: ''
            }
          }
        },
        li1: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/WhyHubSpot%3F-icon.svg',
          sectionLabel: 'Ils ont choisi HubSpot',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.fr/case-studies',
              headerText: 'Études de cas',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.fr/why-go-hubspot',
              headerText: 'Pourquoi choisir HubSpot ?',
              gtm: ''
            }
          }
        },
        li2: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Services-icon.svg',
          sectionLabel: 'Services',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.fr/services',
              headerText: 'Services d\'onboarding et de consulting',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//ecosystem.hubspot.com/fr/marketplace/solutions',
              headerText: 'Annuaire des prestataires de services',
              gtm: ''
            }
          }
        },
        li3: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Partners%26Developers-icon.svg',
          sectionLabel: 'Ressources utilisateurs',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.fr/partners',
              headerText: 'Programmes de partenariat',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//developers.hubspot.com/',
              headerText: 'Outils pour développeurs',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//community.hubspot.com?profile.language=fr',
              headerText: 'Communauté',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '///ecosystem.hubspot.com/fr',
              headerText: 'Écosystème HubSpot',
              gtm: ''
            }
          }
        }
      }
    },
    navDropDownContent3: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-4 hsg-nav__group-item--has-dropdown hsg-nav__group-item--about-mobile',
      topText: 'À propos',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.fr/our-story',
              headerText: 'À propos de HubSpot',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.fr/company/contact',
              headerText: 'Contact',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//www.hubspot.com/careers',
              headerText: 'Carrières',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//www.hubspot.fr/company/management',
              headerText: 'Équipe de direction',
              gtm: ''
            }
          }
        }
      }
    }
  },
  navCta: {
    navCtaText: 'Faites vos premiers pas',
    navCtaUrl: 'https://www.hubspot.fr/products/get-started',
    navCtaClass: 'cta cta--regular cta--primary homepage-nav'
  }
};
var HeaderFR = withHeaderProps({
  lang: lang$3,
  contentBlob: frBlob
});

var lang$4 = 'jp';
var jpBlob = {
  upperNavContent: {
    homeUrl: '//www.hubspot.jp',
    loginUrl: '//app.hubspot.com/login',
    loginText: 'サインイン',
    supportUrl: '//help.hubspot.com/ja/',
    supportText: 'カスタマーサポート',
    regionalDropdownContent: {
      contactUrl: '//offers.hubspot.jp/contact-sales',
      contactText: 'お問い合わせ',
      languagesContent: {
        en: ['English', 'https://www.hubspot.com'],
        jp: ['日本語', 'https://www.hubspot.jp'],
        de: ['Deutsch', 'https://www.hubspot.de'],
        es: ['Español', 'https://www.hubspot.es'],
        pt: ['Português', 'https://br.hubspot.com'],
        fr: ['Français', 'https://www.hubspot.fr']
      }
    },
    aboutContent: {
      aboutLabel: '会社情報',
      aboutText: '沿革とビジョン',
      aboutUrl: '//www.hubspot.jp/our-story',
      contactUsText: 'お問い合わせ',
      contactUsUrl: '//www.hubspot.jp/company/contact',
      careersText: '採用情報',
      careersUrl: '//www.hubspot.jp/work-in-tokyo',
      managementText: '役員紹介',
      managementUrl: '//www.hubspot.jp/company/management'
    }
  },
  mobileNavContent: {
    contactUrl: '//offers.hubspot.jp/contact-sales',
    contactText: 'お問い合わせ',
    ctaUrl: '//www.hubspot.jp/products/get-started',
    ctaText: '無料で試す',
    loginUrl: '//app.hubspot.com/login',
    loginText: 'サインイン',
    searchPlaceholder: 'hubspot.jpを検索',
    home: 'ホーム',
    homeUrl: '//www.hubspot.jp',
    supportUrl: '//help.hubspot.com/ja/',
    supportText: 'カスタマーサポート',
    languagesContent: {
      en: ['English', 'https://www.hubspot.com'],
      jp: ['日本語', 'https://www.hubspot.jp'],
      de: ['Deutsch', 'https://www.hubspot.de'],
      es: ['Español', 'https://www.hubspot.es'],
      pt: ['Português', 'https://br.hubspot.com'],
      fr: ['Français', 'https://www.hubspot.fr']
    }
  },
  searchContent: {
    searchPlaceholder: '検索...',
    searchHubLabel: 'ウェブ検索',
    searchBlogLabel: 'ブログ検索',
    loadMoreText: '検索結果をさらに読み込む',
    cx: '009219321729865762236:nxpyori8uxy',
    cxBlog: '004277018879803690427:rvcirpqoxu0',
    noResultsContent: {
      h6: '変ですね...',
      p1: '完全に一致した結果が見つかりませんでした。',
      p2: '心配いりません。もう一度検索ワードを変えてお試しください。'
    }
  },
  mainNavContent: {
    navDropDownContent0: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-1  hsg-nav__group-item--has-dropdown',
      topText: 'ソフトウェア',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row hsg-nav__dropdown-row--links',
          listRowContent: {
            a0: {
              htype: 3,
              headerText: 'HubSpot CRMプラットフォーム',
              gtm: 'crm',
              subtextContent: 'マーケティングから営業、コンテンツ管理、カスタマーサービス、オペレーションに至るまで、HubSpotのCRMプラットフォームはさまざまな業務に欠かせないツールや連携機能を備えています。'
            },
            a1: {
              url: '//www.hubspot.jp/products/crm',
              htype: 3,
              headerText: '無料でHubSpot CRMを試してみる',
              gtm: 'crm'
            },
            a2: {
              url: '/www.hubspot.jp/products/get-started',
              htype: 3,
              headerText: '統合型CRMプラットフォーム',
              gtm: 'crm'
            }
          }
        },
        li1: {
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              url: '//www.hubspot.jp/products/marketing',
              htype: 4,
              headerText: 'Marketing Hub',
              gtm: 'marketing',
              subtextContent: 'マーケティングオートメーション（MA）ソフトウェア。<span class="highlight">無料ツールからプレミアムエディションまでご用意</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Marketing.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/MarketingHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Marketing Hub icon'
            },
            a1: {
              url: '//www.hubspot.jp/products/sales',
              htype: 4,
              headerText: 'Sales Hub',
              gtm: 'sales',
              subtextContent: '営業支援CRMソフトウェア。<span class="highlight">無料ツールからプレミアムエディションまでご用意</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Sales.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/SalesHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Sales Hub icon'
            },
            a2: {
              url: '//www.hubspot.jp/products/service',
              htype: 4,
              headerText: 'Services Hub',
              gtm: 'service',
              subtextContent: 'カスタマー サービス ソフトウェア。 <span class="highlight">無料ツールからプレミアムエディションまでご用意</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Service.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/ServiceHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Services Hub icon'
            },
            a3: {
              url: '//www.hubspot.jp/products/cms',
              htype: 4,
              headerText: 'CMS Hub',
              gtm: 'cms',
              subtextContent: 'コンテンツ マネジメント システム（CMS）。<span class="highlight">無料ツールからプレミアムエディションまでご用意</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/CMS.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/CMSHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'CMS Hub icon',
              hasRibbon: false
            },
            a4: {
              url: '//www.hubspot.jp/products/operations',
              htype: 4,
              headerText: 'Operations Hub',
              gtm: 'ops',
              subtextContent: ' オペレーション支援ソフトウェア。<span class="highlight">無料ツールからプレミアムエディションまでご用意</span>',
              iconSrc: '//www.hubspot.com/hubfs/assets/hubspot.com/web-team/WBZ/Navigation/operations.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/OperationsHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Operations Hub icon',
              hasRibbon: false
            }
          }
        },
        li2: {
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row hsg-nav__dropdown-row--links hsg-nav__dropdown-row--links-horizontal',
          listRowContent: {
            a0: {
              url: '//ecosystem.hubspot.com/ja/marketplace/apps',
              htype: 6,
              headerText: 'アプリマーケットプレイス',
              gtm: 'app',
              subtextContent: '日常的にご利用のツールとHubSpotを連携できます。 <span class="highlight">連携可能なツールはこちら</span>'
            }
          }
        }
      }
    },
    navDropDownContent1: {
      hasDropDown: false,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-2',
      topUrl: '//www.hubspot.jp/pricing/marketing',
      topText: '価格表'
    },
    navDropDownContent2: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-3  hsg-nav__group-item--has-dropdown',
      topText: '参考資料と導入事例',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Education-icon.svg',
          sectionLabel: '学習コンテンツ',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//blog.hubspot.jp',
              headerText: 'ブログ',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.jp/marketing-library',
              headerText: '無料のお役立ち資料&ノウハウ',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//academy.hubspot.jp/courses',
              headerText: 'HubSpotの認定資格制度',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//www.hubspot.jp/hubspot-events',
              headerText: 'セミナー及びイベント情報',
              gtm: ''
            },
            a4: {
              htype: null,
              url: '//www.hubspot.jp/inbound-marketing',
              headerText: 'インバウンド手法',
              gtm: ''
            }
          }
        },
        li1: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/WhyHubSpot%3F-icon.svg',
          sectionLabel: 'HubSpotのメリット',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.jp/case-studies',
              headerText: '導入事例',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.jp/why-go-hubspot',
              headerText: 'HubSpotが選ばれる理由',
              gtm: ''
            }
          }
        },
        li2: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Services-icon.svg',
          sectionLabel: 'サービス',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.jp/services',
              headerText: '導入支援とコンサルティングサービス',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//ecosystem.hubspot.com/ja/marketplace/solutions/japan',
              headerText: 'パートナー等を探す',
              gtm: ''
            }
          }
        },
        li3: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Partners%26Developers-icon.svg',
          sectionLabel: 'ユーザー向けリソース',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.jp/partners',
              headerText: 'パートナープログラム',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//developers.hubspot.com/',
              headerText: '開発者向けページ',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//community.hubspot.com?profile.language=ja',
              headerText: 'コミュニティー',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//ecosystem.hubspot.com/ja',
              headerText: 'HubSpotエコシステム',
              gtm: ''
            }
          }
        }
      }
    },
    navDropDownContent3: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-4 hsg-nav__group-item--has-dropdown hsg-nav__group-item--about-mobile',
      topText: '会社情報',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.jp/our-story',
              headerText: '沿革とビジョン',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.jp/company/contact',
              headerText: 'お問い合わせ',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//www.hubspot.jp/work-in-tokyo',
              headerText: '採用情報',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//www.hubspot.jp/company/management',
              headerText: '経営チーム紹介',
              gtm: ''
            }
          }
        }
      }
    }
  },
  navCta: {
    navCtaText: '無料で試す',
    navCtaUrl: 'https://www.hubspot.jp/products/get-started',
    navCtaClass: 'cta cta--regular cta--primary homepage-nav'
  }
};
var HeaderJP = withHeaderProps({
  lang: lang$4,
  contentBlob: jpBlob
});

var lang$5 = 'pt';
var ptBlob = {
  upperNavContent: {
    homeUrl: '//br.hubspot.com',
    loginUrl: '//app.hubspot.com/login',
    loginText: 'Log in',
    supportUrl: '//help.hubspot.com/pt/',
    supportText: 'Suporte ao cliente',
    regionalDropdownContent: {
      contactUrl: '//br.hubspot.com/ofertas/contact-sales',
      contactText: 'Fale com um representante de vendas',
      languagesContent: {
        en: ['English', 'https://www.hubspot.com'],
        jp: ['日本語', 'https://www.hubspot.jp'],
        de: ['Deutsch', 'https://www.hubspot.de'],
        es: ['Español', 'https://www.hubspot.es'],
        pt: ['Português', 'https://br.hubspot.com'],
        fr: ['Français', 'https://www.hubspot.fr']
      }
    },
    aboutContent: {
      aboutLabel: 'Sobre',
      aboutText: 'Sobre nós',
      aboutUrl: '//br.hubspot.com/our-story',
      contactUsText: 'Entre em contato conosco',
      contactUsUrl: '//br.hubspot.com/company/contact',
      careersText: 'Trabalhe conosco',
      careersUrl: '//www.hubspot.com/careers',
      managementText: 'Equipe de gestão',
      managementUrl: '//www.hubspot.com/company/management'
    }
  },
  mobileNavContent: {
    contactUrl: '//br.hubspot.com/contact-sales',
    contactText: 'Entre em contato',
    ctaUrl: '//br.hubspot.com/products/get-started',
    ctaText: 'Comece agora',
    loginUrl: '//app.hubspot.com/login',
    loginText: 'Log in',
    searchPlaceholder: 'Buscar br.HubSpot',
    home: 'Início',
    homeUrl: '//br.hubspot.com',
    supportUrl: '//help.hubspot.com/pt/',
    supportText: 'Suporte ao cliente',
    languagesContent: {
      en: ['English', 'https://www.hubspot.com'],
      jp: ['日本語', 'https://www.hubspot.jp'],
      de: ['Deutsch', 'https://www.hubspot.de'],
      es: ['Español', 'https://www.hubspot.es'],
      pt: ['Português', 'https://br.hubspot.com'],
      fr: ['Français', 'https://www.hubspot.fr']
    }
  },
  searchContent: {
    searchPlaceholder: 'Buscar...',
    searchHubLabel: 'Busca no site',
    searchBlogLabel: 'Busca no blog',
    loadMoreText: 'Carregar mais resultados',
    cx: '009219321729865762236:6ks7vjxvwjo',
    cxBlog: '009219321729865762236:bv8gxqzxqpo',
    noResultsContent: {
      h6: 'Estranho...',
      p1: 'Não foi possível encontrar a palavra desejada.',
      p2: 'Não se preocupe, você pode pesquisar novamente lá em cima.'
    }
  },
  mainNavContent: {
    navDropDownContent0: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-1  hsg-nav__group-item--has-dropdown',
      topText: 'Software',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row hsg-nav__dropdown-row--links',
          listRowContent: {
            a0: {
              htype: 3,
              headerText: 'Plataforma de CRM da HubSpot',
              gtm: 'crm',
              subtextContent: 'Todos os softwares da HubSpot de marketing, CRM de vendas, atendimento ao cliente, CMS e operações em uma só plataforma.'
            },
            a1: {
              url: '//br.hubspot.com/products/crm',
              htype: 3,
              headerText: 'CRM grátis',
              gtm: 'crm'
            },
            a2: {
              url: '//br.hubspot.com/products/get-started',
              htype: 3,
              headerText: 'Plataforma de CRM completa',
              gtm: 'crm'
            }
          }
        },
        li1: {
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              url: '//br.hubspot.com/products/marketing',
              htype: 4,
              headerText: 'Marketing Hub',
              gtm: 'marketing',
              subtextContent: 'Software de automação de marketing. <span class="highlight">Planos gratuitos e premium</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Marketing.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/MarketingHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Marketing Hub icon'
            },
            a1: {
              url: '//br.hubspot.com/products/sales',
              htype: 4,
              headerText: 'Sales Hub',
              gtm: 'sales',
              subtextContent: 'Software de atendimento ao cliente. <span class="highlight">Planos gratuitos e premium</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Sales.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/SalesHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Sales Hub icon'
            },
            a2: {
              url: '//br.hubspot.com/products/service',
              htype: 4,
              headerText: 'Service Hub',
              gtm: 'service',
              subtextContent: 'Software para você oferecer um atendimento de alto nível ao cliente. <span class="highlight">Planos gratuitos e premium</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Service.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/ServiceHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Service Hub icon'
            },
            a3: {
              url: '//br.hubspot.com/products/cms',
              htype: 4,
              headerText: 'CMS Hub',
              gtm: 'cms',
              subtextContent: 'Software para sistema de gestão de conteúdo. <span class="highlight">Planos gratuitos e premium</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/CMS.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/CMSHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'CMS Hub icon',
              hasRibbon: false
            },
            a4: {
              url: '//br.hubspot.com/products/operations',
              htype: 4,
              headerText: 'Operations Hub',
              gtm: 'ops',
              subtextContent: 'Software de operações. <span class="highlight">Planos gratuitos e premium</span>',
              iconSrc: '//www.hubspot.com/hubfs/assets/hubspot.com/web-team/WBZ/Navigation/operations.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/OperationsHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Operations Hub icon',
              hasRibbon: false
            }
          }
        },
        li2: {
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row hsg-nav__dropdown-row--links hsg-nav__dropdown-row--links-horizontal',
          listRowContent: {
            a0: {
              url: '//ecosystem.hubspot.com/pt/marketplace/apps',
              htype: 6,
              headerText: 'App Marketplace',
              gtm: 'app',
              subtextContent: 'Conecte seus aplicativos favoritos à HubSpot. <span class="highlight">Veja todas as integrações</span>'
            }
          }
        }
      }
    },
    navDropDownContent1: {
      hasDropDown: false,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-2',
      topUrl: '//br.hubspot.com/pricing/marketing',
      topText: 'Preços'
    },
    navDropDownContent2: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-3  hsg-nav__group-item--has-dropdown',
      topText: 'Recursos',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Education-icon.svg',
          sectionLabel: 'Treinamento',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//br.hubspot.com/blog',
              headerText: 'Blog',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.com/resources/',
              headerText: 'E-books, guias e muito mais',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//academy.hubspot.com/courses',
              headerText: 'Free Courses & Certifications',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//academy.hubspot.com/courses',
              headerText: 'Cursos e certificações gratuitos',
              gtm: ''
            },
            a4: {
              htype: null,
              url: '//www.hubspot.com/inbound-marketing',
              headerText: 'Metodologia inbound',
              gtm: ''
            }
          }
        },
        li1: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/WhyHubSpot%3F-icon.svg',
          sectionLabel: 'Por que a HubSpot?',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.com/case-studies',
              headerText: 'Estudos de caso',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//br.hubspot.com/why-go-hubspot',
              headerText: 'Por que escolher a HubSpot?',
              gtm: ''
            }
          }
        },
        li2: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Services-icon.svg',
          sectionLabel: 'Serviços',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//br.hubspot.com/services',
              headerText: 'Onboarding e serviços de consultoria',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//ecosystem.hubspot.com/pt/marketplace/solutions',
              headerText: 'Contrate um prestador de serviços',
              gtm: ''
            }
          }
        },
        li3: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Partners%26Developers-icon.svg',
          sectionLabel: 'Recursos para o usuário',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//br.hubspot.com/partners',
              headerText: 'Programas de parceiros',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//developers.hubspot.com/',
              headerText: 'Ferramentas para desenvolvedores',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//community.hubspot.com?profile.language=pt-br',
              headerText: 'Comunidade',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//ecosystem.hubspot.com/pt',
              headerText: 'Ecossistema HubSpot',
              gtm: ''
            }
          }
        }
      }
    },
    navDropDownContent3: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-4 hsg-nav__group-item--has-dropdown hsg-nav__group-item--about-mobile',
      topText: 'Sobre',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          listRowContent: {
            a0: {
              htype: null,
              url: '//br.hubspot.com/our-story',
              headerText: 'Sobre nós',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//br.hubspot.com/company/contact',
              headerText: 'Entre em contato conosco',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//www.hubspot.com/careers',
              headerText: 'Trabalhe conosco',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//www.hubspot.com/company/management',
              headerText: 'Equipe de gestão',
              gtm: ''
            }
          }
        }
      }
    }
  },
  navCta: {
    navCtaText: 'Use a HubSpot gratuitamente',
    navCtaUrl: '//br.hubspot.com/products/get-started',
    navCtaClass: 'cta cta--regular cta--primary homepage-nav'
  }
};
var HeaderPT = withHeaderProps({
  lang: lang$5,
  contentBlob: ptBlob
});

var lang$6 = 'en';
var enBlob$1 = {
  upperNavContent: {
    homeUrl: '//www.hubspot.com',
    loginUrl: '//app.hubspot.com/login',
    loginText: 'Inloggen',
    supportUrl: '//help.hubspot.com',
    supportText: 'Klantenondersteuning (Engels)',
    regionalDropdownContent: {
      contactUrl: '//offers.hubspot.com/contact-sales',
      contactText: 'Contact met ons opnemen',
      languagesContent: {
        en: ['English', 'https://www.hubspot.com'],
        jp: ['日本語', 'https://www.hubspot.jp'],
        de: ['Deutsch', 'https://www.hubspot.de'],
        es: ['Español', 'https://www.hubspot.es'],
        pt: ['Português', 'https://br.hubspot.com'],
        fr: ['Français', 'https://www.hubspot.fr']
      }
    },
    aboutContent: {
      aboutLabel: 'About',
      aboutText: 'About Us',
      aboutUrl: '//www.hubspot.com/our-story',
      contactUsText: 'Contact Us',
      contactUsUrl: '//www.hubspot.com/company/contact',
      careersText: 'Careers',
      careersUrl: '//www.hubspot.com/careers',
      managementText: 'Management Team',
      managementUrl: '//www.hubspot.com/company/management'
    }
  },
  mobileNavContent: {
    contactUrl: '//offers.hubspot.com/contact-sales',
    contactText: 'Contact met ons opnemen',
    loginUrl: '//app.hubspot.com/login',
    loginText: 'Inloggen',
    searchPlaceholder: 'Search HubSpot.com',
    supportUrl: '//help.hubspot.com/',
    supportText: 'Klantenondersteuning (Engels)',
    home: 'Home',
    homeUrl: '//www.hubspot.com',
    languagesContent: {
      en: ['English', 'https://www.hubspot.com'],
      jp: ['日本語', 'https://www.hubspot.jp'],
      de: ['Deutsch', 'https://www.hubspot.de'],
      es: ['Español', 'https://www.hubspot.es'],
      pt: ['Português', 'https://br.hubspot.com'],
      fr: ['Français', 'https://www.hubspot.fr']
    }
  },
  searchContent: {
    searchPlaceholder: 'search...',
    searchHubLabel: 'Search hubspot.com',
    searchBlogLabel: 'Search blog',
    loadMoreText: 'Load more results',
    cx: '009219321729865762236:z9gsnksfc30',
    cxBlog: '009219321729865762236:fzizmixjdmi',
    noResultsContent: {
      h6: 'That’s odd...',
      p1: 'Couldn’t find quite the right match.',
      p2: 'Don’t worry, try searching again up top.'
    }
  },
  mainNavContent: {
    navDropDownContent0: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-1  hsg-nav__group-item--has-dropdown',
      topText: 'Software',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row hsg-nav__dropdown-row--links',
          listRowContent: {
            a0: {
              htype: 3,
              headerText: 'The HubSpot CRM Platform',
              subtextContent: 'All of HubSpot’s marketing, sales CRM, customer service, CMS, and operations software on one platform.'
            },
            a1: {
              url: '//www.hubspot.com/products/crm',
              htype: 3,
              headerText: 'Free HubSpot CRM',
              gtm: 'crm'
            },
            a2: {
              url: '//www.hubspot.com/products/get-started',
              htype: 3,
              headerText: 'Overview of all products',
              gtm: 'crm'
            }
          }
        },
        li1: {
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              url: '//www.hubspot.com/products/marketing',
              htype: 4,
              headerText: 'Marketing Hub',
              gtm: 'marketing',
              subtextContent: 'Marketing automation software. <span class="highlight">Free and premium plans</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Marketing.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/MarketingHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Marketing icon'
            },
            a1: {
              url: '//www.hubspot.com/products/sales',
              htype: 4,
              headerText: 'Sales Hub',
              gtm: 'sales',
              subtextContent: 'Sales CRM software. <span class="highlight">Free and premium plans</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Sales.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/SalesHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Sales icon'
            },
            a2: {
              url: '//www.hubspot.com/products/service',
              htype: 4,
              headerText: 'Service Hub',
              gtm: 'service',
              subtextContent: 'Customer service software. <span class="highlight">Free and premium plans</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Service.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/ServiceHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Service icon'
            },
            a3: {
              url: '//www.hubspot.com/products/cms',
              htype: 4,
              headerText: 'CMS Hub',
              gtm: 'cms',
              subtextContent: 'Content management system software. <span class="highlight">Free and premium plans</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/CMS.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/CMSHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'CMS icon',
              hasRibbon: false
            },
            a4: {
              url: '//www.hubspot.com/products/operations',
              htype: 4,
              headerText: 'Operations Hub',
              gtm: 'ops',
              subtextContent: 'Operations software. <span class="highlight">Free and premium plans</span>',
              iconSrc: '//www.hubspot.com/hubfs/assets/hubspot.com/web-team/WBZ/Navigation/operations.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/OperationsHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Operations icon',
              hasRibbon: false
            }
          }
        },
        li2: {
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row hsg-nav__dropdown-row--links hsg-nav__dropdown-row--links-horizontal',
          listRowContent: {
            a0: {
              url: '//ecosystem.hubspot.com/marketplace/apps',
              htype: 6,
              headerText: 'App Marketplace',
              gtm: 'app',
              subtextContent: 'Connect your favorite apps to HubSpot. <span class="highlight">See all integrations</span>'
            }
          }
        }
      }
    },
    navDropDownContent1: {
      hasDropDown: false,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-2',
      topUrl: '//www.hubspot.com/pricing/marketing',
      topText: 'Pricing'
    },
    navDropDownContent2: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-3  hsg-nav__group-item--has-dropdown',
      topText: 'Resources',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Education-icon.svg',
          sectionLabel: 'Education',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//blog.hubspot.com',
              headerText: 'Blog',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.com/resources/',
              headerText: 'Ebooks, Guides & More',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//academy.hubspot.com/courses',
              headerText: 'Free Courses & Certifications',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//www.hubspot.com/inbound-marketing',
              headerText: 'Inbound Methodology',
              gtm: ''
            }
          }
        },
        li1: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/WhyHubSpot%3F-icon.svg',
          sectionLabel: 'Why HubSpot?',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.com/case-studies',
              headerText: 'Case Studies',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.com/why-go-hubspot',
              headerText: 'Why Choose HubSpot?',
              gtm: ''
            }
          }
        },
        li2: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Services-icon.svg',
          sectionLabel: 'Services',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.com/services',
              headerText: 'Onboarding & Consulting Services',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//ecosystem.hubspot.com/marketplace/solutions',
              headerText: 'Hire a Service Provider',
              gtm: ''
            }
          }
        },
        li3: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Partners%26Developers-icon.svg',
          sectionLabel: 'User Resources',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.com/partners',
              headerText: 'Partner Programs',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//developers.hubspot.com/',
              headerText: 'Developer Tools',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//community.hubspot.com?profile.language=en',
              headerText: 'Community',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//ecosystem.hubspot.com/',
              headerText: 'HubSpot Ecosystem',
              gtm: ''
            }
          }
        }
      }
    },
    navDropDownContent3: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-4 hsg-nav__group-item--has-dropdown hsg-nav__group-item--about-mobile',
      topText: 'About',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.com/our-story',
              headerText: 'About Us',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.com/company/contact',
              headerText: 'Contact Us',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//www.hubspot.com/careers',
              headerText: 'Careers',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//www.hubspot.com/company/management',
              headerText: 'Management Team',
              gtm: ''
            }
          }
        }
      }
    }
  },
  navCta: {
    navCtaText: 'Aan de slag',
    navCtaUrl: 'https://www.hubspot.com/products/get-started',
    navCtaClass: 'cta cta--regular cta--primary homepage-nav'
  }
};
var HeaderNL = withHeaderProps({
  lang: lang$6,
  contentBlob: enBlob$1
});

var lang$7 = 'it';
var itBlob = {
  upperNavContent: {
    homeUrl: '//www.hubspot.com',
    loginUrl: '//app.hubspot.com/login',
    loginText: 'Accedi',
    supportUrl: '//help.hubspot.com',
    supportText: 'Assistenza clienti (Inglese)',
    regionalDropdownContent: {
      contactUrl: '//offers.hubspot.com/contact-sales',
      contactText: 'Contattaci',
      languagesContent: {
        en: ['English', 'https://www.hubspot.com'],
        jp: ['日本語', 'https://www.hubspot.jp'],
        de: ['Deutsch', 'https://www.hubspot.de'],
        es: ['Español', 'https://www.hubspot.es'],
        pt: ['Português', 'https://br.hubspot.com'],
        fr: ['Français', 'https://www.hubspot.fr']
      }
    },
    aboutContent: {
      aboutLabel: 'About',
      aboutText: 'About Us',
      aboutUrl: '//www.hubspot.com/our-story',
      contactUsText: 'Contact Us',
      contactUsUrl: '//www.hubspot.com/company/contact',
      careersText: 'Careers',
      careersUrl: '//www.hubspot.com/careers',
      managementText: 'Management Team',
      managementUrl: '//www.hubspot.com/company/management'
    }
  },
  mobileNavContent: {
    contactUrl: '//offers.hubspot.com/contact-sales',
    contactText: 'Contattaci',
    loginUrl: '//app.hubspot.com/login',
    loginText: 'Accedi',
    searchPlaceholder: 'Search HubSpot.com',
    supportUrl: '//help.hubspot.com/',
    supportText: 'Assistenza clienti (Inglese)',
    home: 'Home',
    homeUrl: '//www.hubspot.com',
    languagesContent: {
      en: ['English', 'https://www.hubspot.com'],
      jp: ['日本語', 'https://www.hubspot.jp'],
      de: ['Deutsch', 'https://www.hubspot.de'],
      es: ['Español', 'https://www.hubspot.es'],
      pt: ['Português', 'https://br.hubspot.com'],
      fr: ['Français', 'https://www.hubspot.fr']
    }
  },
  searchContent: {
    searchPlaceholder: 'search...',
    searchHubLabel: 'Search hubspot.com',
    searchBlogLabel: 'Search blog',
    loadMoreText: 'Load more results',
    cx: '009219321729865762236:z9gsnksfc30',
    cxBlog: '009219321729865762236:fzizmixjdmi',
    noResultsContent: {
      h6: 'That’s odd...',
      p1: 'Couldn’t find quite the right match.',
      p2: 'Don’t worry, try searching again up top.'
    }
  },
  mainNavContent: {
    navDropDownContent0: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-1  hsg-nav__group-item--has-dropdown',
      topText: 'Software',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row hsg-nav__dropdown-row--links',
          listRowContent: {
            a0: {
              htype: 3,
              headerText: 'The HubSpot CRM Platform',
              subtextContent: 'All of HubSpot’s marketing, sales CRM, customer service, CMS, and operations software on one platform.'
            },
            a1: {
              url: '//www.hubspot.com/products/crm',
              htype: 3,
              headerText: 'Free HubSpot CRM',
              gtm: 'crm'
            },
            a2: {
              url: '//www.hubspot.com/products/get-started',
              htype: 3,
              headerText: 'Overview of all products',
              gtm: 'crm'
            }
          }
        },
        li1: {
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              url: '//www.hubspot.com/products/marketing',
              htype: 4,
              headerText: 'Marketing Hub',
              gtm: 'marketing',
              subtextContent: 'Marketing automation software. <span class="highlight">Free and premium plans</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Marketing.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/MarketingHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Marketing icon'
            },
            a1: {
              url: '//www.hubspot.com/products/sales',
              htype: 4,
              headerText: 'Sales Hub',
              gtm: 'sales',
              subtextContent: 'Sales CRM software. <span class="highlight">Free and premium plans</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Sales.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/SalesHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Sales icon'
            },
            a2: {
              url: '//www.hubspot.com/products/service',
              htype: 4,
              headerText: 'Service Hub',
              gtm: 'service',
              subtextContent: 'Customer service software. <span class="highlight">Free and premium plans</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/Service.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/ServiceHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Service icon'
            },
            a3: {
              url: '//www.hubspot.com/products/cms',
              htype: 4,
              headerText: 'CMS Hub',
              gtm: 'cms',
              subtextContent: 'Content management system software. <span class="highlight">Free and premium plans</span>',
              iconSrc: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Software/CMS.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/CMSHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'CMS icon',
              hasRibbon: false
            },
            a4: {
              url: '//www.hubspot.com/products/operations',
              htype: 4,
              headerText: 'Operations Hub',
              gtm: 'ops',
              subtextContent: 'Operations software. <span class="highlight">Free and premium plans</span>',
              iconSrc: '//www.hubspot.com/hubfs/assets/hubspot.com/web-team/WBZ/Navigation/operations.svg',
              newIconSrc: '//fs.hubspotusercontent00.net/hubfs/53/product_icons_2022/OperationsHub_Icon_Gradient_RGB_24px.svg',
              iconAlt: 'Operations icon',
              hasRibbon: false
            }
          }
        },
        li2: {
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row hsg-nav__dropdown-row--links hsg-nav__dropdown-row--links-horizontal',
          listRowContent: {
            a0: {
              url: '//ecosystem.hubspot.com/marketplace/apps',
              htype: 6,
              headerText: 'App Marketplace',
              gtm: 'app',
              subtextContent: 'Connect your favorite apps to HubSpot. <span class="highlight">See all integrations</span>'
            }
          }
        }
      }
    },
    navDropDownContent1: {
      hasDropDown: false,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-2',
      topUrl: '//www.hubspot.com/pricing/marketing',
      topText: 'Pricing'
    },
    navDropDownContent2: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-3  hsg-nav__group-item--has-dropdown',
      topText: 'Resources',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Education-icon.svg',
          sectionLabel: 'Education',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//blog.hubspot.com',
              headerText: 'Blog',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.com/resources/',
              headerText: 'Ebooks, Guides & More',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//academy.hubspot.com/courses',
              headerText: 'Free Courses & Certifications',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//www.hubspot.com/inbound-marketing',
              headerText: 'Inbound Methodology',
              gtm: ''
            }
          }
        },
        li1: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/WhyHubSpot%3F-icon.svg',
          sectionLabel: 'Why HubSpot?',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.com/case-studies',
              headerText: 'Case Studies',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.com/why-go-hubspot',
              headerText: 'Why Choose HubSpot?',
              gtm: ''
            }
          }
        },
        li2: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Services-icon.svg',
          sectionLabel: 'Services',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.com/services',
              headerText: 'Onboarding & Consulting Services',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//ecosystem.hubspot.com/marketplace/solutions',
              headerText: 'Hire a Service Provider',
              gtm: ''
            }
          }
        },
        li3: {
          sectionIcon: '//f.hubspotusercontent00.net/hubfs/53/WBZ-1165%20Global%20Nav%20Redesign/Partners%26Developers-icon.svg',
          sectionLabel: 'User Resources',
          numInnerDivs: 1,
          className: 'hsg-nav__dropdown-row',
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.com/partners',
              headerText: 'Partner Programs',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//developers.hubspot.com/',
              headerText: 'Developer Tools',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//community.hubspot.com?profile.language=en',
              headerText: 'Community',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//ecosystem.hubspot.com/',
              headerText: 'HubSpot Ecosystem',
              gtm: ''
            }
          }
        }
      }
    },
    navDropDownContent3: {
      hasDropDown: true,
      className: 'hsg-nav__group-item hsg-nav__group-item--order-4 hsg-nav__group-item--has-dropdown hsg-nav__group-item--about-mobile',
      topText: 'About',
      ulClassName: 'hsg-nav__dropdown-list hsg-nav__dropdown-cards',
      navLinksContent: {
        li0: {
          listRowContent: {
            a0: {
              htype: null,
              url: '//www.hubspot.com/our-story',
              headerText: 'About Us',
              gtm: ''
            },
            a1: {
              htype: null,
              url: '//www.hubspot.com/company/contact',
              headerText: 'Contact Us',
              gtm: ''
            },
            a2: {
              htype: null,
              url: '//www.hubspot.com/careers',
              headerText: 'Careers',
              gtm: ''
            },
            a3: {
              htype: null,
              url: '//www.hubspot.com/company/management',
              headerText: 'Management Team',
              gtm: ''
            }
          }
        }
      }
    }
  },
  navCta: {
    navCtaText: 'Inizia',
    navCtaUrl: 'https://www.hubspot.com/products/get-started',
    navCtaClass: 'cta cta--regular cta--primary homepage-nav'
  }
};
var HeaderIT = withHeaderProps({
  lang: lang$7,
  contentBlob: itBlob
});

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  -webkit-box-ordinal-group: ", ";\n  order: ", ";\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledListItem = styled__default.li(_templateObject$3(), function (props) {
  return (parseInt(props.dataOrder, 10) + 1).toString();
}, function (props) {
  return props.dataOrder;
});

var renderLinkItems$2 = function renderLinkItems(contentObj) {
  return Object.keys(contentObj).map(function (item) {
    var _contentObj$item = contentObj[item],
        url = _contentObj$item.url,
        text = _contentObj$item.text;
    return React.createElement("a", {
      key: item,
      href: url
    }, text);
  });
};

var ListItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ListItem, _React$Component);

  function ListItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ListItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        order = _this$props.order,
        url = _this$props.url,
        text = _this$props.text,
        className = _this$props.className,
        dropDownContent = _this$props.dropDownContent;

    var _ref = dropDownContent || {},
        dropDownId = _ref.dropDownId,
        dropDownItemsContent = _ref.dropDownItemsContent;

    return React.createElement(StyledListItem, {
      className: className,
      dataOrder: order
    }, dropDownItemsContent ? React.createElement("div", {
      className: "hsg-footer__dropdown",
      "data-order": order,
      "data-linkorder": order
    }, React.createElement("input", {
      type: "checkbox",
      id: dropDownId,
      name: dropDownId
    }), React.createElement("label", {
      htmlFor: dropDownId
    }, text), React.createElement("span", null, renderLinkItems$2(dropDownItemsContent))) : React.createElement("a", {
      href: url,
      "data-order": order,
      "data-linkorder": order,
      onClick: function onClick() {
        return window.location.href = url;
      }
    }, text));
  };

  return ListItem;
}(React.Component);

ListItem.propTypes = {
  order: PropTypes.string.isRequired,
  url: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
  dropDownContent: PropTypes.object
};

var renderListItems = function renderListItems(contentObj) {
  return Object.keys(contentObj).map(function (item) {
    var _contentObj$item = contentObj[item],
        order = _contentObj$item.order,
        url = _contentObj$item.url,
        text = _contentObj$item.text,
        innerContent = _contentObj$item.innerContent;
    return React.createElement(ListItem, {
      key: item,
      className: "hsg-footer__nav-item",
      order: order,
      url: url,
      text: text,
      dropDownContent: innerContent || {}
    });
  });
};

var FooterColumn =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FooterColumn, _React$Component);

  function FooterColumn(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isFooterToggle: false
    };
    return _this;
  }

  var _proto = FooterColumn.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        listContent = _this$props.listContent,
        headerId = _this$props.headerId,
        headerText = _this$props.headerText,
        handleFooterToggleClick = _this$props.handleFooterToggleClick;
    var isActive = this.props.isFooterActive && this.props.activeFooterColumn === headerId;
    return React.createElement("li", {
      id: headerId,
      className: "hsg-footer__nav-column " + (isActive ? 'active' : 'hide'),
      onClick: function onClick(e) {
        return handleFooterToggleClick(e, {
          activeFooterColumn: headerId
        });
      }
    }, React.createElement("label", {
      htmlFor: headerId
    }, headerText), React.createElement("ul", null, renderListItems(listContent)));
  };

  return FooterColumn;
}(React.Component);

FooterColumn.propTypes = {
  listContent: PropTypes.object,
  headerId: PropTypes.string.isRequired,
  headerText: PropTypes.string
};

/**
 * Replaces an img element with an svg src with the inlined svg
 *
 * @param  {string} query
 * @return {function} callback
 */
var inlineSvg = function inlineSvg(query, callback) {
  var images = document.querySelectorAll(query);

  var parseSvg = function parseSvg(data, image) {
    var parser = new DOMParser();
    var svg = parser.parseFromString(data, 'image/svg+xml').querySelector('svg');

    if (image.id) {
      svg.id = image.id;
    }

    if (image.className) {
      if (svg.classList) {
        svg.classList = image.classList;
      }
    }

    if (image.parentNode) {
      image.parentNode.replaceChild(svg, image);
    }
  };

  images.forEach(function (image) {
    return fetch(image.dataset.src).then(function (res) {
      return res.text();
    }).then(function (data) {
      return parseSvg(data, image);
    }).then(callback).catch(function (error) {
      return console.error(error);
    });
  });
};

/**
 * Appends the icon SVG map to the page head as an <img> tag
 *
 * @example
 * <img class="cl-svg-map" style="display: none;" data-src="...icons.svg" />
 */
var className = 'cl-svg-map';
var selector = "." + className;

var icons = function icons() {
  try {
    var existingElement = document.querySelector(selector);

    if (!existingElement) {
      var image = document.createElement('img');
      image.dataset.src = 'https://f.hubspotusercontent20.net/hubfs/2406023/assets/component-library/icons/icons.svg';
      image.style.display = 'none';
      image.classList.add(className);
      document.head.appendChild(image);
      inlineSvg(selector);
    }
  } catch (error) {
    console.error(error);
  }

  return selector;
};

icons();

var renderSocial = function renderSocial(contentObj) {
  var useHref;
  return Object.keys(contentObj).map(function (item) {
    var _contentObj$item = contentObj[item],
        url = _contentObj$item.url,
        text = _contentObj$item.text,
        className = _contentObj$item.className;

    switch (className) {
      case 'hstc_facebook':
        useHref = 'facebook';
        break;

      case 'hstc_instagram':
        useHref = 'instagram';
        break;

      case 'hstc_youtube':
        useHref = 'youtube';
        break;

      case 'hstc_twitter':
        useHref = 'twitter';
        break;

      case 'hstc_linkedin':
        useHref = 'linkedin';
        break;

      case 'hstc_medium':
        useHref = 'medium';
        break;

      case 'hstc_tiktok':
        useHref = 'tiktok';
        break;

      default:
        useHref = '';
    }

    return React.createElement("li", {
      key: item
    }, React.createElement("a", {
      href: url,
      target: "_blank",
      rel: "noopener noreferrer",
      className: className
    }, React.createElement("svg", {
      className: "cl-icon"
    }, React.createElement("use", {
      href: "#" + useHref
    })), React.createElement("span", {
      className: "hidden-social"
    }, text)));
  });
};

var SocialGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(SocialGroup, _React$Component);

  function SocialGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SocialGroup.prototype;

  _proto.render = function render() {
    var socialContent = this.props.socialContent;
    return React.createElement("li", {
      className: "hsg-footer__nav-item--cta-social"
    }, React.createElement("ul", {
      className: "hsg-footer__social-items"
    }, renderSocial(socialContent)));
  };

  return SocialGroup;
}(React.Component);

SocialGroup.propTypes = {
  socialContent: PropTypes.object
};

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  color: ", ";\n  padding: 0 0 2rem;\n  transition: all .3s ease;\n\n  @media (min-width: 927px) {\n    padding: 3rem 2rem\n  }\n\n  a {\n    font-weight: 500;\n\n    &:not([class^='cta']) {\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    }\n  }\n  .hsg-footer__logo-caret {\n    display: none;\n  }\n\n  &.active{\n    padding: 2rem 0;\n\n    .hsg-footer__nav-column {\n      &.hide {\n        display: none;\n      }\n    }\n    .hsg-footer__logo-caret {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      .hsg-footer__close {\n        display: inline-block;\n        position: relative;\n        width: 1.5rem;\n\n        &::before,\n        &::after {\n          display: block;\n          background-color: ", ";\n          border-radius: 1rem;\n          width: 90%;\n          height: 0.2rem;\n          content: '';\n          position: absolute;\n          top: 0;\n          left: 0;\n        }\n\n        &::before {\n          transform: rotate(-135deg);\n        }\n        &::after {\n          transform: rotate(-45deg);\n        }\n      }\n    }\n  }\n  .hsg-footer__layout {\n    box-sizing: content-box;\n    max-width: 1080px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 0;\n\n    @media (min-width: 768px) {\n      padding: 0 2rem;\n    }\n  }\n\n  &.active {\n    .hsg-footer__logo-caret {\n      display: flex;\n    }\n  }\n\n  .hsg-footer__logo-caret {\n    display: none;\n    margin: 0 1rem;\n    justify-content: space-between;\n\n    a {\n      font-size: .875rem;\n      display: inline-block;\n      color: ", ";\n      padding-left: 2rem;\n      position: relative;\n      font-weight: 600;\n\n      &::before {\n        font-size: 1.125rem;\n        position: absolute;\n        display: inline-block;\n        content: '\\E003';\n        font-family: 'hsg-icons';\n        font-weight: 700;\n        color: ", ";\n        left: 0;\n        vertical-align: middle;\n        -ms-transform: rotate(90deg);\n        transform: rotate(90deg);\n        top: -2px;\n      }\n    }\n\n    .hsg-footer__close {\n      display: inline-block;\n      position: relative;\n      width: 1.5rem;\n\n      &::before,\n      &::after {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        display: block;\n        background-color: ", ";\n        border-radius: 1rem;\n        width: 90%;\n        height: 0.2rem;\n      }\n\n      &::before {\n        transform: rotate(-135deg);\n      }\n\n      &::after {\n        transform: rotate(-45deg);\n      }\n    }\n  }\n\n  .hsg-footer__nav {\n\n    > ul {\n      margin: 0;\n      padding: 0;\n      display: flex;\n      flex-direction: column;\n      -webkit-box-pack: justify;\n      justify-content: space-between;\n      width: 100%;\n      padding: 0;\n\n      @media (min-width: 768px) {\n        display: grid;\n        grid: 25% min-content/20% 1fr 1fr 1fr;\n\n        [lang='de'] &,\n        [lang='fr'] & {\n          grid: 35% min-content/20% 1fr 1fr 1fr;\n        }\n      }\n\n      .hsg-footer__dropdown {\n        > input {\n          overflow: hidden;\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 1px;\n          height: 1px;\n          clip: rect(0, 0, 0, 0);\n\n          &:checked ~ span {\n            display: flex;\n          }\n        }\n\n        > label {\n          display: block;\n          font-size: 0.875rem;\n          cursor: pointer;\n          padding: 1rem 0;\n\n          @media (min-width: 768px) {\n            padding: 0.5rem 0;\n          }\n\n          &::after {\n            content: '\\E004';\n            display: inline;\n            font-family: 'hsg-icons';\n            font-size: 7px;\n            padding-left: 0.5rem;\n          }\n        }\n\n        span {\n          display: none;\n          -webkit-box-orient: vertical;\n          -webkit-box-direction: normal;\n          flex-direction: column;\n          width: 100%;\n          padding-bottom: 1rem;\n\n          @media (min-width: 768px) {\n            padding-bottom: 0;\n          }\n\n          a {\n            font-size: 0.75rem;\n            padding: 0.5rem 0;\n          }\n        }\n      }\n    }\n  }\n\n  .hsg-footer__nav-column {\n    position: relative;\n    -webkit-box-flex: 1;\n    flex: 1;\n    text-align: left;\n    transition: all .3s ease;\n\n    @media (min-width: 768px) {\n      margin-bottom: 0;\n      padding: 0 1rem;\n    }\n\n    &.active {\n      > label {\n        font-size: 1.25rem;\n        text-align: center;\n        font-weight: 400;\n        margin-bottom: 1rem;\n\n        &::after {\n          content: '';\n        }\n      }\n      > ul {\n        display: flex;\n        height: 100%;\n        position: static;\n        padding: 0 1rem;\n\n        li {\n          background-color: ", ";\n          margin: 0 0 1rem;\n          border-radius: 3px;\n          border: 1px solid ", ";\n\n          &.hsg-footer__nav-item {\n            a {\n              display: inline-block;\n              font-size: 1rem;\n              color: ", ";\n              font-weight: 500;\n              padding: 1.25rem;\n              border-top: 0;\n              width: 100%;\n\n              &::after {\n                font-size: 1.125rem;\n                position: absolute;\n                display: inline-block;\n                content: '\\E003';\n                font-family: 'hsg-icons';\n                font-weight: 700;\n                color: ", ";\n                right: 2rem;\n                vertical-align: middle;\n                -ms-transform: rotate(-90deg);\n                transform: rotate(-90deg);\n              }\n            }\n          }\n        }\n\n\n      }\n    }\n\n    &:first-child {\n      @media (min-width: 768px) {\n        padding-left: 0;\n        display: flex;\n        flex-wrap: wrap;\n        flex-direction: column;\n        border-right: 1px solid ", ";\n        grid-area: 1/1/3/3;\n        margin-right: 2rem;\n        padding: 0 0 5rem 0;\n        align-self: start;\n\n        ul {\n          display: flex;\n          flex-direction: row;\n          flex-wrap: wrap;\n\n          li {\n            margin-right: 1em;\n            flex: 1 1 45%;\n\n            &:last-child {\n              &:nth-child(odd) {\n                flex-grow: 0;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    &:nth-child(2) {\n      padding-left: 0;\n    }\n\n    &:nth-child (3),\n    &:nth-child(2) {\n      grid-row: 1/3;\n    }\n\n    &:last-child {\n      padding-right: 0;\n      grid-area: 2/5/3/6;\n    }\n\n    > input {\n      overflow: hidden;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 1px;\n      height: 1px;\n      clip: rect(0, 0, 0, 0);\n\n\n    }\n\n    > label {\n      font-size: 1.125rem;\n      font-weight: 600;\n      line-height: 1.375;\n      cursor: pointer;\n      display: block;\n      padding: 1rem 1rem 0.5rem 1rem;\n      position: relative;\n      transition: all 0.3s ease;\n\n      @media (min-width: 768px) {\n        cursor: default;\n        color: inherit;\n        padding: 0;\n        margin-bottom: 1rem;\n      }\n\n      &::after {\n        @media (max-width: 767px) {\n          content: '\\E003';\n          display: inline-block;\n          font-family: 'hsg-icons';\n          font-size: 1.125rem;\n          vertical-align: middle;\n          right: 1rem;\n          transform: rotate(-90deg);\n          position: absolute;\n        }\n      }\n    }\n\n    > ul {\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n      flex-direction: column;\n      display: flex;\n\n      .hsg-footer__nav-item {\n        &:last-of-type {\n          @media (max-width: 767px) {\n            border-bottom: 1px solid ", ";\n          }\n        }\n\n        a {\n          display: block;\n          font-size: 0.875rem;\n          font-weight: 600;\n        }\n\n        > a {\n          padding: 0.5rem 0;\n\n          @media (max-width: 767px) {\n            padding: 1rem 0;\n            border-top: 1px solid ", ";\n            display: none;\n          }\n        }\n\n        label[for*=\"hsg-footer-dropdown\"] {\n          @media (max-width: 767px) {\n            display: none;\n            border-top: 1px solid ", ";\n          }\n        }\n      }\n    }\n  }\n\n  .hsg-footer__cta {\n    margin: 3rem 0 0.75rem;\n\n    @media (min-width: 768px) {\n      margin: 0.75rem 0;\n    }\n\n    .cta--primary-light {\n      cursor: pointer;\n      display: inline-block;\n      line-height: 1.25;\n      border: 0;\n      border-radius: .1875rem;\n      transition: 0.15s color ease-out, 0.15s background-color ease-out, 0.15s border-color ease-out;\n      background-color: ", ";\n      color: ", ";\n      font-weight: 600;\n      font-size: 1rem;\n      padding: 1.625rem 3rem;\n\n      &:hover {\n        background-color: rgba(255,255,255,0.9);\n      }\n    }\n\n    .cta--small {\n      font-size: 0.75rem;\n      font-weight: 500;\n      padding: 0.563rem 1rem;\n    }\n  }\n\n  .hsg-footer__social {\n    width: 100%;\n    position: relative;\n    display: flex;\n    justify-content: space-around;\n    margin-top: 1rem;\n\n    &-items {\n      display: flex;\n      justify-content: center;\n      gap: 0.25rem\n\n      @media (max-width: 768px) {\n        gap: 0.75rem;\n      }\n    }\n\n    li {\n      a {\n        .cl-icon {\n        height: 23px;\n        width: 26px;\n  \n          use {\n            fill: ", ";\n          }\n\n          @media (max-width: 300px) {\n            padding: 0.5rem 0.4rem;\n          }\n        } \n      }\n    }\n\n    @media (min-width: 768px) {\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n      flex-direction: row;\n      -webkit-box-pack: justify;\n      justify-content: space-between;\n    }\n\n    .hsg-icon::before {\n      font-size: 1.35rem;\n    }\n\n    @media (min-width: 850px) {\n      &::before,\n      &::after {\n        width: 25%;\n        position: absolute;\n        content: \"\";\n        border-top: 1px solid ", ";\n        top: 50%;\n      }\n\n      &::before {\n        right: 0;\n      }\n\n      &::after {\n        left: 0;\n      }\n    }\n\n    @media (min-width: 1080px) {\n      &::before,\n      &::after {\n        width: 27%;\n      }\n    }\n\n    ul {\n      margin: 0 auto;\n    }\n\n    li {\n      display: inline-block;\n      margin: 0;\n\n      @media (min-width: 768px) {\n        margin: 0 1em;\n      }\n\n      a {\n        display: block;\n        padding: 0.5rem;\n\n        @media (min-width: 768px) {\n          padding: 0.75rem 0;\n        }\n\n        span {\n          position: absolute;\n          left: -10000px;\n          top: auto;\n          width: 1px;\n          height: 1px;\n          overflow: hidden;\n        }\n      }\n    }\n  }\n\n  .hsg-footer__contact-links {\n    box-sizing: content-box;\n    max-width: 1080px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 0 2rem;\n    text-align: center;\n\n    @media (min-width: 768px) {\n      display: none;\n      padding: 0;\n    }\n\n    .hsg-footer__cta {\n      margin: 3rem 0 0.75rem;\n\n      @media (min-width: 768px) {\n        margin: 0.75rem 0;\n      }\n    }\n  }\n\n  .hsg-footer__bottom {\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    flex-direction: column;\n    -webkit-box-pack: center;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n    padding: 1rem 2rem 2rem;\n\n    @media (min-width: 1025px) {\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n      flex-direction: column;\n      -webkit-box-pack: justify;\n      justify-content: space-between;\n      text-align: left;\n      padding: 1rem 0;\n      align-items: center;\n    }\n\n    .hsg-footer__apps {\n      display: flex;\n      margin-bottom: 1rem;\n      justify-content: center;\n\n      @media (min-width: 1025px) {\n        display: none;\n      }\n    }\n\n      .hsg-footer__app {\n        display: flex;\n        max-width: 8.5rem;\n        height: 2.9rem;\n      }\n\n      .hsg-footer__app:first-child {\n        margin-right: 1rem;\n      }\n\n    .hsg-footer__logo {\n      margin-top: 2rem;\n\n      @media (min-width: 1025px) {\n        margin-top: 0;\n      }\n\n      img {\n        display: block;\n        max-width: 100px;\n        margin: 0 auto;\n      }\n\n      p {\n        font-size: 0.75rem;\n        line-height: 1.5;\n        color: ", ";\n      }\n    }\n\n    .hsg-footer__legal {\n      li {\n        display: inline-block;\n        position: relative;\n\n        &::after {\n          display: inline-block;\n          font-size: 0.75em;\n          color: ", ";\n          position: absolute;\n          content: \"|\";\n          top: 30%;\n          right: -0.25em;        \n        }\n\n        &:last-of-type {\n          &::after {\n            content: \"\";\n          }\n        }\n\n        a {\n          display: block;\n          padding: 0.5rem 1rem;\n          font-size: .875rem;\n          font-weight: 600;\n          color: ", ";\n          text-decoration: underline;\n\n          &:hover {\n            color: ", ";\n            text-decoration: none;\n          }\n        }\n      }\n    }\n  }\n\n  @media (min-width: 768px) {\n    padding-top: 5.75rem;\n  }\n"], ["\n  background-color: ", ";\n  color: ", ";\n  padding: 0 0 2rem;\n  transition: all .3s ease;\n\n  @media (min-width: 927px) {\n    padding: 3rem 2rem\n  }\n\n  a {\n    font-weight: 500;\n\n    &:not([class^='cta']) {\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    }\n  }\n  .hsg-footer__logo-caret {\n    display: none;\n  }\n\n  &.active{\n    padding: 2rem 0;\n\n    .hsg-footer__nav-column {\n      &.hide {\n        display: none;\n      }\n    }\n    .hsg-footer__logo-caret {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      .hsg-footer__close {\n        display: inline-block;\n        position: relative;\n        width: 1.5rem;\n\n        &::before,\n        &::after {\n          display: block;\n          background-color: ", ";\n          border-radius: 1rem;\n          width: 90%;\n          height: 0.2rem;\n          content: '';\n          position: absolute;\n          top: 0;\n          left: 0;\n        }\n\n        &::before {\n          transform: rotate(-135deg);\n        }\n        &::after {\n          transform: rotate(-45deg);\n        }\n      }\n    }\n  }\n  .hsg-footer__layout {\n    box-sizing: content-box;\n    max-width: 1080px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 0;\n\n    @media (min-width: 768px) {\n      padding: 0 2rem;\n    }\n  }\n\n  &.active {\n    .hsg-footer__logo-caret {\n      display: flex;\n    }\n  }\n\n  .hsg-footer__logo-caret {\n    display: none;\n    margin: 0 1rem;\n    justify-content: space-between;\n\n    a {\n      font-size: .875rem;\n      display: inline-block;\n      color: ", ";\n      padding-left: 2rem;\n      position: relative;\n      font-weight: 600;\n\n      &::before {\n        font-size: 1.125rem;\n        position: absolute;\n        display: inline-block;\n        content: '\\\\E003';\n        font-family: 'hsg-icons';\n        font-weight: 700;\n        color: ", ";\n        left: 0;\n        vertical-align: middle;\n        -ms-transform: rotate(90deg);\n        transform: rotate(90deg);\n        top: -2px;\n      }\n    }\n\n    .hsg-footer__close {\n      display: inline-block;\n      position: relative;\n      width: 1.5rem;\n\n      &::before,\n      &::after {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        display: block;\n        background-color: ", ";\n        border-radius: 1rem;\n        width: 90%;\n        height: 0.2rem;\n      }\n\n      &::before {\n        transform: rotate(-135deg);\n      }\n\n      &::after {\n        transform: rotate(-45deg);\n      }\n    }\n  }\n\n  .hsg-footer__nav {\n\n    > ul {\n      margin: 0;\n      padding: 0;\n      display: flex;\n      flex-direction: column;\n      -webkit-box-pack: justify;\n      justify-content: space-between;\n      width: 100%;\n      padding: 0;\n\n      @media (min-width: 768px) {\n        display: grid;\n        grid: 25% min-content/20% 1fr 1fr 1fr;\n\n        [lang='de'] &,\n        [lang='fr'] & {\n          grid: 35% min-content/20% 1fr 1fr 1fr;\n        }\n      }\n\n      .hsg-footer__dropdown {\n        > input {\n          overflow: hidden;\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 1px;\n          height: 1px;\n          clip: rect(0, 0, 0, 0);\n\n          &:checked ~ span {\n            display: flex;\n          }\n        }\n\n        > label {\n          display: block;\n          font-size: 0.875rem;\n          cursor: pointer;\n          padding: 1rem 0;\n\n          @media (min-width: 768px) {\n            padding: 0.5rem 0;\n          }\n\n          &::after {\n            content: '\\\\E004';\n            display: inline;\n            font-family: 'hsg-icons';\n            font-size: 7px;\n            padding-left: 0.5rem;\n          }\n        }\n\n        span {\n          display: none;\n          -webkit-box-orient: vertical;\n          -webkit-box-direction: normal;\n          flex-direction: column;\n          width: 100%;\n          padding-bottom: 1rem;\n\n          @media (min-width: 768px) {\n            padding-bottom: 0;\n          }\n\n          a {\n            font-size: 0.75rem;\n            padding: 0.5rem 0;\n          }\n        }\n      }\n    }\n  }\n\n  .hsg-footer__nav-column {\n    position: relative;\n    -webkit-box-flex: 1;\n    flex: 1;\n    text-align: left;\n    transition: all .3s ease;\n\n    @media (min-width: 768px) {\n      margin-bottom: 0;\n      padding: 0 1rem;\n    }\n\n    &.active {\n      > label {\n        font-size: 1.25rem;\n        text-align: center;\n        font-weight: 400;\n        margin-bottom: 1rem;\n\n        &::after {\n          content: '';\n        }\n      }\n      > ul {\n        display: flex;\n        height: 100%;\n        position: static;\n        padding: 0 1rem;\n\n        li {\n          background-color: ", ";\n          margin: 0 0 1rem;\n          border-radius: 3px;\n          border: 1px solid ", ";\n\n          &.hsg-footer__nav-item {\n            a {\n              display: inline-block;\n              font-size: 1rem;\n              color: ", ";\n              font-weight: 500;\n              padding: 1.25rem;\n              border-top: 0;\n              width: 100%;\n\n              &::after {\n                font-size: 1.125rem;\n                position: absolute;\n                display: inline-block;\n                content: '\\\\E003';\n                font-family: 'hsg-icons';\n                font-weight: 700;\n                color: ", ";\n                right: 2rem;\n                vertical-align: middle;\n                -ms-transform: rotate(-90deg);\n                transform: rotate(-90deg);\n              }\n            }\n          }\n        }\n\n\n      }\n    }\n\n    &:first-child {\n      @media (min-width: 768px) {\n        padding-left: 0;\n        display: flex;\n        flex-wrap: wrap;\n        flex-direction: column;\n        border-right: 1px solid ", ";\n        grid-area: 1/1/3/3;\n        margin-right: 2rem;\n        padding: 0 0 5rem 0;\n        align-self: start;\n\n        ul {\n          display: flex;\n          flex-direction: row;\n          flex-wrap: wrap;\n\n          li {\n            margin-right: 1em;\n            flex: 1 1 45%;\n\n            &:last-child {\n              &:nth-child(odd) {\n                flex-grow: 0;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    &:nth-child(2) {\n      padding-left: 0;\n    }\n\n    &:nth-child (3),\n    &:nth-child(2) {\n      grid-row: 1/3;\n    }\n\n    &:last-child {\n      padding-right: 0;\n      grid-area: 2/5/3/6;\n    }\n\n    > input {\n      overflow: hidden;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 1px;\n      height: 1px;\n      clip: rect(0, 0, 0, 0);\n\n\n    }\n\n    > label {\n      font-size: 1.125rem;\n      font-weight: 600;\n      line-height: 1.375;\n      cursor: pointer;\n      display: block;\n      padding: 1rem 1rem 0.5rem 1rem;\n      position: relative;\n      transition: all 0.3s ease;\n\n      @media (min-width: 768px) {\n        cursor: default;\n        color: inherit;\n        padding: 0;\n        margin-bottom: 1rem;\n      }\n\n      &::after {\n        @media (max-width: 767px) {\n          content: '\\\\E003';\n          display: inline-block;\n          font-family: 'hsg-icons';\n          font-size: 1.125rem;\n          vertical-align: middle;\n          right: 1rem;\n          transform: rotate(-90deg);\n          position: absolute;\n        }\n      }\n    }\n\n    > ul {\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n      flex-direction: column;\n      display: flex;\n\n      .hsg-footer__nav-item {\n        &:last-of-type {\n          @media (max-width: 767px) {\n            border-bottom: 1px solid ", ";\n          }\n        }\n\n        a {\n          display: block;\n          font-size: 0.875rem;\n          font-weight: 600;\n        }\n\n        > a {\n          padding: 0.5rem 0;\n\n          @media (max-width: 767px) {\n            padding: 1rem 0;\n            border-top: 1px solid ", ";\n            display: none;\n          }\n        }\n\n        label[for*=\"hsg-footer-dropdown\"] {\n          @media (max-width: 767px) {\n            display: none;\n            border-top: 1px solid ", ";\n          }\n        }\n      }\n    }\n  }\n\n  .hsg-footer__cta {\n    margin: 3rem 0 0.75rem;\n\n    @media (min-width: 768px) {\n      margin: 0.75rem 0;\n    }\n\n    .cta--primary-light {\n      cursor: pointer;\n      display: inline-block;\n      line-height: 1.25;\n      border: 0;\n      border-radius: .1875rem;\n      transition: 0.15s color ease-out, 0.15s background-color ease-out, 0.15s border-color ease-out;\n      background-color: ", ";\n      color: ", ";\n      font-weight: 600;\n      font-size: 1rem;\n      padding: 1.625rem 3rem;\n\n      &:hover {\n        background-color: rgba(255,255,255,0.9);\n      }\n    }\n\n    .cta--small {\n      font-size: 0.75rem;\n      font-weight: 500;\n      padding: 0.563rem 1rem;\n    }\n  }\n\n  .hsg-footer__social {\n    width: 100%;\n    position: relative;\n    display: flex;\n    justify-content: space-around;\n    margin-top: 1rem;\n\n    &-items {\n      display: flex;\n      justify-content: center;\n      gap: 0.25rem\n\n      @media (max-width: 768px) {\n        gap: 0.75rem;\n      }\n    }\n\n    li {\n      a {\n        .cl-icon {\n        height: 23px;\n        width: 26px;\n  \n          use {\n            fill: ", ";\n          }\n\n          @media (max-width: 300px) {\n            padding: 0.5rem 0.4rem;\n          }\n        } \n      }\n    }\n\n    @media (min-width: 768px) {\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n      flex-direction: row;\n      -webkit-box-pack: justify;\n      justify-content: space-between;\n    }\n\n    .hsg-icon::before {\n      font-size: 1.35rem;\n    }\n\n    @media (min-width: 850px) {\n      &::before,\n      &::after {\n        width: 25%;\n        position: absolute;\n        content: \"\";\n        border-top: 1px solid ", ";\n        top: 50%;\n      }\n\n      &::before {\n        right: 0;\n      }\n\n      &::after {\n        left: 0;\n      }\n    }\n\n    @media (min-width: 1080px) {\n      &::before,\n      &::after {\n        width: 27%;\n      }\n    }\n\n    ul {\n      margin: 0 auto;\n    }\n\n    li {\n      display: inline-block;\n      margin: 0;\n\n      @media (min-width: 768px) {\n        margin: 0 1em;\n      }\n\n      a {\n        display: block;\n        padding: 0.5rem;\n\n        @media (min-width: 768px) {\n          padding: 0.75rem 0;\n        }\n\n        span {\n          position: absolute;\n          left: -10000px;\n          top: auto;\n          width: 1px;\n          height: 1px;\n          overflow: hidden;\n        }\n      }\n    }\n  }\n\n  .hsg-footer__contact-links {\n    box-sizing: content-box;\n    max-width: 1080px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 0 2rem;\n    text-align: center;\n\n    @media (min-width: 768px) {\n      display: none;\n      padding: 0;\n    }\n\n    .hsg-footer__cta {\n      margin: 3rem 0 0.75rem;\n\n      @media (min-width: 768px) {\n        margin: 0.75rem 0;\n      }\n    }\n  }\n\n  .hsg-footer__bottom {\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    flex-direction: column;\n    -webkit-box-pack: center;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n    padding: 1rem 2rem 2rem;\n\n    @media (min-width: 1025px) {\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n      flex-direction: column;\n      -webkit-box-pack: justify;\n      justify-content: space-between;\n      text-align: left;\n      padding: 1rem 0;\n      align-items: center;\n    }\n\n    .hsg-footer__apps {\n      display: flex;\n      margin-bottom: 1rem;\n      justify-content: center;\n\n      @media (min-width: 1025px) {\n        display: none;\n      }\n    }\n\n      .hsg-footer__app {\n        display: flex;\n        max-width: 8.5rem;\n        height: 2.9rem;\n      }\n\n      .hsg-footer__app:first-child {\n        margin-right: 1rem;\n      }\n\n    .hsg-footer__logo {\n      margin-top: 2rem;\n\n      @media (min-width: 1025px) {\n        margin-top: 0;\n      }\n\n      img {\n        display: block;\n        max-width: 100px;\n        margin: 0 auto;\n      }\n\n      p {\n        font-size: 0.75rem;\n        line-height: 1.5;\n        color: ", ";\n      }\n    }\n\n    .hsg-footer__legal {\n      li {\n        display: inline-block;\n        position: relative;\n\n        &::after {\n          display: inline-block;\n          font-size: 0.75em;\n          color: ", ";\n          position: absolute;\n          content: \"|\";\n          top: 30%;\n          right: -0.25em;        \n        }\n\n        &:last-of-type {\n          &::after {\n            content: \"\";\n          }\n        }\n\n        a {\n          display: block;\n          padding: 0.5rem 1rem;\n          font-size: .875rem;\n          font-weight: 600;\n          color: ", ";\n          text-decoration: underline;\n\n          &:hover {\n            color: ", ";\n            text-decoration: none;\n          }\n        }\n      }\n    }\n  }\n\n  @media (min-width: 768px) {\n    padding-top: 5.75rem;\n  }\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var colors$1 = {
  // THEME COLORS
  // Primary colors
  calypso: '#00a4bd',
  calypsoLight: '#7fd1de',
  // Dark greys
  pantera: '#2d3e50',
  obsidian: '#33475b',
  heffalump: '#425b76',
  eerie: '#7c98b6',
  // Light greys
  battleship: '#cbd6e2',
  olaf: '#fff'
};
var StyledFooter = styled__default(StyledBase.withComponent('footer'))(_templateObject$4(), colors$1.heffalump, colors$1.olaf, colors$1.battleship, colors$1.calypsoLight, colors$1.olaf, colors$1.olaf, colors$1.olaf, colors$1.olaf, colors$1.olaf, colors$1.obsidian, colors$1.obsidian, colors$1.calypso, colors$1.eerie, colors$1.eerie, colors$1.heffalump, colors$1.heffalump, colors$1.olaf, colors$1.obsidian, colors$1.battleship, colors$1.eerie, colors$1.battleship, colors$1.eerie, colors$1.olaf, colors$1.calypsoLight);

var renderLinkItems$3 = function renderLinkItems(contentObj) {
  return Object.keys(contentObj).map(function (item) {
    var _contentObj$item = contentObj[item],
        url = _contentObj$item.url,
        text = _contentObj$item.text;
    return React.createElement("li", {
      key: item
    }, React.createElement("a", {
      href: url
    }, text));
  });
};

var renderFooterColumns = function renderFooterColumns(contentObj, callback, state) {
  if (contentObj === void 0) {
    contentObj = {};
  }

  var isMobile = state.isMobile,
      isFooterActive = state.isFooterActive,
      isFooterToggle = state.isFooterToggle,
      activeFooterColumn = state.activeFooterColumn;
  return Object.keys(contentObj).map(function (item) {
    var _contentObj$item2 = contentObj[item],
        headerId = _contentObj$item2.headerId,
        headerText = _contentObj$item2.headerText,
        listItemsContent = _contentObj$item2.listItemsContent;
    return React.createElement(FooterColumn, {
      key: item,
      handleFooterToggleClick: callback,
      isMobile: isMobile,
      isFooterActive: isFooterActive,
      isFooterToggle: isFooterToggle,
      listContent: listItemsContent,
      activeFooterColumn: activeFooterColumn,
      headerId: headerId,
      headerText: headerText
    });
  });
};

var FooterMain =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FooterMain, _React$Component);

  function FooterMain(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isMobile: window.innerWidth <= 767,
      isFooterActive: false,
      isFooterToggle: false
    }; // preserve the initial state in a new object

    _this.baseState = _this.state;

    if (_this.state.isMobile) {
      _this.state.isFooterActive = _this.state.isMobile && false;
    }

    _this.resetForm = _this.resetForm.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleFooterToggleClick = _this.handleFooterToggleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onResizeEvent = _this.onResizeEvent.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = FooterMain.prototype;

  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.onResizeEvent);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.onResizeEvent);
  };

  _proto.onResizeEvent = function onResizeEvent() {
    var isMobile = window.innerWidth <= 767;
    this.setState({
      isMobile: isMobile,
      // eslint-disable-line object-shorthand
      isFooterActive: isMobile && this.state.isFooterActive
    });
  };

  _proto.resetForm = function resetForm() {
    this.setState(this.baseState);
  };

  _proto.handleFooterToggleClick = function handleFooterToggleClick(event, activeItem) {
    event.preventDefault();
    this.setState(_extends({
      isFooterActive: this.state.isMobile && activeItem !== undefined,
      isFooterToggle: !this.state.isFooterToggle
    }, activeItem), function () {// TODO: this.resetForm();
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props$contentBl = this.props.contentBlob,
        backLabel = _this$props$contentBl.backLabel,
        footerNavContent = _this$props$contentBl.footerNavContent,
        socialContent = _this$props$contentBl.socialContent,
        _this$props$contentBl2 = _this$props$contentBl.footerBottomContent,
        copyright = _this$props$contentBl2.copyright,
        appButtons = _this$props$contentBl2.appButtons,
        legalLinksContent = _this$props$contentBl2.legalLinksContent,
        homeUrl = _this$props$contentBl2.homeUrl;
    var className = this.state.isMobile && this.state.isFooterActive ? 'active' : ' ';
    return React.createElement(StyledFooter, {
      className: className,
      handleFooterToggleClick: this.handleFooterToggleClick,
      isFooterActive: this.state.isFooterActive,
      isMobile: this.state.isMobile,
      activeFooterColumn: this.state.activeFooterColumn ? this.state.activeFooterColumn : ' ',
      isFooterToggle: this.state.isFooterToggle
    }, React.createElement("div", {
      className: "hsg-footer__layout"
    }, this.state.isMobile && React.createElement("div", {
      id: "back-link",
      className: "hsg-footer__logo-caret",
      onClick: function onClick(e) {
        return _this2.handleFooterToggleClick(e);
      }
    }, React.createElement("a", {
      className: "hsg-footer__logo-caret-home",
      href: "#"
    }, backLabel), React.createElement("span", {
      className: "hsg-footer__close",
      role: "img",
      "aria-label": "Close"
    })), React.createElement("nav", {
      className: "hsg-footer__nav"
    }, React.createElement("ul", null, renderFooterColumns(footerNavContent, this.handleFooterToggleClick, this.state))), React.createElement("section", {
      className: "hsg-footer__social"
    }, React.createElement("ul", null, React.createElement(SocialGroup, {
      socialContent: socialContent
    }))), React.createElement("section", {
      className: "hsg-footer__bottom"
    }, React.createElement("div", {
      className: "hsg-footer__apps"
    }, React.createElement("a", {
      className: "hsg-footer__app",
      href: appButtons.a0.url
    }, React.createElement("img", {
      className: "hsg-deferred " + appButtons.a0.trackingclass,
      src: appButtons.a0.img,
      alt: appButtons.a0.alt
    })), React.createElement("a", {
      className: "hsg-footer__app",
      href: appButtons.a1.url
    }, React.createElement("img", {
      className: "hsg-deferred " + appButtons.a1.trackingclass,
      src: appButtons.a1.img,
      alt: appButtons.a1.alt
    }))), React.createElement("div", {
      className: "hsg-footer__logo"
    }, React.createElement("a", {
      href: homeUrl
    }, React.createElement("img", {
      src: "//www.hubspot.com/hubfs/HubSpot_Logos/HSLogo_white.svg?t=1529611146261",
      alt: "HubSpot Logo"
    })), React.createElement("p", null, copyright)), React.createElement("div", {
      className: "hsg-footer__legal"
    }, React.createElement("ul", null, renderLinkItems$3(legalLinksContent))))));
  };

  return FooterMain;
}(React.Component);

FooterMain.propTypes = {
  contentBlob: PropTypes.object
};

var enBlob$2 = {
  backLabel: 'BACK',
  footerNavContent: {
    footerColumnContent0: {
      headerId: 'hsg-footer-column-0',
      headerText: 'Popular Features',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.com/products/sales/schedule-meeting',
          text: 'Free Meeting Scheduler App'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.com/products/marketing/social-inbox',
          text: 'Social Media Tools'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.com/products/sales/email-tracking',
          text: 'Email Tracking Software'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.com/products/sales/sales-automation',
          text: 'Sales Email Automation'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.com/products/marketing/ads',
          text: 'Ads Software'
        },
        li5: {
          order: '5',
          url: '//www.hubspot.com/products/marketing/email',
          text: 'Email Marketing Software'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.com/products/crm/lead-management',
          text: 'Lead Management Software'
        },
        li7: {
          order: '7',
          url: '//www.hubspot.com/products/crm/pipeline-management',
          text: 'Pipeline Management Tools'
        },
        li8: {
          order: '8',
          url: '//www.hubspot.com/products/sales/email-templates-sales',
          text: 'Sales Email Templates'
        },
        li9: {
          order: '9',
          url: '//www.hubspot.com/products/service/help-desk',
          text: 'Help Desk Software'
        },
        li10: {
          order: '10',
          url: '//www.hubspot.com/products/marketing/forms',
          text: 'Free Online Form Builder'
        },
        li11: {
          order: '11',
          url: '//www.hubspot.com/products/crm/chatbot-builder',
          text: 'Free Chatbot Builder'
        },
        li12: {
          order: '12',
          url: '//www.hubspot.com/products/crm/live-chat',
          text: 'Free Live Chat Software'
        },
        li13: {
          order: '13',
          url: '//www.hubspot.com/products/marketing/analytics',
          text: 'Marketing Analytics'
        },
        li14: {
          order: '14',
          url: '//www.hubspot.com/products/marketing/landing-pages',
          text: 'Free Landing Page Builder'
        }
      }
    },
    footerColumnContent1: {
      headerId: 'hsg-footer-column-1',
      headerText: 'Free Tools',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//website.grader.com/?__hstc=20629287.e4e046660731447bf82affe18aa75831.1482962870986.1487962165415.1487964870240.141&__hssc=20629287.1.1487964870240&__hsfp=3218882972',
          text: 'Website Grader'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.com/make-my-persona',
          text: 'Make My Persona'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.com/email-signature-generator',
          text: 'Email Signature Generator'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.com/blog-topic-generator',
          text: 'Blog Ideas Generator'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.com/invoice-template-generator',
          text: 'Invoice Template Generator'
        },
        li5: {
          order: '5',
          url: '//www.hubspot.com/marketing-plan-template-generator',
          text: 'Marketing Plan Generator'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.com/business-templates',
          text: 'Free Business Templates'
        },
        li7: {
          order: '7',
          url: '//www.hubspot.com/industry-data',
          text: 'Industry Benchmark Data'
        },
        li8: {
          order: '8',
          url: '//www.hubspot.com/comparisons',
          text: 'Software Comparisons Library'
        },
        li9: {
          order: '9',
          url: 'https://ecosystem.hubspot.com/marketplace/website',
          text: 'Website Themes & Templates'
        }
      }
    },
    footerColumnContent2: {
      headerId: 'hsg-footer-column-2',
      headerText: 'Company',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.com/our-story',
          text: 'About Us'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.com/careers',
          text: 'Careers'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.com/company/management',
          text: 'Management Team'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.com/company/board-of-directors',
          text: 'Board of Directors'
        },
        li4: {
          order: '4',
          url: '//ir.hubspot.com/?_ga=2.262843276.12874469.1592422655-430007000.1592422655',
          text: 'Investor Relations'
        },
        li5: {
          order: '5',
          url: '//blog.hubspot.com',
          text: 'Blog'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.com/company/contact',
          text: 'Contact Us'
        }
      }
    },
    footerColumnContent3: {
      headerId: 'hsg-footer-column-3',
      headerText: 'Customers',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//help.hubspot.com/',
          text: 'Customer Support'
        },
        li1: {
          order: '1',
          url: '//academy.hubspot.com/hubspot-user-groups',
          text: 'Join a Local User Group'
        }
      }
    },
    footerColumnContent4: {
      headerId: 'hsg-footer-column-4',
      headerText: 'Partners',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.com/partners',
          text: 'All Partner Programs'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.com/partners/solutions',
          text: 'Solutions Partner Program'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.com/partners/app',
          text: 'App Partner Program'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.com/startups/partners',
          text: 'HubSpot for Startups'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.com/partners/affiliates',
          text: 'Affiliate Program'
        }
      }
    }
  },
  socialContent: {
    li0: {
      url: '//www.facebook.com/hubspot',
      text: 'Facebook',
      className: 'hstc_facebook'
    },
    li1: {
      url: '//www.instagram.com/hubspot',
      text: 'Instagram',
      className: 'hstc_instagram'
    },
    li2: {
      url: '//youtube.com/user/HubSpot',
      text: 'Youtube',
      className: 'hstc_youtube'
    },
    li3: {
      url: '//twitter.com/HubSpot',
      text: 'Twitter',
      className: 'hstc_twitter'
    },
    li4: {
      url: '//www.linkedin.com/company/hubspot',
      text: 'Linkedin',
      className: 'hstc_linkedin'
    },
    li05: {
      url: '//thinkgrowth.org',
      text: 'Medium',
      className: 'hstc_medium'
    },
    li06: {
      url: '//www.tiktok.com/@hubspot',
      text: 'TikTok',
      className: 'hstc_tiktok'
    }
  },
  footerBottomContent: {
    homeUrl: '//www.hubspot.com',
    copyright: "Copyright \xA9 " + new Date().getFullYear() + " HubSpot, Inc.",
    appButtons: {
      a0: {
        url: 'https://apps.apple.com/us/app/hubspot/id1107711722',
        img: 'https://www.hubspot.com/hubfs/app%20store%20high%20res.png',
        alt: 'App store',
        trackingclass: 'homepage-mobile-footer-apple'
      },
      a1: {
        url: 'https://play.google.com/store/apps/details?id=com.hubspot.android&hl=en_US',
        img: 'https://www.hubspot.com/hubfs/google%20play%20high%20res.png',
        alt: 'Google Play',
        trackingclass: 'homepage-mobile-footer-google'
      }
    },
    legalLinksContent: {
      a0: {
        url: '//legal.hubspot.com/legal-stuff',
        text: 'Legal Stuff'
      },
      a1: {
        url: '//legal.hubspot.com/privacy-policy',
        text: 'Privacy Policy'
      },
      a2: {
        url: '//legal.hubspot.com/security',
        text: 'Security'
      }
    }
  }
};

var FooterEN =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FooterEN, _React$Component);

  function FooterEN() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FooterEN.prototype;

  _proto.render = function render() {
    return React.createElement(FooterMain, {
      contentBlob: enBlob$2
    });
  };

  return FooterEN;
}(React.Component);

var deBlob$1 = {
  backLabel: 'Zurück',
  footerNavContent: {
    footerColumnContent0: {
      headerId: 'hsg-footer-column-0',
      headerText: 'Beliebte Features',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.de/products/marketing/ads',
          text: 'Werbeanzeigen verwalten'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.de/products/marketing/seo',
          text: 'SEO-Software'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.de/products/marketing/blog',
          text: 'Blogging-Software'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.de/products/marketing/social-inbox',
          text: 'Social-Media-Software'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.de/products/marketing/email',
          text: 'E-Mail-Marketing-Software'
        },
        li5: {
          order: '5',
          url: '//www.hubspot.de/products/marketing/forms',
          text: 'Online-Formulare'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.de/products/marketing/analytics',
          text: 'Marketing-Analytics'
        },
        li7: {
          order: '7',
          url: '//www.hubspot.de/products/cms',
          text: 'Content-Management-System'
        },
        li8: {
          order: '8',
          url: '//www.hubspot.de/products/crm/chatbot-builder',
          text: 'Kostenlose Chatbot-Software'
        },
        li9: {
          order: '9',
          url: '//www.hubspot.de/products/crm/live-chat',
          text: 'Kostenlose Live-Chat-Software'
        },
        li10: {
          order: '10',
          url: '//www.hubspot.de/products/sales/schedule-meeting',
          text: 'Meeting-Planer'
        },
        li11: {
          order: '11',
          url: '//www.hubspot.de/products/sales/email-templates-sales',
          text: 'E-Mail-Vorlagen'
        },
        li12: {
          order: '12',
          url: '//www.hubspot.de/products/service/help-desk',
          text: 'Helpdesk- und -Ticketingsoftware'
        },
        li13: {
          order: '13',
          url: '//www.hubspot.de/products/sales/email-tracking',
          text: 'E-Mail-Tracking'
        },
        li14: {
          order: '14',
          url: '//www.hubspot.de/products/sales/sales-automation',
          text: 'Vertriebsautomatisierung'
        },
        li15: {
          order: '15',
          url: '//www.hubspot.de/products/crm/lead-management',
          text: 'Lead-Management'
        },
        li16: {
          order: '16',
          url: '//www.hubspot.de/products/sales/click-to-call',
          text: 'Leads mit einem Klick anrufen'
        },
        li17: {
          order: '17',
          url: '//www.hubspot.de/products/crm/pipeline-management',
          text: 'Pipeline-Management'
        }
      }
    },
    footerColumnContent1: {
      headerId: 'hsg-footer-column-1',
      headerText: 'Kostenlose Tools',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//website.grader.com/de/',
          text: 'Lassen Sie Ihre Webseite bewerten'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.de/make-my-persona',
          text: 'Make My Persona'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.de/email-signature-generator',
          text: 'E-Mail-Signatur-Generator'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.de/marketing-bibliothek',
          text: 'HubSpot-Marketingbibliothek'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.de/business-templates',
          text: '20 Geschäftsvorlagen zum Download'
        },
        li5: {
          order: '5',
          url: '//www.hubspot.de/industry-data',
          text: 'Benchmarkdaten für Marketing, Service & Vertrieb'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.de/podcasts/the-digital-helpdesk',
          text: 'Deutschsprachige HubSpot-Podcasts'
        },
        li7: {
          order: '7',
          url: '//www.hubspot.de/comparisons',
          text: 'Software-Vergleiche'
        }
      }
    },
    footerColumnContent2: {
      headerId: 'hsg-footer-column-2',
      headerText: 'Unternehmen',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.de/our-story',
          text: 'Über uns'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.com/careers',
          text: 'Karriere'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.com/company/management',
          text: 'Management'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.com/company/board-of-directors',
          text: 'Vorstand'
        },
        li4: {
          order: '4',
          url: '//ir.hubspot.com/?_ga=2.262843276.12874469.1592422655-430007000.1592422655',
          text: 'Investor Relations'
        },
        li5: {
          order: '5',
          url: '//blog.hubspot.de',
          text: 'Blog'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.de/company/contact',
          text: 'Kontaktieren Sie uns'
        }
      }
    },
    footerColumnContent3: {
      headerId: 'hsg-footer-column-3',
      headerText: 'Kunden',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//help.hubspot.com/de/',
          text: 'Kundensupport'
        },
        li1: {
          order: '1',
          url: '//academy.hubspot.com/hubspot-user-groups',
          text: 'Nutzergruppen in Ihrer Region'
        },
        li2: {
          order: '2',
          url: '//community.hubspot.com/?profile.language=de',
          text: 'Deutschsprachige HubSpot-Community'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.de/data-privacy/gdpr',
          text: 'HubSpot & die DSGVO'
        }
      }
    },
    footerColumnContent4: {
      headerId: 'hsg-footer-column-4',
      headerText: 'Partner',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.de/partners',
          text: 'Partnerprogramme'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.de/partners/solutions',
          text: 'Solutions Partner Program'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.com/partners/app',
          text: 'App-Partnerprogramm'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.com/startups/partners',
          text: 'HubSpot for Startups'
        }
      }
    }
  },
  socialContent: {
    li0: {
      url: '//www.facebook.com/HubspotDeutschland',
      text: 'Facebook',
      className: 'hstc_facebook'
    },
    li1: {
      url: '//www.instagram.com/hubspotdach/',
      text: 'Instagram',
      className: 'hstc_instagram'
    },
    li2: {
      url: '//www.youtube.com/channel/UCInS7wB5bD-mgLz-shTJTCw',
      text: 'Youtube',
      className: 'hstc_youtube'
    },
    li3: {
      url: '//twitter.com/HubSpotDACH',
      text: 'Twitter',
      className: 'hstc_twitter'
    },
    li4: {
      url: '//www.linkedin.com/company/hubspot',
      text: 'Linkedin',
      className: 'hstc_linkedin'
    },
    li05: {
      url: '//thinkgrowth.org',
      text: 'Medium',
      className: 'hstc_medium'
    },
    li06: {
      url: '//www.tiktok.com/@hubspot',
      text: 'TikTok',
      className: 'hstc_tiktok'
    }
  },
  footerBottomContent: {
    homeUrl: '//www.hubspot.de',
    copyright: "Copyright \xA9 " + new Date().getFullYear() + " HubSpot, Inc.",
    appButtons: {
      a0: {
        url: 'https://apps.apple.com/us/app/hubspot/id1107711722',
        img: 'https://www.hubspot.com/hubfs/app%20store%20high%20res.png',
        alt: 'App store',
        trackingclass: 'de-homepage-mobile-footer-apple'
      },
      a1: {
        url: 'https://play.google.com/store/apps/details?id=com.hubspot.android&hl=en_US',
        img: 'https://www.hubspot.com/hubfs/google%20play%20high%20res.png',
        alt: 'Google Play',
        trackingclass: 'de-homepage-mobile-footer-google'
      }
    },
    legalLinksContent: {
      a0: {
        url: '//legal.hubspot.com/de/legal-stuff',
        text: 'Rechtliches'
      },
      a1: {
        url: '//legal.hubspot.com/de/privacy-policy',
        text: 'Datenschutzbestimmungen'
      },
      a2: {
        url: '//legal.hubspot.com/de/impressum',
        text: 'Impressum'
      },
      a3: {
        url: '//legal.hubspot.com/de/security',
        text: 'Sicherheit'
      }
    }
  }
};

var FooterDE =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FooterDE, _React$Component);

  function FooterDE() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FooterDE.prototype;

  _proto.render = function render() {
    return React.createElement(FooterMain, {
      contentBlob: deBlob$1
    });
  };

  return FooterDE;
}(React.Component);

var esBlob$1 = {
  backLabel: 'Volver',
  footerNavContent: {
    footerColumnContent0: {
      headerId: 'hsg-footer-column-0',
      headerText: 'Funciones populares',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.es/products/sales/schedule-meeting',
          text: 'App gratuita para programar reuniones'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.es/products/marketing/social-inbox',
          text: 'Herramientas de redes sociales'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.es/products/sales/email-tracking',
          text: 'Software de seguimiento de emails'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.es/products/sales/sales-automation',
          text: 'Automatización para emails de ventas'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.es/products/marketing/ads',
          text: 'Software de anuncios'
        },
        li5: {
          order: '5',
          url: '//www.hubspot.es/products/marketing/email',
          text: 'Software de email marketing'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.es/products/crm/lead-management',
          text: 'Software para gestión de leads'
        },
        li7: {
          order: '7',
          url: '//www.hubspot.es/products/crm/pipeline-management',
          text: 'Herramientas de gestión del pipeline'
        },
        li8: {
          order: '8',
          url: '//www.hubspot.es/products/sales/email-templates-sales',
          text: 'Plantillas de emails de ventas'
        },
        li9: {
          order: '9',
          url: '//www.hubspot.es/products/service/help-desk',
          text: 'Software de asistencia técnica'
        },
        li10: {
          order: '10',
          url: '//www.hubspot.es/products/marketing/forms',
          text: 'Generador de formularios online gratis'
        },
        li11: {
          order: '11',
          url: '//www.hubspot.es/products/crm/chatbot-builder',
          text: 'Generador de chatbots gratis'
        },
        li12: {
          order: '12',
          url: '//www.hubspot.es/products/crm/live-chat',
          text: 'Software de chat en directo gratis'
        },
        li13: {
          order: '13',
          url: '//www.hubspot.es/products/marketing/analytics',
          text: 'Analíticas de marketing'
        },
        li14: {
          order: '14',
          url: '//www.hubspot.es/products/marketing/landing-pages',
          text: 'Creador de landing page gratis'
        }
      }
    },
    footerColumnContent1: {
      headerId: 'hsg-footer-column-1',
      headerText: 'Herramientas gratuitas',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//website.grader.com/es/',
          text: 'Website Grader'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.es/make-my-persona',
          text: 'Generador de buyer personas'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.es/email-signature-generator',
          text: 'Generador de firmas de email'
        },
        li3: {
          order: '3',
          url: '//offers.hubspot.es/generador-ideas-blog',
          text: 'Generador de ideas para el blog'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.es/business-templates',
          text: 'Plantillas empresariales gratis'
        },
        li5: {
          order: '5',
          url: '//www.hubspot.es/covid-data',
          text: 'Datos de referencia sobre COVID-19'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.es/comparisons',
          text: 'Comparación de software para empresas'
        }
      }
    },
    footerColumnContent2: {
      headerId: 'hsg-footer-column-2',
      headerText: 'Empresa',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.es/our-story',
          text: 'Sobre nosotros'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.com/careers',
          text: 'Trabaja con nosotros'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.com/company/management',
          text: 'Equipo directivo'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.com/company/board-of-directors',
          text: 'Junta directiva'
        },
        li4: {
          order: '4',
          url: '//ir.hubspot.com/?_ga=2.262843276.12874469.1592422655-430007000.1592422655',
          text: 'Inversores'
        },
        li5: {
          order: '5',
          url: '//blog.hubspot.es',
          text: 'Blog'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.es/company/contact',
          text: 'Contacto'
        },
        li7: {
          order: '7',
          url: '//www.hubspot.com/newsroom',
          text: 'Recursos para prensa'
        },
        li8: {
          order: '8',
          url: '//offers.hubspot.es/newsroom-subscribe',
          text: 'Últimas noticias'
        }
      }
    },
    footerColumnContent3: {
      headerId: 'hsg-footer-column-3',
      headerText: 'Clientes',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//help.hubspot.com/es/',
          text: 'Atención al cliente'
        },
        li1: {
          order: '1',
          url: '//academy.hubspot.com/hubspot-user-groups',
          text: 'Únete a un grupo local de usuarios'
        }
      }
    },
    footerColumnContent4: {
      headerId: 'hsg-footer-column-4',
      headerText: 'Partners',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.es/partners',
          text: 'Todos los programas para partners'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.es/partners/solutions',
          text: 'Solutions Partner Program'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.com/partners/app',
          text: 'App Partner Program'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.es/startups/partners',
          text: 'HubSpot para Startups'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.com/partners/affiliates',
          text: 'Programa de Afiliados'
        }
      }
    }
  },
  socialContent: {
    li0: {
      url: '//www.facebook.com/HubSpotEspanol/',
      text: 'Facebook',
      className: 'hstc_facebook'
    },
    li1: {
      url: '//www.instagram.com/hubspot',
      text: 'Instagram',
      className: 'hstc_instagram'
    },
    li2: {
      url: '//www.youtube.com/channel/UCnEpR8Tczb_PrORMc3QI8Pg',
      text: 'Youtube',
      className: 'hstc_youtube'
    },
    li3: {
      url: '//twitter.com/HubSpotEspanol',
      text: 'Twitter',
      className: 'hstc_twitter'
    },
    li4: {
      url: '//www.linkedin.com/company/hubspot',
      text: 'Linkedin',
      className: 'hstc_linkedin'
    },
    li05: {
      url: '//thinkgrowth.org',
      text: 'Medium',
      className: 'hstc_medium'
    },
    li06: {
      url: '//www.tiktok.com/@hubspot',
      text: 'TikTok',
      className: 'hstc_tiktok'
    }
  },
  footerBottomContent: {
    homeUrl: '//www.hubspot.es',
    copyright: "Copyright \xA9 " + new Date().getFullYear() + " HubSpot, Inc.",
    appButtons: {
      a0: {
        url: 'https://apps.apple.com/us/app/hubspot/id1107711722',
        img: 'https://www.hubspot.com/hubfs/app%20store%20high%20res.png',
        alt: 'App store',
        trackingclass: 'es-homepage-mobile-footer-apple'
      },
      a1: {
        url: 'https://play.google.com/store/apps/details?id=com.hubspot.android&hl=en_US',
        img: 'https://www.hubspot.com/hubfs/google%20play%20high%20res.png',
        alt: 'Google Play',
        trackingclass: 'es-homepage-mobile-footer-google'
      }
    },
    legalLinksContent: {
      a0: {
        url: '//legal.hubspot.com/es/legal-stuff',
        text: 'Avisos legales'
      },
      a1: {
        url: '//legal.hubspot.com/es/privacy-policy',
        text: 'Política de privacidad'
      },
      a2: {
        url: '//legal.hubspot.com/es/security',
        text: 'Seguridad'
      }
    }
  }
};

var FooterES =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FooterES, _React$Component);

  function FooterES() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FooterES.prototype;

  _proto.render = function render() {
    return React.createElement(FooterMain, {
      contentBlob: esBlob$1
    });
  };

  return FooterES;
}(React.Component);

var frBlob$1 = {
  backLabel: 'Retour',
  footerNavContent: {
    footerColumnContent0: {
      headerId: 'hsg-footer-column-0',
      headerText: 'Fonctionnalités',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.fr/products/sales/schedule-meeting',
          text: 'Prise de rendez-vous en ligne'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.fr/products/marketing/social-inbox',
          text: 'Gestion des réseaux sociaux'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.fr/products/sales/email-tracking',
          text: 'Suivi des e-mails'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.fr/products/sales/sales-automation',
          text: 'Séquences d\'e-mails'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.fr/products/marketing/ads',
          text: 'Gestion de campagnes publicitaires'
        },
        li5: {
          order: '5',
          url: '//www.hubspot.fr/products/marketing/email',
          text: 'Logiciel d’emailing'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.fr/products/crm/lead-management',
          text: 'Gestion des leads'
        },
        li7: {
          order: '7',
          url: '//www.hubspot.fr/products/crm/pipeline-management',
          text: 'Gestion du pipeline de ventes'
        },
        li8: {
          order: '8',
          url: '//www.hubspot.fr/products/sales/email-templates-sales',
          text: 'Modèles d\'e-mails'
        },
        li9: {
          order: '9',
          url: '//www.hubspot.fr/products/service/help-desk',
          text: 'Logiciel helpdesk'
        },
        li10: {
          order: '10',
          url: '//www.hubspot.fr/products/marketing/forms',
          text: 'Création de formulaires'
        },
        li11: {
          order: '11',
          url: '//www.hubspot.fr/products/crm/chatbot-builder',
          text: 'Création de chatbots'
        },
        li12: {
          order: '12',
          url: '//www.hubspot.fr/products/crm/live-chat',
          text: 'Logiciel de chat en ligne'
        },
        li13: {
          order: '13',
          url: '//www.hubspot.fr/products/marketing/analytics',
          text: 'Analytics marketing'
        },
        li14: {
          order: '14',
          url: '//www.hubspot.fr/products/marketing/landing-pages',
          text: 'Création de landing pages'
        }
      }
    },
    footerColumnContent1: {
      headerId: 'hsg-footer-column-1',
      headerText: 'Outils gratuits',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//website.grader.com/fr/',
          text: 'Analyse de site web'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.fr/make-my-persona',
          text: 'Création de persona'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.fr/email-signature-generator',
          text: 'Générateur de signature'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.fr/business-templates',
          text: 'Modèles de documents professionnels'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.fr/industry-data',
          text: 'Données marketing et vente'
        },
        li5: {
          order: '5',
          url: '//www.hubspot.fr/products/wordpress',
          text: 'Plug-in HubSpot pour WordPress'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.fr/comparisons',
          text: 'Comparatif de logiciels'
        }
      }
    },
    footerColumnContent2: {
      headerId: 'hsg-footer-column-2',
      headerText: 'Entreprise',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.fr/our-story',
          text: 'À propos de HubSpot'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.com/careers',
          text: 'Carrières'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.fr/company/management',
          text: 'Équipe de direction'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.fr/company/board-of-directors',
          text: 'Conseil d\'administration'
        },
        li4: {
          order: '4',
          url: '//ir.hubspot.com/?_ga=2.262843276.12874469.1592422655-430007000.1592422655',
          text: 'Relations avec les investisseurs'
        },
        li5: {
          order: '5',
          url: '//blog.hubspot.fr',
          text: 'Blog'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.fr/company/contact',
          text: 'Contact'
        }
      }
    },
    footerColumnContent3: {
      headerId: 'hsg-footer-column-3',
      headerText: 'Clients',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//help.hubspot.com/fr/',
          text: 'Centre d\'aide'
        },
        li1: {
          order: '1',
          url: '//academy.hubspot.com/hubspot-user-groups',
          text: 'Groupes d\'utilisateurs HubSpot'
        }
      }
    },
    footerColumnContent4: {
      headerId: 'hsg-footer-column-4',
      headerText: 'Partenaires',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.fr/partners',
          text: 'Programmes de partenariat'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.fr/partners/solutions',
          text: 'Programme Partenaires solutions'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.fr/startups/partners',
          text: 'HubSpot pour start-ups'
        }
      }
    }
  },
  socialContent: {
    li0: {
      url: '//www.facebook.com/HubSpotFrance/',
      text: 'Facebook',
      className: 'hstc_facebook'
    },
    li1: {
      url: '//www.instagram.com/hubspot',
      text: 'Instagram',
      className: 'hstc_instagram'
    },
    li2: {
      url: '//www.youtube.com/channel/UCABaYYDH8nZkvE5ap0r4PMQ',
      text: 'Youtube',
      className: 'hstc_youtube'
    },
    li3: {
      url: '//twitter.com/HubSpotFrance',
      text: 'Twitter',
      className: 'hstc_twitter'
    },
    li4: {
      url: '//www.linkedin.com/company/hubspot',
      text: 'Linkedin',
      className: 'hstc_linkedin'
    },
    li05: {
      url: '//thinkgrowth.org',
      text: 'Medium',
      className: 'hstc_medium'
    },
    li06: {
      url: '//www.tiktok.com/@hubspot',
      text: 'TikTok',
      className: 'hstc_tiktok'
    }
  },
  footerBottomContent: {
    homeUrl: '//www.hubspot.fr',
    copyright: "Copyright \xA9 " + new Date().getFullYear() + " HubSpot, Inc.",
    appButtons: {
      a0: {
        url: 'https://apps.apple.com/us/app/hubspot/id1107711722',
        img: 'https://www.hubspot.com/hubfs/app%20store%20high%20res.png',
        alt: 'App store',
        trackingclass: 'fr-homepage-mobile-footer-apple'
      },
      a1: {
        url: 'https://play.google.com/store/apps/details?id=com.hubspot.android&hl=en_US',
        img: 'https://www.hubspot.com/hubfs/google%20play%20high%20res.png',
        alt: 'Google Play',
        trackingclass: 'fr-homepage-mobile-footer-google'
      }
    },
    legalLinksContent: {
      a0: {
        url: '//legal.hubspot.com/fr/legal-stuff',
        text: 'Mentions légales'
      },
      a1: {
        url: '//legal.hubspot.com/fr/privacy-policy',
        text: 'Politique de confidentialité'
      },
      a2: {
        url: '//legal.hubspot.com/fr/security',
        text: 'Sécurité'
      }
    }
  }
};

var FooterFR =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FooterFR, _React$Component);

  function FooterFR() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FooterFR.prototype;

  _proto.render = function render() {
    return React.createElement(FooterMain, {
      contentBlob: frBlob$1
    });
  };

  return FooterFR;
}(React.Component);

var jpBlob$1 = {
  backLabel: '戻る',
  footerNavContent: {
    footerColumnContent0: {
      headerId: 'hsg-footer-column-0',
      headerText: '主な機能',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.jp/products/sales/schedule-meeting',
          text: '商談スケジュール設定'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.jp/products/marketing/social-inbox',
          text: 'SNSツール'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.jp/products/sales/email-tracking',
          text: 'Eメールトラッキング'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.jp/products/sales/sales-automation',
          text: 'Eメールオートメーション'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.jp/products/marketing/ads',
          text: '広告ツール'
        },
        li5: {
          order: '5',
          url: '//www.hubspot.jp/products/marketing/email',
          text: 'Eメールマーケティング'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.jp/products/crm/lead-management',
          text: 'リード管理'
        },
        li7: {
          order: '7',
          url: '//www.hubspot.jp/products/crm/pipeline-management',
          text: 'パイプライン管理'
        },
        li8: {
          order: '8',
          url: '//www.hubspot.jp/products/sales/email-templates-sales',
          text: 'セールスEメールテンプレート'
        },
        li9: {
          order: '9',
          url: '//www.hubspot.jp/products/service/help-desk',
          text: 'ヘルプ デスク ソフトウェア'
        },
        li10: {
          order: '10',
          url: '//www.hubspot.jp/products/marketing/forms',
          text: '無料のフォーム作成ツール'
        },
        li11: {
          order: '11',
          url: '//www.hubspot.jp/products/crm/chatbot-builder',
          text: '無料のチャットボット作成ツール'
        },
        li12: {
          order: '12',
          url: '//www.hubspot.jp/products/crm/live-chat',
          text: '無料のウェブ チャット機能'
        },
        li13: {
          order: '13',
          url: '//www.hubspot.jp/products/marketing/analytics',
          text: 'マーケティングアナリティクス'
        },
        li14: {
          order: '14',
          url: '//www.hubspot.jp/products/marketing/landing-pages',
          text: '無料のランディングページ作成ツール'
        }
      }
    },
    footerColumnContent1: {
      headerId: 'hsg-footer-column-1',
      headerText: '無料ツール',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//website.grader.com/ja/',
          text: 'Website Grader'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.com/make-my-persona',
          text: 'ペルソナ作成ツール'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.jp/email-signature-generator',
          text: 'Eメール用署名作成ツール'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.com/blog-topic-generator',
          text: 'ブログ アイデア ジェネレーター'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.com/invoice-template-generator',
          text: '請求書テンプレート作成ツール'
        },
        li5: {
          order: '5',
          url: '//www.hubspot.com/marketing-plan-template-generator',
          text: 'マーケティングプラン作成ツール'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.com/business-templates',
          text: '無料のビジネステンプレート'
        },
        li7: {
          order: '7',
          url: '//www.hubspot.com/covid-data',
          text: 'COVID-19関連集計データ'
        },
        li8: {
          order: '8',
          url: '//www.hubspot.jp/comparisons',
          text: 'ソフトウェア製品比較の一覧'
        }
      }
    },
    footerColumnContent2: {
      headerId: 'hsg-footer-column-2',
      headerText: '会社情報',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.jp/our-story',
          text: '沿革とビジョン'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.jp/work-in-tokyo',
          text: '採用情報'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.jp/company/management',
          text: '役員紹介'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.jp/company/board-of-directors',
          text: '取締役紹介'
        },
        li4: {
          order: '4',
          url: '//ir.hubspot.com/?_ga=2.262843276.12874469.1592422655-430007000.1592422655',
          text: 'IR情報'
        },
        li5: {
          order: '5',
          url: '//www.hubspot.jp/company-news',
          text: 'ニュースルーム'
        },
        li6: {
          order: '6',
          url: '//blog.hubspot.jp',
          text: 'ブログ'
        },
        li7: {
          order: '7',
          url: '//www.hubspot.jp/company/contact',
          text: 'お問い合わせ'
        }
      }
    },
    footerColumnContent3: {
      headerId: 'hsg-footer-column-3',
      headerText: 'サポート関連',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//help.hubspot.com/ja/',
          text: 'カスタマーサポート'
        },
        li1: {
          order: '1',
          url: '//community.hubspot.com/?profile.language=ja',
          text: '日本語版コミュニティー'
        }
      }
    },
    footerColumnContent4: {
      headerId: 'hsg-footer-column-4',
      headerText: 'パートナー',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.jp/partners',
          text: 'すべてのパートナープログラム'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.jp/partners/solutions',
          text: 'Solutions Partnerプログラム'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.jp/partners/app',
          text: 'アプリ パートナー プログラム'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.jp/startups/partners',
          text: 'HubSpot for Startups'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.com/partners/affiliates',
          text: 'アフィリエイトプログラム'
        }
      }
    }
  },
  socialContent: {
    li0: {
      url: '//www.facebook.com/HubSpotJapan/',
      text: 'Facebook',
      className: 'hstc_facebook'
    },
    li1: {
      url: '//www.instagram.com/hubspot',
      text: 'Instagram',
      className: 'hstc_instagram'
    },
    li2: {
      url: '//www.youtube.com/channel/UCm3Hl6Zz4Ua_2x-NIFpVDPQ',
      text: 'Youtube',
      className: 'hstc_youtube'
    },
    li3: {
      url: '//twitter.com/hubspotjapan',
      text: 'Twitter',
      className: 'hstc_twitter'
    },
    li4: {
      url: '//www.linkedin.com/company/hubspot',
      text: 'Linkedin',
      className: 'hstc_linkedin'
    },
    li05: {
      url: '//thinkgrowth.org',
      text: 'Medium',
      className: 'hstc_medium'
    },
    li06: {
      url: '//www.tiktok.com/@hubspot',
      text: 'TikTok',
      className: 'hstc_tiktok'
    }
  },
  footerBottomContent: {
    homeUrl: '//www.hubspot.jp',
    copyright: "Copyright \xA9 " + new Date().getFullYear() + " HubSpot, Inc.",
    appButtons: {
      a0: {
        url: 'https://apps.apple.com/us/app/hubspot/id1107711722',
        img: 'https://www.hubspot.com/hubfs/app%20store%20high%20res.png',
        alt: 'App store',
        trackingclass: 'jp-homepage-mobile-footer-apple'
      },
      a1: {
        url: 'https://play.google.com/store/apps/details?id=com.hubspot.android&hl=en_US',
        img: 'https://www.hubspot.com/hubfs/google%20play%20high%20res.png',
        alt: 'Google Play',
        trackingclass: 'jp-homepage-mobile-footer-google'
      }
    },
    legalLinksContent: {
      a0: {
        url: '//legal.hubspot.com/jp/legal-stuff',
        text: '各種規約・法的情報'
      },
      a1: {
        url: '//legal.hubspot.com/jp/privacy-policy',
        text: 'プライバシーポリシー'
      },
      a2: {
        url: '//legal.hubspot.com/jp/security',
        text: 'セキュリティー'
      }
    }
  }
};

var FooterJP =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FooterJP, _React$Component);

  function FooterJP() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FooterJP.prototype;

  _proto.render = function render() {
    return React.createElement(FooterMain, {
      contentBlob: jpBlob$1
    });
  };

  return FooterJP;
}(React.Component);

var ptBlob$1 = {
  backLabel: 'Voltar',
  footerNavContent: {
    footerColumnContent0: {
      headerId: 'hsg-footer-column-0',
      headerText: 'Recursos populares',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//br.hubspot.com/products/sales/schedule-meeting',
          text: 'Aplicativo gratuito de agendamento de reuniões'
        },
        li1: {
          order: '1',
          url: '//br.hubspot.com/products/marketing/social-inbox',
          text: 'Ferramentas para mídias sociais'
        },
        li2: {
          order: '2',
          url: '//br.hubspot.com/products/sales/email-tracking',
          text: 'Software de rastreamento de e-mail'
        },
        li3: {
          order: '3',
          url: '//br.hubspot.com/products/sales/sales-automation',
          text: 'Automação de e-mails de vendas'
        },
        li4: {
          order: '4',
          url: '//br.hubspot.com/products/marketing/ads',
          text: 'Software de anúncios'
        },
        li5: {
          order: '5',
          url: '//br.hubspot.com/products/marketing/email',
          text: 'Software de e-mail marketing'
        },
        li6: {
          order: '6',
          url: '//br.hubspot.com/products/crm/lead-management',
          text: 'Software de gestão de leads'
        },
        li7: {
          order: '7',
          url: '//br.hubspot.com/products/crm/pipeline-management',
          text: 'Ferramentas de gestão de pipeline'
        },
        li8: {
          order: '8',
          url: '//br.hubspot.com/products/sales/email-templates-sales',
          text: 'Modelos de e-mails de vendas'
        },
        li9: {
          order: '9',
          url: '//br.hubspot.com/products/service/help-desk',
          text: 'Software de Help Desk'
        },
        li10: {
          order: '10',
          url: '//br.hubspot.com/products/marketing/forms',
          text: 'Criador de formulários on-line gratuito'
        },
        li11: {
          order: '11',
          url: '//br.hubspot.com/products/crm/chatbot-builder',
          text: 'Criador de chatbot gratuito'
        },
        li12: {
          order: '12',
          url: '//br.hubspot.com/products/crm/live-chat',
          text: 'Software de bate-papo ao vivo gratuito'
        },
        li13: {
          order: '13',
          url: '//br.hubspot.com/products/marketing/analytics',
          text: 'Análise de marketing'
        },
        li14: {
          order: '14',
          url: '//br.hubspot.com/products/marketing/landing-pages',
          text: 'Criador de landing pages gratuito'
        }
      }
    },
    footerColumnContent1: {
      headerId: 'hsg-footer-column-1',
      headerText: 'Ferramentas gratuitas',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//website.grader.com/?__hstc=20629287.e4e046660731447bf82affe18aa75831.1482962870986.1487962165415.1487964870240.141&__hssc=20629287.1.1487964870240&__hsfp=3218882972',
          text: 'Website Grader'
        },
        li1: {
          order: '1',
          url: '//br.hubspot.com/make-my-persona',
          text: 'Make My Persona'
        },
        li2: {
          order: '2',
          url: '//br.hubspot.com/email-signature-generator',
          text: 'Criador de assinaturas de e-mail'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.com/blog-topic-generator',
          text: 'Gerador de ideias de blog'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.com/invoice-template-generator',
          text: 'Gerador de modelo de nota fiscal'
        },
        li5: {
          order: '5',
          url: '//www.hubspot.com/marketing-plan-template-generatorerator',
          text: 'Gerador de plano de marketing'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.com/business-templates',
          text: 'Ferramentas gratuitas de negócios'
        },
        li7: {
          order: '7',
          url: '//br.hubspot.com/covid-data',
          text: 'Dados de referência da COVID-19'
        }
      }
    },
    footerColumnContent2: {
      headerId: 'hsg-footer-column-2',
      headerText: 'Empresa',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//br.hubspot.com/our-story',
          text: 'Sobre nós'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.com/careers',
          text: 'Trabalhe conosco'
        },
        li2: {
          order: '2',
          url: '//br.hubspot.com/company/management',
          text: 'Equipe de gestão'
        },
        li3: {
          order: '3',
          url: '//br.hubspot.com/company/board-of-directors',
          text: 'Conselho administrativo'
        },
        li4: {
          order: '4',
          url: '//ir.hubspot.com/?_ga=2.262843276.12874469.1592422655-430007000.1592422655',
          text: 'Relações com investidores'
        },
        li5: {
          order: '5',
          url: '//br.hubspot.com/blog',
          text: 'Blog'
        },
        li6: {
          order: '6',
          url: '//br.hubspot.com/company/contact',
          text: 'Entre em contato conosco'
        }
      }
    },
    footerColumnContent3: {
      headerId: 'hsg-footer-column-3',
      headerText: 'Clientes',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//help.hubspot.com/pt/',
          text: 'Suporte ao cliente'
        },
        li1: {
          order: '1',
          url: '//academy.hubspot.com/hubspot-user-groups',
          text: 'Junte-se ao grupo de usuários local'
        }
      }
    },
    footerColumnContent4: {
      headerId: 'hsg-footer-column-4',
      headerText: 'Parceiros',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//br.hubspot.com/partners',
          text: 'Todos os programas de parceiros'
        },
        li1: {
          order: '1',
          url: '//br.hubspot.com/partners/solutions',
          text: 'Solutions Partner Program'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.com/partners/app',
          text: 'App Partner Program'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.com/startups/partners',
          text: 'HubSpot for Startups'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.com/partners/affiliates',
          text: 'Affiliate Program'
        }
      }
    }
  },
  socialContent: {
    li0: {
      url: '//www.facebook.com/HubSpotBR',
      text: 'Facebook',
      className: 'hstc_facebook'
    },
    li1: {
      url: '//www.instagram.com/hubspot',
      text: 'Instagram',
      className: 'hstc_instagram'
    },
    li2: {
      url: '//youtube.com/hubspotbrasil',
      text: 'Youtube',
      className: 'hstc_youtube'
    },
    li3: {
      url: '//twitter.com/hubspotbrasil',
      text: 'Twitter',
      className: 'hstc_twitter'
    },
    li4: {
      url: '//www.linkedin.com/company/hubspot',
      text: 'Linkedin',
      className: 'hstc_linkedin'
    },
    li05: {
      url: '//thinkgrowth.org',
      text: 'Medium',
      className: 'hstc_medium'
    },
    li06: {
      url: '//www.tiktok.com/@hubspot',
      text: 'TikTok',
      className: 'hstc_tiktok'
    }
  },
  footerBottomContent: {
    homeUrl: '//br.hubspot.com',
    copyright: "Copyright \xA9 " + new Date().getFullYear() + " HubSpot, Inc.",
    appButtons: {
      a0: {
        url: 'https://apps.apple.com/us/app/hubspot/id1107711722',
        img: 'https://www.hubspot.com/hubfs/app%20store%20high%20res.png',
        alt: 'App store',
        trackingclass: 'br-homepage-mobile-footer-apple'
      },
      a1: {
        url: 'https://play.google.com/store/apps/details?id=com.hubspot.android&hl=en_US',
        img: 'https://www.hubspot.com/hubfs/google%20play%20high%20res.png',
        alt: 'Google Play',
        trackingclass: 'br-homepage-mobile-footer-google'
      }
    },
    legalLinksContent: {
      a0: {
        url: '//legal.hubspot.com/br/legal-stuff',
        text: 'Assuntos jurídicos'
      },
      a1: {
        url: '//legal.hubspot.com/br/privacy-policy',
        text: 'Política de Privacidade'
      },
      a2: {
        url: '//legal.hubspot.com/br/security',
        text: 'Segurança'
      }
    }
  }
};

var FooterPT =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FooterPT, _React$Component);

  function FooterPT() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FooterPT.prototype;

  _proto.render = function render() {
    return React.createElement(FooterMain, {
      contentBlob: ptBlob$1
    });
  };

  return FooterPT;
}(React.Component);

var nlBlob = {
  backLabel: 'TERUG',
  footerNavContent: {
    footerColumnContent0: {
      headerId: 'hsg-footer-column-0',
      headerText: 'Populaire Functies',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.com/products/sales/schedule-meeting',
          text: 'Gratis Meetingplanner-app (Engels)'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.com/products/marketing/social-inbox',
          text: 'Tools voor sociale media (Engels)'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.com/products/sales/email-tracking',
          text: 'Software voor volgen van e-mails (Engels)'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.com/products/sales/sales-automation',
          text: 'Automatisering van verkoopmails (Engels)'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.com/products/marketing/ads',
          text: 'Advertentiesoftware (Engels)'
        },
        li5: {
          order: '5',
          url: '//www.hubspot.com/products/marketing/email',
          text: 'Software voor e-mailmarketing (Engels)'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.com/products/crm/lead-management',
          text: 'Software voor leadbeheer (Engels)'
        },
        li7: {
          order: '7',
          url: '//www.hubspot.com/products/crm/pipeline-management',
          text: 'Tools voor pijplijnbeheer (Engels)'
        },
        li8: {
          order: '8',
          url: '//www.hubspot.com/products/sales/email-templates-sales',
          text: 'Sales-e-mailtemplates (Engels)'
        },
        li9: {
          order: '9',
          url: '//www.hubspot.com/products/service/help-desk',
          text: 'Helpdesksoftware (Engels)'
        },
        li10: {
          order: '10',
          url: '//www.hubspot.com/products/marketing/forms',
          text: 'Gratis online formulierontwerper (Engels)'
        },
        li11: {
          order: '11',
          url: '//www.hubspot.com/products/crm/chatbot-builder',
          text: 'Gratis chatbotontwerper (Engels)'
        },
        li12: {
          order: '12',
          url: '//www.hubspot.com/products/crm/live-chat',
          text: 'Gratis software voor live chat (Engels)'
        },
        li13: {
          order: '13',
          url: '//www.hubspot.com/products/marketing/analytics',
          text: 'Marketinganalyse (Engels)'
        },
        li14: {
          order: '14',
          url: '//www.hubspot.com/products/marketing/landing-pages',
          text: 'Gratis landingspagina-builder (Engels)'
        }
      }
    },
    footerColumnContent1: {
      headerId: 'hsg-footer-column-1',
      headerText: 'Gratis tools',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//website.grader.com/?__hstc=20629287.e4e046660731447bf82affe18aa75831.1482962870986.1487962165415.1487964870240.141&__hssc=20629287.1.1487964870240&__hsfp=3218882972',
          text: 'Website Grader (Engels)'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.com/make-my-persona',
          text: 'Maak mijn persona (Engels)'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.com/email-signature-generator',
          text: 'Hulpmiddel voor e-mailhandtekening (Engels)'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.com/blog-topic-generator',
          text: 'Hulpmiddel voor blogideeën (Engels)'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.com/invoice-template-generator',
          text: 'Hulpmiddel voor factuurtemplates (Engels)'
        },
        li5: {
          order: '5',
          url: '//www.hubspot.com/marketing-plan-template-generator',
          text: 'Hulpmiddel voor marketingabonnementen (Engels)'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.com/business-templates',
          text: 'Gratis bedrijfssjabloon (Engels)'
        },
        li7: {
          order: '7',
          url: '//www.hubspot.com/industry-data',
          text: 'Benchmarkgegevens industrie (Engels)'
        },
        li8: {
          order: '8',
          url: '//www.hubspot.com/comparisons',
          text: 'Software vergelijken (Engels)'
        },
        li9: {
          order: '9',
          url: 'https://ecosystem.hubspot.com/marketplace/website',
          text: 'Website Thema\'s & Sjablonen (Engels)'
        }
      }
    },
    footerColumnContent2: {
      headerId: 'hsg-footer-column-2',
      headerText: 'Bedrijf',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.com/our-story',
          text: 'Over ons (Engels)'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.com/careers',
          text: 'Vacatures (Engels)'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.com/company/management',
          text: 'Managementteam (Engels)'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.com/company/board-of-directors',
          text: 'Raad van Bestuur (Engels)'
        },
        li4: {
          order: '4',
          url: '//ir.hubspot.com/?_ga=2.262843276.12874469.1592422655-430007000.1592422655',
          text: 'Investeerdersrelaties (Engels)'
        },
        li5: {
          order: '5',
          url: '//blog.hubspot.com',
          text: 'Blog (Engels)'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.com/company/contact',
          text: 'Contact met ons opnemen (Engels)'
        }
      }
    },
    footerColumnContent3: {
      headerId: 'hsg-footer-column-3',
      headerText: 'Klanten',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//help.hubspot.com/',
          text: 'Klantenondersteuning (Engels)'
        },
        li1: {
          order: '1',
          url: '//academy.hubspot.com/hubspot-user-groups',
          text: 'Lid worden van lokale gebruikersgroep (Engels)'
        }
      }
    },
    footerColumnContent4: {
      headerId: 'hsg-footer-column-4',
      headerText: 'Partners',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.com/partners',
          text: 'Alle partnerprogramma\'s (Engels)'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.com/partners/solutions',
          text: 'Solutions-partnerprogramma (Engels)'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.com/partners/app',
          text: 'App-partnerprogramma (Engels)'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.com/startups/partners',
          text: 'HubSpot voor start-ups (Engels)'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.com/partners/affiliates',
          text: 'Affiliate-programma (Engels)'
        }
      }
    }
  },
  socialContent: {
    li0: {
      url: '//www.facebook.com/hubspot',
      text: 'Facebook',
      className: 'hstc_facebook'
    },
    li1: {
      url: '//www.instagram.com/hubspot',
      text: 'Instagram',
      className: 'hstc_instagram'
    },
    li2: {
      url: '//youtube.com/user/HubSpot',
      text: 'Youtube',
      className: 'hstc_youtube'
    },
    li3: {
      url: '//twitter.com/HubSpot',
      text: 'Twitter',
      className: 'hstc_twitter'
    },
    li4: {
      url: '//www.linkedin.com/company/hubspot',
      text: 'Linkedin',
      className: 'hstc_linkedin'
    },
    li05: {
      url: '//thinkgrowth.org',
      text: 'Medium',
      className: 'hstc_medium'
    },
    li06: {
      url: '//www.tiktok.com/@hubspot',
      text: 'TikTok',
      className: 'hstc_tiktok'
    }
  },
  footerBottomContent: {
    homeUrl: '//www.hubspot.com',
    copyright: "Copyright \xA9 " + new Date().getFullYear() + " HubSpot, Inc.",
    appButtons: {
      a0: {
        url: 'https://apps.apple.com/us/app/hubspot/id1107711722',
        img: 'https://www.hubspot.com/hubfs/app%20store%20high%20res.png',
        alt: 'App store',
        trackingclass: 'homepage-mobile-footer-apple'
      },
      a1: {
        url: 'https://play.google.com/store/apps/details?id=com.hubspot.android&hl=en_US',
        img: 'https://www.hubspot.com/hubfs/google%20play%20high%20res.png',
        alt: 'Google Play',
        trackingclass: 'homepage-mobile-footer-google'
      }
    },
    legalLinksContent: {
      a0: {
        url: '//legal.hubspot.com/legal-stuff',
        text: 'Juridische informatie (Engels)'
      },
      a1: {
        url: '//legal.hubspot.com/privacy-policy',
        text: 'Privacybeleid (Engels)'
      },
      a2: {
        url: '//legal.hubspot.com/security',
        text: 'Beveiliging (Engels)'
      }
    }
  }
};

var FooterNL =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FooterNL, _React$Component);

  function FooterNL() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FooterNL.prototype;

  _proto.render = function render() {
    return React.createElement(FooterMain, {
      contentBlob: nlBlob
    });
  };

  return FooterNL;
}(React.Component);

var itBlob$1 = {
  backLabel: 'INDIETRO',
  footerNavContent: {
    footerColumnContent0: {
      headerId: 'hsg-footer-column-0',
      headerText: 'Funzionalità popolari',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.com/products/sales/schedule-meeting',
          text: 'App di pianificazione delle riunioni gratuita (Inglese)'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.com/products/marketing/social-inbox',
          text: 'Strumenti social media (Inglese)'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.com/products/sales/email-tracking',
          text: 'Software di registrazione e-mail (Inglese)'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.com/products/sales/sales-automation',
          text: 'Automazione delle e-mail per le vendite (Inglese)'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.com/products/marketing/ads',
          text: 'Software per gli annunci (Inglese)'
        },
        li5: {
          order: '5',
          url: '//www.hubspot.com/products/marketing/email',
          text: 'Software per l’e-mail marketing (Inglese)'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.com/products/crm/lead-management',
          text: 'Software per la gestione dei lead (Inglese)'
        },
        li7: {
          order: '7',
          url: '//www.hubspot.com/products/crm/pipeline-management',
          text: 'Strumenti di gestione delle pipeline (Inglese)'
        },
        li8: {
          order: '8',
          url: '//www.hubspot.com/products/sales/email-templates-sales',
          text: 'Modelli di e-mail per le vendite (Inglese)'
        },
        li9: {
          order: '9',
          url: '//www.hubspot.com/products/service/help-desk',
          text: 'Software per l’Help desk (Inglese)'
        },
        li10: {
          order: '10',
          url: '//www.hubspot.com/products/marketing/forms',
          text: 'Generatore di form online gratuito (Inglese)'
        },
        li11: {
          order: '11',
          url: '//www.hubspot.com/products/crm/chatbot-builder',
          text: 'Generatore di chatflow gratuito (Inglese)'
        },
        li12: {
          order: '12',
          url: '//www.hubspot.com/products/crm/live-chat',
          text: 'Software per le live chat gratuito (Inglese)'
        },
        li13: {
          order: '13',
          url: '//www.hubspot.com/products/marketing/analytics',
          text: 'Analisi dati marketing (Inglese)'
        },
        li14: {
          order: '14',
          url: '//www.hubspot.com/products/marketing/landing-pages',
          text: 'Generatore di landing page gratuito (Inglese)'
        }
      }
    },
    footerColumnContent1: {
      headerId: 'hsg-footer-column-1',
      headerText: 'Strumenti gratuiti',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//website.grader.com/?__hstc=20629287.e4e046660731447bf82affe18aa75831.1482962870986.1487962165415.1487964870240.141&__hssc=20629287.1.1487964870240&__hsfp=3218882972',
          text: 'Website Grader (Inglese)'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.com/make-my-persona',
          text: 'Make My Persona (Inglese)'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.com/email-signature-generator',
          text: 'Generatore di firme per le e-mail (Inglese)'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.com/blog-topic-generator',
          text: 'Generatore di idee per i blog (Inglese)'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.com/invoice-template-generator',
          text: 'Generatore modello fattura (Inglese)'
        },
        li5: {
          order: '5',
          url: '//www.hubspot.com/marketing-plan-template-generator',
          text: 'Generatore abbonamento di marketing (Inglese)'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.com/business-templates',
          text: 'Modelli aziendali gratuiti (Inglese)'
        },
        li7: {
          order: '7',
          url: '//www.hubspot.com/industry-data',
          text: 'Dati di riferimento del settore (Inglese)'
        },
        li8: {
          order: '8',
          url: '//www.hubspot.com/comparisons',
          text: 'Comparazione di software aziendali (Inglese)'
        },
        li9: {
          order: '9',
          url: 'https://ecosystem.hubspot.com/marketplace/website',
          text: 'Temi e modelli di siti web (Inglese)'
        }
      }
    },
    footerColumnContent2: {
      headerId: 'hsg-footer-column-2',
      headerText: 'Azienda',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.com/our-story',
          text: 'Informazioni (Inglese)'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.com/careers',
          text: 'Lavora con noi (Inglese)'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.com/company/management',
          text: 'Team di gestione (Inglese)'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.com/company/board-of-directors',
          text: 'Consiglio di Amministrazione (Inglese)'
        },
        li4: {
          order: '4',
          url: '//ir.hubspot.com/?_ga=2.262843276.12874469.1592422655-430007000.1592422655',
          text: 'Relazioni con gli investitori (Inglese)'
        },
        li5: {
          order: '5',
          url: '//blog.hubspot.com',
          text: 'Blog (Inglese)'
        },
        li6: {
          order: '6',
          url: '//www.hubspot.com/company/contact',
          text: 'Contattaci (Inglese)'
        }
      }
    },
    footerColumnContent3: {
      headerId: 'hsg-footer-column-3',
      headerText: 'Clienti',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//help.hubspot.com/',
          text: 'Assistenza clienti (Inglese)'
        },
        li1: {
          order: '1',
          url: '//academy.hubspot.com/hubspot-user-groups',
          text: 'Unisciti a un gruppo di utenti locale (Inglese)'
        }
      }
    },
    footerColumnContent4: {
      headerId: 'hsg-footer-column-4',
      headerText: 'Partner',
      listItemsContent: {
        li0: {
          order: '0',
          url: '//www.hubspot.com/partners',
          text: 'Tutti i programmi per i partner (Inglese)'
        },
        li1: {
          order: '1',
          url: '//www.hubspot.com/partners/solutions',
          text: 'Programma dei solutions partner (Inglese)'
        },
        li2: {
          order: '2',
          url: '//www.hubspot.com/partners/app',
          text: 'Programma partner per le app (Inglese)'
        },
        li3: {
          order: '3',
          url: '//www.hubspot.com/startups/partners',
          text: 'HubSpot per le startup (Inglese)'
        },
        li4: {
          order: '4',
          url: '//www.hubspot.com/partners/affiliates',
          text: 'Programma per gli affiliati (Inglese)'
        }
      }
    }
  },
  socialContent: {
    li0: {
      url: '//www.facebook.com/hubspot',
      text: 'Facebook',
      className: 'hstc_facebook'
    },
    li1: {
      url: '//www.instagram.com/hubspot',
      text: 'Instagram',
      className: 'hstc_instagram'
    },
    li2: {
      url: '//youtube.com/user/HubSpot',
      text: 'Youtube',
      className: 'hstc_youtube'
    },
    li3: {
      url: '//twitter.com/HubSpot',
      text: 'Twitter',
      className: 'hstc_twitter'
    },
    li4: {
      url: '//www.linkedin.com/company/hubspot',
      text: 'Linkedin',
      className: 'hstc_linkedin'
    },
    li05: {
      url: '//thinkgrowth.org',
      text: 'Medium',
      className: 'hstc_medium'
    },
    li06: {
      url: '//www.tiktok.com/@hubspot',
      text: 'TikTok',
      className: 'hstc_tiktok'
    }
  },
  footerBottomContent: {
    homeUrl: '//www.hubspot.com',
    copyright: "Copyright \xA9 " + new Date().getFullYear() + " HubSpot, Inc.",
    appButtons: {
      a0: {
        url: 'https://apps.apple.com/us/app/hubspot/id1107711722',
        img: 'https://www.hubspot.com/hubfs/app%20store%20high%20res.png',
        alt: 'App store',
        trackingclass: 'homepage-mobile-footer-apple'
      },
      a1: {
        url: 'https://play.google.com/store/apps/details?id=com.hubspot.android&hl=en_US',
        img: 'https://www.hubspot.com/hubfs/google%20play%20high%20res.png',
        alt: 'Google Play',
        trackingclass: 'homepage-mobile-footer-google'
      }
    },
    legalLinksContent: {
      a0: {
        url: '//legal.hubspot.com/legal-stuff',
        text: 'Affari legali (Inglese)'
      },
      a1: {
        url: '//legal.hubspot.com/privacy-policy',
        text: 'Privacy policy (Inglese)'
      },
      a2: {
        url: '//legal.hubspot.com/security',
        text: 'Sicurezza (Inglese)'
      }
    }
  }
};

var FooterIT =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FooterIT, _React$Component);

  function FooterIT() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FooterIT.prototype;

  _proto.render = function render() {
    return React.createElement(FooterMain, {
      contentBlob: itBlob$1
    });
  };

  return FooterIT;
}(React.Component);

var index = {
  Header: {
    en: HeaderEN,
    de: HeaderDE,
    es: HeaderES,
    fr: HeaderFR,
    jp: HeaderJP,
    pt: HeaderPT,
    it: HeaderIT,
    nl: HeaderNL
  },
  Footer: {
    en: FooterEN,
    de: FooterDE,
    es: FooterES,
    fr: FooterFR,
    jp: FooterJP,
    pt: FooterPT,
    it: FooterIT,
    nl: FooterNL
  }
};

module.exports = index;
